import {
  Box,
  Grid,
  Paper,
  Typography,
  Stack,
  Button,
  LinearProgress,
  Divider,
  Avatar,
  IconButton,
  TextField,
  Skeleton,
  CircularProgress,
  InputAdornment,
  Modal,
  Rating,
  Chip,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Zoom,
  Alert,
  Tooltip
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CloseIcon from '@mui/icons-material/Close';
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import MicNoneOutlinedIcon from "@mui/icons-material/MicNoneOutlined";
import StopIcon from "@mui/icons-material/Stop";
import OceshaLogo from "../../../assets/ocesha_images/ocesha_logo.png";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import SendIcon from "@mui/icons-material/Send";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import VerifiedIcon from "@mui/icons-material/Verified";
import SchoolIcon from "@mui/icons-material/School";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import { toast } from "react-toastify";
import axios from "axios";
import { useEffect, useRef, useState, useMemo, Fragment } from "react";
import { useGetUserDetailsMutation } from "../../../redux/api/authApi";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
/* import { TTSButton } from "../../../components/TTSPlayer";
import { speakText, stopTTS } from "../../../redux/features/ttsSlice";
import { useAppDispatch } from "../../../redux/store"; */
// import { useTTSQueue } from "hooks/useTTSQueue";
import { useTTSStream } from "hooks/useTTSStream";
import PersonIcon from "@mui/icons-material/Person";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { getCookie } from "utils/storageUtils";
import GBALogo from '../../../assets/traffic_monster/GBA_Logo.png';
import TextsmsOutlinedIcon from '@mui/icons-material/TextsmsOutlined';
import { isBrowser, isMobile } from "react-device-detect";
import MenuIcon from '@mui/icons-material/Menu';
import quizSuccessImg from '../../../assets/ocesha_images/quiz_success.png';
import QuizIcon from "@mui/icons-material/Quiz";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import defaultUserImage1 from '../../../assets/ocesha_images/default-user1.jpg';
import SubtitlesIcon from "@mui/icons-material/Subtitles";
import SubtitlesOffIcon from "@mui/icons-material/SubtitlesOff";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import CodeOutlinedIcon from "@mui/icons-material/CodeOutlined";
import VolumeUpOutlinedIcon from "@mui/icons-material/VolumeUpOutlined";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import PauseOutlinedIcon from '@mui/icons-material/PauseOutlined';
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined";
import ExtensionOutlinedIcon from "@mui/icons-material/ExtensionOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import ReplayIcon from "@mui/icons-material/Replay";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import QuizImg from '../../../assets/traffic_monster/quiz_img.png';
import OpenWithIcon from "@mui/icons-material/OpenWith";


type ChatMsg = {
  role: "user" | "bot";
  text: string;
};

type MentorReview = {
  name: string;
  avatar: string;
  role: string;
  rating: number;
  comment: string;
  date: string;
  verified: boolean;
};

type CourseReview = {
  name: string;
  avatar: string;
  rating: number;
  comment: string;
  date: string;
  helpful: number;
};


// ─── Avatar helpers ───────────────────────────────────────────────────────────
const AVATAR_COLORS = [
  "#2563eb",
  "#7c3aed",
  "#0891b2",
  "#059669",
  "#d97706",
  "#dc2626",
];

const avatarColor = (str: string) =>
  AVATAR_COLORS[
  str.split("").reduce((acc, c) => acc + c.charCodeAt(0), 0) %
  AVATAR_COLORS.length
  ];

const getInitials = (name: string) =>
  name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

// ─── Star Row helper ──────────────────────────────────────────────────────────
const StarRow = ({
  value,
  readOnly = false,
  onChange,
}: {
  value: number;
  readOnly?: boolean;
  onChange?: (v: number) => void;
}) => (
  <Stack direction="row" spacing={0.3}>
    {[1, 2, 3, 4, 5].map((s) => (
      <Box
        key={s}
        onClick={() => !readOnly && onChange && onChange(s)}
        sx={{ cursor: readOnly ? "default" : "pointer", lineHeight: 1 }}
      >
        {s <= value ? (
          <StarIcon sx={{ color: "#FBBF24", fontSize: 18 }} />
        ) : (
          <StarBorderIcon sx={{ color: "#6B7280", fontSize: 18 }} />
        )}
      </Box>
    ))}
  </Stack>
);

// ─── Pulse loader (unchanged) ─────────────────────────────────────────────────
const VoicePulseLoader = () => (
  <Box sx={{ display: "flex", alignItems: "center", gap: "4px", height: 18 }}>
    {[0, 1, 2].map((i) => (
      <Box
        key={i}
        sx={{
          width: 4,
          height: 16,
          borderRadius: "2px",
          backgroundColor: "#fff",
          animation: "voicePulse 1s ease-in-out infinite",
          animationDelay: `${i * 0.15}s`,
          "@keyframes voicePulse": {
            "0%, 100%": { transform: "scaleY(0.4)", opacity: 0.5 },
            "50%": { transform: "scaleY(1)", opacity: 1 },
          },
        }}
      />
    ))}
  </Box>
);

// ─── Mentor Review Card ───────────────────────────────────────────────────────
const MentorReviewCard = ({ review }: { review: MentorReview }) => (
  <Box
    sx={{
      position: "relative",
      p: 2.5,
      borderRadius: "14px",
      background: "linear-gradient(135deg, #1a1c27 0%, #1f2133 100%)",
      border: "1px solid #2D3050",
      overflow: "hidden",
      transition: "border-color 0.2s",
      "&:hover": { borderColor: "#2563eb55" },
    }}
  >
    <FormatQuoteIcon
      sx={{
        position: "absolute",
        top: 10,
        right: 12,
        fontSize: 42,
        color: "#2563eb18",
      }}
    />
    <Stack direction="row" spacing={1.5} alignItems="center" mb={1.5}>
      <Avatar
        sx={{
          bgcolor: avatarColor(review.name),
          width: 44,
          height: 44,
          fontWeight: 700,
          fontSize: 14,
        }}
      >
        {review.avatar}
      </Avatar>
      <Box flex={1}>
        <Stack direction="row" alignItems="center" spacing={0.6}>
          <Typography color="#fff" fontSize="14px" fontWeight={600}>
            {review.name}
          </Typography>
          {review.verified && (
            <VerifiedIcon sx={{ color: "#2563eb", fontSize: 15 }} />
          )}
        </Stack>
        <Typography color="#6B7280" fontSize="12px">
          {review.role}
        </Typography>
      </Box>
      <Chip
        label="Mentor"
        size="small"
        sx={{
          bgcolor: "#1e3a5f",
          color: "#60A5FA",
          fontSize: "10px",
          height: 20,
          borderRadius: "4px",
        }}
      />
    </Stack>
    <StarRow value={review.rating} readOnly />
    <Typography
      color="#C9D1E0"
      fontSize="13px"
      lineHeight={1.7}
      mt={1.2}
      sx={{ fontStyle: "italic" }}
    >
      "{review.comment}"
    </Typography>
    <Typography color="#4B5563" fontSize="11px" mt={1.5}>
      {review.date}
    </Typography>
  </Box>
);

// ─── Course Review Card ───────────────────────────────────────────────────────
const CourseReviewCard = ({ review }: { review: CourseReview }) => {
  const [liked, setLiked] = useState(false);
  return (
    <Box
      sx={{
        p: 2.5,
        borderRadius: "14px",
        background: "#16181f",
        border: "1px solid #252535",
        transition: "border-color 0.2s",
        "&:hover": { borderColor: "#2563eb44" },
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center" mb={1.2}>
        <Avatar
          sx={{
            bgcolor: avatarColor(review.name),
            width: 38,
            height: 38,
            fontSize: 13,
            fontWeight: 700,
          }}
        >
          {review.avatar}
        </Avatar>
        <Box flex={1}>
          <Typography color="#fff" fontSize="13px" fontWeight={600}>
            {review.name}
          </Typography>
          <Typography color="#4B5563" fontSize="11px">
            {review.date}
          </Typography>
        </Box>
        <StarRow value={review.rating} readOnly />
      </Stack>
      <Typography color="#B0B8CC" fontSize="13px" lineHeight={1.7}>
        {review.comment}
      </Typography>
      <Stack direction="row" alignItems="center" spacing={1} mt={1.5}>
        <Button
          size="small"
          onClick={() => setLiked((p) => !p)}
          sx={{
            textTransform: "none",
            color: liked ? "#2563eb" : "#6B7280",
            fontSize: "11px",
            minWidth: 0,
            p: 0,
            "&:hover": { background: "transparent", color: "#60A5FA" },
          }}
        >
          Helpful ({liked ? review.helpful + 1 : review.helpful})
        </Button>
      </Stack>
    </Box>
  );
};

// ─── Rating Summary Bar ───────────────────────────────────────────────────────
const RatingSummary = ({ reviews }: { reviews: CourseReview[] }) => {
  const avg = reviews.reduce((s, r) => s + r.rating, 0) / (reviews.length || 1);
  const counts = [5, 4, 3, 2, 1].map((star) => ({
    star,
    count: reviews.filter((r) => r.rating === star).length,
  }));
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={3}
      alignItems="center"
      sx={{
        p: 2.5,
        borderRadius: "14px",
        background: "#0e1018",
        border: "1px solid #1e2030",
        mb: 2,
      }}
    >
      <Box textAlign="center" minWidth={80}>
        <Typography
          sx={{
            fontSize: "52px",
            fontWeight: 800,
            color: "#FBBF24",
            lineHeight: 1,
          }}
        >
          {avg.toFixed(1)}
        </Typography>
        <StarRow value={Math.round(avg)} readOnly />
        <Typography color="#6B7280" fontSize="11px" mt={0.5}>
          {reviews.length} review{reviews.length !== 1 ? "s" : ""}
        </Typography>
      </Box>
      <Stack flex={1} spacing={0.6} width="100%">
        {counts.map(({ star, count }) => (
          <Stack key={star} direction="row" alignItems="center" spacing={1}>
            <Typography color="#9CA3AF" fontSize="11px" minWidth={8}>
              {star}
            </Typography>
            <StarIcon sx={{ color: "#FBBF24", fontSize: 12 }} />
            <LinearProgress
              variant="determinate"
              value={reviews.length ? (count / reviews.length) * 100 : 0}
              sx={{
                flex: 1,
                height: 6,
                borderRadius: 3,
                backgroundColor: "#1e2030",
                "& .MuiLinearProgress-bar": { backgroundColor: "#FBBF24" },
              }}
            />
            <Typography color="#4B5563" fontSize="11px" minWidth={14}>
              {count}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

// ─── Shared star picker ───────────────────────────────────────────────────────
const StarPicker = ({
  rating,
  hoverRating,
  setRating,
  setHoverRating,
}: {
  rating: number;
  hoverRating: number;
  setRating: (v: number) => void;
  setHoverRating: (v: number) => void;
}) => {
  const LABELS: Record<number, string> = {
    1: "Poor",
    2: "Fair",
    3: "Good",
    4: "Great",
    5: "Excellent",
  };
  return (
    <Box mb={2}>
      <Typography color="#9CA3AF" fontSize="12px" mb={0.8}>
        Overall Rating
      </Typography>
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Stack direction="row" spacing={0.4}>
          {[1, 2, 3, 4, 5].map((s) => (
            <Box
              key={s}
              onMouseEnter={() => setHoverRating(s)}
              onMouseLeave={() => setHoverRating(0)}
              onClick={() => setRating(s)}
              sx={{
                cursor: "pointer",
                transition: "transform 0.1s",
                "&:hover": { transform: "scale(1.2)" },
              }}
            >
              {s <= (hoverRating || rating) ? (
                <StarIcon sx={{ color: "#FBBF24", fontSize: 26 }} />
              ) : (
                <StarBorderIcon sx={{ color: "#374151", fontSize: 26 }} />
              )}
            </Box>
          ))}
        </Stack>
        {(hoverRating || rating) > 0 && (
          <Typography
            color="#FBBF24"
            fontSize="13px"
            fontWeight={600}
            sx={{ minWidth: 60 }}
          >
            {LABELS[hoverRating || rating]}
          </Typography>
        )}
      </Stack>
    </Box>
  );
};

// ─── Shared success state ─────────────────────────────────────────────────────
const SubmittedState = () => (
  <Box
    sx={{
      textAlign: "center",
      py: 4,
      px: 2,
      borderRadius: "14px",
      background: "linear-gradient(135deg, #0d1f3c 0%, #0d2236 100%)",
      border: "1px solid #1e3a5f",
    }}
  >
    <Typography color="#60A5FA" fontWeight={700} fontSize="16px">
      Thank you for your review!
    </Typography>
    <Typography color="#6B7280" fontSize="13px" mt={0.5}>
      Your feedback helps others make better decisions.
    </Typography>
  </Box>
);

const userRole = localStorage.getItem("userRole");

const CourseReviewForm = ({
  courseId,
  apiUrl,
  studentId,
  onReviewSubmitted,
}: {
  courseId: string;
  apiUrl: string;
  studentId: string;
  onReviewSubmitted?: (review: CourseReview) => void;
}) => {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);


  const handleSubmit = async () => {
    if (!rating) return toast.error("Please select a rating.");
    if (!comment.trim()) return toast.error("Please write a review.");
    if (!studentId) return toast.error("User not found. Please log in again.");

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/student/reviews/course`, null, {
        params: {
          student_id: studentId,
          course_id: courseId,
          rating: rating,
          comment: comment.trim(),
        },
      });

      if (onReviewSubmitted) {
        const userName = localStorage.getItem("user_name") || "You";
        onReviewSubmitted({
          name: userName,
          avatar: getInitials(userName),
          rating,
          comment: comment.trim(),
          date: new Date().toLocaleDateString("en-US", {
            month: "long",
            year: "numeric",
          }),
          helpful: 0,
        });
      }

      toast.success("Course review submitted! Thank you ");
    } catch (err: any) {
      console.error("Course review submit error:", err);
      toast.error(
        err?.response?.data?.detail ||
        "Failed to submit review. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        p: 3,
        borderRadius: "16px",
        background: "linear-gradient(135deg, #12141e 0%, #181a28 100%)",
        border: "1px solid #252538",
      }}
    >
      <Typography color="#fff" fontSize="15px" fontWeight={700} mb={2}>
        Share your course experience
      </Typography>

      <StarPicker
        rating={rating}
        hoverRating={hoverRating}
        setRating={setRating}
        setHoverRating={setHoverRating}
      />

      <TextField
        multiline
        rows={3}
        fullWidth
        placeholder="What did you like or dislike? What would you improve?"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        inputProps={{ maxLength: 500 }}
        sx={{
          mb: 1,
          "& .MuiOutlinedInput-root": {
            color: "#D9D9D9",
            fontSize: "13px",
            borderRadius: "10px",
            background: "#0e1018",
            "& fieldset": { borderColor: "#2D2D45" },
            "&:hover fieldset": { borderColor: "#2563eb" },
            "&.Mui-focused fieldset": { borderColor: "#2563eb" },
          },
          "& .MuiInputBase-input::placeholder": { color: "#4B5563" },
        }}
      />

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography color="#4B5563" fontSize="11px">
          {comment.length}/500
        </Typography>
      </Stack>

      <Button
        fullWidth
        variant="contained"
        disabled={loading || !rating || !comment.trim()}
        onClick={handleSubmit}
        sx={{
          textTransform: "none",
          borderRadius: "10px",
          py: 1.2,
          fontSize: "14px",
          fontWeight: 600,
          background: "linear-gradient(90deg, #2563eb, #1d9bf0)",
          "&:disabled": { opacity: 0.4 },
          "&:hover": { background: "linear-gradient(90deg, #1d4ed8, #0284c7)" },
        }}
      >
        {loading ? (
          <CircularProgress size={18} sx={{ color: "#fff" }} />
        ) : (
          "Submit Course Review"
        )}
      </Button>
    </Box>
  );
};

// ═══════════════════════════════════════════════════════════════════════════════
// MENTOR REVIEW FORM
// API: POST /api/student/reviews/mentor
// Query params: student_id, mentor_id, rating (integer), comment
// ═══════════════════════════════════════════════════════════════════════════════
const MentorReviewForm = ({
  mentorId,
  mentorName,
  apiUrl,
  studentId,
  onReviewSubmitted,
}: {
  mentorId: string;
  mentorName: string;
  apiUrl: string;
  studentId: string;
  onReviewSubmitted?: (review: MentorReview) => void;
}) => {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!rating) return toast.error("Please select a rating.");
    if (!comment.trim()) return toast.error("Please write a review.");
    if (!studentId) return toast.error("User not found. Please log in again.");
    if (!mentorId) return toast.error("Mentor information not found.");

    try {
      setLoading(true);

      // POST /api/student/reviews/mentor
      // All fields sent as query params as per API spec
      await axios.post(`${apiUrl}/api/student/reviews/mentor`, null, {
        params: {
          student_id: studentId,
          mentor_id: mentorId,
          rating: rating,
          comment: comment.trim(),
        },
      });

      // Optimistically prepend the new review to the list
      if (onReviewSubmitted) {
        const userName = localStorage.getItem("user_name") || "You";
        onReviewSubmitted({
          name: userName,
          avatar: getInitials(userName),
          role: "Student",
          rating,
          comment: comment.trim(),
          date: new Date().toLocaleDateString("en-US", {
            month: "long",
            year: "numeric",
          }),
          verified: false,
        });
      }

      toast.success("Mentor review submitted! Thank you ");
      setRating(0);
      setComment("");
      setHoverRating(0);
    } catch (err: any) {
      console.error("Mentor review submit error:", err);
      toast.error(
        err?.response?.data?.detail ||
        "Failed to submit review. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        p: 3,
        borderRadius: "16px",
        background: "linear-gradient(135deg, #0d1a2d 0%, #101828 100%)",
        border: "1px solid #1e3a5f",
        mt: 3,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} mb={2}>
        <VerifiedIcon sx={{ color: "#2563eb", fontSize: 18 }} />
        <Typography color="#fff" fontSize="15px" fontWeight={700}>
          Review {mentorName || "your Mentor"}
        </Typography>
      </Stack>

      <StarPicker
        rating={rating}
        hoverRating={hoverRating}
        setRating={setRating}
        setHoverRating={setHoverRating}
      />

      <TextField
        multiline
        rows={3}
        fullWidth
        placeholder="How was your mentorship experience? Was the mentor helpful and responsive?"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        inputProps={{ maxLength: 500 }}
        sx={{
          mb: 1,
          "& .MuiOutlinedInput-root": {
            color: "#D9D9D9",
            fontSize: "13px",
            borderRadius: "10px",
            background: "#0a0f1a",
            "& fieldset": { borderColor: "#1e3a5f" },
            "&:hover fieldset": { borderColor: "#2563eb" },
            "&.Mui-focused fieldset": { borderColor: "#2563eb" },
          },
          "& .MuiInputBase-input::placeholder": { color: "#4B5563" },
        }}
      />

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography color="#4B5563" fontSize="11px">
          {comment.length}/500
        </Typography>
      </Stack>

      <Button
        fullWidth
        variant="contained"
        disabled={loading || !rating || !comment.trim()}
        onClick={handleSubmit}
        sx={{
          textTransform: "none",
          borderRadius: "10px",
          py: 1.2,
          fontSize: "14px",
          fontWeight: 600,
          background: "linear-gradient(90deg, #1e40af, #2563eb)",
          "&:disabled": { opacity: 0.4 },
          "&:hover": { background: "linear-gradient(90deg, #1e3a8a, #1d4ed8)" },
        }}
      >
        {loading ? (
          <CircularProgress size={18} sx={{ color: "#fff" }} />
        ) : (
          "Submit Mentor Review"
        )}
      </Button>
    </Box>
  );
};

const createCourseSlug = (
  title: string,
  id: string
) => {
  const slug = title
    ?.toLowerCase()
    ?.trim()
    ?.replace(/[^a-z0-9\s-]/g, "")
    ?.replace(/\s+/g, "-");

  return `${slug}-${id}`;
};

// ═══════════════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════════════
export default function CourseDetailScreen() {
  const navigate = useNavigate();
  // const dispatch = useAppDispatch();
  const supportUserid = process.env.REACT_APP_SUPPORT_USER_ID || "";
  const loggedIn = localStorage.getItem("logged_in");
  const isNewTab = window.history.length <= 1;
  const location = useLocation();
  const { courseSlug } = useParams();
  const courseIdFromUrl = courseSlug?.split("-").pop();
  const courseId = location.state?.courseId || courseIdFromUrl || null;
  const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";
  const hasFetched = useRef(false);
  const [curriculum, setCurriculum] = useState<any[]>([]);
  const [activeWeekIndex, setActiveWeekIndex] = useState(0);
  const [selectedWeekData, setSelectedWeekData] = useState<any>(null);
  // Selected lesson from the module subtopics list.
  const [selectedSubtopic, setSelectedSubtopic] = useState<any>(null);
  const [showCourseDefinition, setShowCourseDefinition] = useState(false);
  const [introVideoOpen, setIntroVideoOpen] = useState(false);
  const [pendingStartAfterVideo, setPendingStartAfterVideo] = useState(false);
  // const [courseImage, setCourseImage] = useState<any>();
  const [loadingCourse, setLoadingCourse] = useState(false);
  const [completeCourseDet, setCompleteCourseDet] = useState<any>();
  const userEmail = localStorage.getItem("user_email");
  const isOwnCourse = completeCourseDet?.user_email === userEmail;
  const courseVoiceName = completeCourseDet?.user?.digitial_twin_voice || "default";
  const [openChatBot, setOpenChatBot] = useState(false);
  const [isChatBotLoading, setIsChatBotLoading] = useState(false);
  const [prompt, setPrompt] = useState<any>();
  const [chatMessages, setChatMessages] = useState<ChatMsg[]>([]);
  const chatContainerRef = useRef<HTMLDivElement | null>(null);
  const courseContentRef = useRef<HTMLDivElement | null>(null);
  const lastUserMsgRef = useRef<HTMLDivElement | null>(null);
  const audioChunksRef = useRef<Blob[]>([]);
  const [audioURL, setAudioURL] = useState<string | null>(null);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const [isRecording, setIsRecording] = useState(false);
  // const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isTranscribing, setIsTranscribing] = useState(false);
  // const [isMuted, setIsMuted] = useState(false);
  const [loginPopup, setLoginPopup] = useState(false);
  const [isEnrolled, setIsEnrolled] = useState(false);
  const [loadingEnrollment, setLoadingEnrollment] = useState(true);
  const [enrollPopup, setEnrollPopup] = useState(false);
  const [loadingCheckout, setLoadingCheckout] = useState(false);
  const studentEmail = localStorage.getItem("user_email");
  const [lastBotText, setLastBotText] = useState<string>("");
  const prevTextRef = useRef("");
  const [hasStartedCourse, setHasStartedCourse] = useState(false);
  const [expandedWeeks, setExpandedWeeks] = useState<number[]>([]);
  const [enrollmentId, setEnrollmentId] = useState<string | null>(null);
  const chatRequestIdRef = useRef(0);
  const initialFlowDecidedRef = useRef(false);

  const activeModuleAudioTypeRef = useRef<"curriculum" | "tts" | null>(null);

  const [overallCompletionPercentage, setOverallCompletionPercentage] =
    useState(0);

  const [weekProgress, setWeekProgress] = useState<
    Record<number, number>
  >({});

  const allWeeksComplete =
    curriculum.length > 0 &&
    curriculum.every((w) => (weekProgress[Number(w.week)] ?? 0) >= 100);

  const isCourseCompleted = overallCompletionPercentage >= 100 || allWeeksComplete;

  const playedProgressChunksRef = useRef<Set<string>>(new Set());

  const weekProgressRef = useRef<Record<number, number>>({});

  // NEW — prevent double-counting if an effect re-fires
  const moduleSummaryProgressAddedRef = useRef<Set<number>>(new Set());
  const quizProgressAddedRef = useRef<Set<number>>(new Set());
  const lessonProgressAddedRef = useRef<Set<string>>(new Set());

  const [quizOpen, setQuizOpen] = useState(false);
  const [currentQuizIndex, setCurrentQuizIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState<string | null>(null);
  const [correctCount, setCorrectCount] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [isLessonQuiz, setIsLessonQuiz] = useState(false);
  const [answeredQuestions, setAnsweredQuestions] = useState<Set<number>>(new Set());
  const [quizAnswers, setQuizAnswers] = useState<
    Record<number, {
      selected_answer: string;
      is_correct: boolean;
    }>>({});

  const [quizProgressPercentage, setQuizProgressPercentage] = useState(0);
  const [isQuizLoading, setIsQuizLoading] = useState(false);
  const [isQuizSaving, setIsQuizSaving] = useState(false);
  const [isQuizCompleted, setIsQuizCompleted] = useState(false);

  const curriculumAudioRef = useRef<HTMLAudioElement | null>(null);

  const isChatbotRequestRef = useRef(false);

  const progressFetchSeqRef = useRef(0);

  const [showResumeConfirm, setShowResumeConfirm] = useState(false);


  useEffect(() => {
    if (!completeCourseDet) return;              // wait until we actually know if a video exists
    if (initialFlowDecidedRef.current) return;    // never re-decide this later
    initialFlowDecidedRef.current = true;

    stopAllAudio();   // clean slate — nothing should be sounding at this point

    if (introVideoUrl) {
      // Only the video should be visible. Course definition audio
      // must not start until the video is explicitly closed.
      setShowCourseDefinition(false);
      setPendingStartAfterVideo(true);
      setIntroVideoOpen(true);
    } else {
      // No video — go straight into course definition audio automatically.
      setHasStartedCourse(true);
      setShowCourseDefinition(true);
    }
  }, [completeCourseDet]);

  /* const resumeAfterChatRef = useRef<{
    shouldResume: boolean;
    weekIndex: number;
    audioType: "curriculum" | "tts" | null;
    currentTime: number;
  }>({
    shouldResume: false,
    weekIndex: 0,
    audioType: null,
    currentTime: 0,
  }); */
  const resumeAfterChatRef = useRef<{
    shouldResume: boolean;
    weekIndex: number;
    speechType: "course" | "lesson" | "overview" | null;
    audioType: "curriculum" | "tts" | null;
    currentTime: number;
    lessonKey: string | null;
    lessonChunkIndex: number;
  }>({
    shouldResume: false,
    weekIndex: 0,
    speechType: null,
    audioType: null,
    currentTime: 0,
    lessonKey: null,
    lessonChunkIndex: 0,
  });

  const [isCurriculumAudioPlaying, setIsCurriculumAudioPlaying] =
    useState(false);

  // ── Review state ──────────────────────────────────────────────────────────
  // Lists start empty and grow when:
  //   a) you wire up GET fetch endpoints, or
  //   b) a user submits via the form (optimistic insert)
  const [courseReviews, setCourseReviews] = useState<CourseReview[]>([]);
  const [mentorReviews, setMentorReviews] = useState<MentorReview[]>([]);
  const [reviewTab, setReviewTab] = useState<"mentor" | "student">("student");
  const [reviewPopupOpen, setReviewPopupOpen] = useState(false);
  const [moduleCompletePopup, setModuleCompletePopup] = useState(false);
  const [completedModuleInfo, setCompletedModuleInfo] = useState<{ index: number; title: string } | null>(null);
  const shownCompletionRef = useRef<Set<number>>(new Set());
  const prevWeekProgressRef = useRef<Record<number, number>>({});

  // student_id used by both review APIs — falls back to email if user_id is absent
  const [studentId, setStudentId] = useState<string>(
    localStorage.getItem("student_id") || ""
  );
  const mentorId = localStorage.getItem("mentor_id") || "";
  const mentorName: string =
    completeCourseDet?.mentor_name ||
    completeCourseDet?.instructor_name ||
    "your Mentor";

  /* useEffect(() => {
    if (lastUserMsgRef.current) {
      lastUserMsgRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [chatMessages]); */

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [chatMessages]);

  const [getUserDetails] = useGetUserDetailsMutation();
  const [userDets, setUserDets] = useState<any>();
  const [userImage, setUserImage] = useState("");
  const [mentorDetails, setMentorDetails] = useState<any>();
  const user_email = localStorage.getItem("user_email") || "";
  const [openCoursePopup, setOpenCoursePopup] = useState(false);
  const [GBAUserLogo, setGBAUserLogo] = useState<any>();
  const [isCourseContentsOpen, setIsCourseContentsOpen] = useState(true);
  const [isConversationOpen, setIsConversationOpen] = useState(true);
  const [imageZoomOpen, setImageZoomOpen] = useState(false);
  /* const [examplePreviewOpen, setExamplePreviewOpen] = useState(false);
  const [selectedExample, setSelectedExample] = useState<string>("");
  const [selectedExampleTitle, setSelectedExampleTitle] =
    useState<string>("Example"); */
  const [examplePreviewOpen, setExamplePreviewOpen] = useState(false);
  const [selectedModuleTitle, setSelectedModuleTitle] = useState<string>("");
  const [selectedExamples, setSelectedExamples] = useState<
    { title: string; content: string }[]
  >([]);

  const {
    playText,
    prefetchText,
    pause,
    resume,
    stop,
    stopAll,
    seek,
    isPlaying,
    isProcessingAudio,
    currentIndex,
    audioRef,
    isMuted,
    setIsMuted,
  } = useTTSStream(courseVoiceName);/* useTTSQueue(); */

  const currentSpeechTypeRef = useRef<
    "course" | "chatbot" | "lesson" | "quiz" | "overview" | null
  >(null);
  const speechRequestIdRef = useRef(0);
  const initialCoursePlayedRef = useRef(false);
  const [captionText, setCaptionText] = useState<string>("");
  const [captionsEnabled, setCaptionsEnabled] = useState<boolean>(true);

  // NEW — draggable caption position. null = default centered position.
  const [captionPos, setCaptionPos] = useState<{ x: number; y: number } | null>(null);
  const isDraggingCaptionRef = useRef(false);
  const captionDragParentRef = useRef<HTMLElement | null>(null);
  const captionDragOffsetRef = useRef({ x: 0, y: 0 });

  const [downloadingCertificate, setDownloadingCertificate] = useState(false);

  const PROCESSING_MESSAGES = [
    "Synthesizing voice…",
    "Warming up the neural voice…",
    "Generating speech…",
    "Composing audio waveform…",
    "AI is narrating…",
    "Rendering natural speech…",
    "Bringing text to life…",
    "Tuning vocal inflections…",
  ];

  const [processingMessage, setProcessingMessage] = useState(PROCESSING_MESSAGES[0]);


  // Only show the "Synthesizing voice…" messages if audio hasn't started
  // within this delay. If the first chunk comes back and plays quickly,
  // the user never sees them.
  const PROCESSING_MESSAGE_DELAY_MS = 5000;
  const [showProcessingMessage, setShowProcessingMessage] = useState(false);

  useEffect(() => {
    if (!isProcessingAudio) {
      // Audio started (or the request ended) — hide immediately.
      setShowProcessingMessage(false);
      return;
    }

    let interval: ReturnType<typeof setInterval> | undefined;

    const delayTimer = setTimeout(() => {
      // Still waiting after 5 seconds — start showing rotating messages.
      setProcessingMessage(
        PROCESSING_MESSAGES[Math.floor(Math.random() * PROCESSING_MESSAGES.length)]
      );
      setShowProcessingMessage(true);

      interval = setInterval(() => {
        setProcessingMessage(
          PROCESSING_MESSAGES[Math.floor(Math.random() * PROCESSING_MESSAGES.length)]
        );
      }, 1400); // rotate every 1.4s while waiting
    }, PROCESSING_MESSAGE_DELAY_MS);

    return () => {
      clearTimeout(delayTimer);
      if (interval) clearInterval(interval);
    };
  }, [isProcessingAudio]);


  // ── Duration estimation (backend "X Weeks" data is unreliable) ──────────────
  const WORDS_PER_MINUTE = 140; // avg narration/reading pace — tune to match your voiceover speed

  const stripHtml = (html: string) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    return (tempDiv.textContent || tempDiv.innerText || "")
      .replace(/\s+/g, " ")
      .trim();
  };

  const countWords = (text: string) => {
    const clean = stripHtml(text || "").trim();
    return clean ? clean.split(/\s+/).length : 0;
  };

  const estimateWeekMinutes = (week: any) => {
    const words =
      countWords(week?.title) +
      countWords(week?.description) +
      countWords(week?.module_summary || week?.content);

    return Math.max(1, Math.ceil(words / WORDS_PER_MINUTE)) * 2;
  };

  const formatMinutes = (totalMinutes: number) => {
    if (!totalMinutes) return "";
    if (totalMinutes < 60) return `${totalMinutes} min`;
    const hrs = Math.floor(totalMinutes / 60);
    const mins = totalMinutes % 60;
    return mins > 0 ? `${hrs} hr ${mins} min` : `${hrs} hr`;
  };

  // Parses backend duration strings like "1 hr 10 min", "45 min", "2 hr",
  // "1.5 hr" into total minutes. Returns 0 if it can't parse anything.
  const parseDurationToMinutes = (raw?: string): number => {
    if (!raw || typeof raw !== "string") return 0;

    const str = raw.toLowerCase();
    let totalMinutes = 0;

    const hrMatch = str.match(/(\d+(?:\.\d+)?)\s*(?:hr|hour)/);
    const minMatch = str.match(/(\d+(?:\.\d+)?)\s*min/);

    if (hrMatch) totalMinutes += parseFloat(hrMatch[1]) * 60;
    if (minMatch) totalMinutes += parseFloat(minMatch[1]);

    return totalMinutes;
  };

  // Sum of each week's own `duration` field (e.g. "1 hr 10 min") —
  // this is the authoritative per-module time from the backend.
  // Falls back to the word-count estimate only for weeks missing a duration.
  const computedCourseDurationMinutes = useMemo(
    () =>
      curriculum.reduce((sum, week) => {
        const parsed = parseDurationToMinutes(week?.duration);
        return sum + (parsed > 0 ? parsed : estimateWeekMinutes(week));
      }, 0),
    [curriculum]
  );

  // Total course duration — always derived from curriculum week durations,
  // never from completeCourseDet.duration (that field is "X Weeks", the
  // course length, not actual content time).
  const displayDuration = useMemo(() => {
    return formatMinutes(computedCourseDurationMinutes);
  }, [computedCourseDurationMinutes]);

  // Per-module duration — reflects whichever module is currently active,
  // read directly from that week's own `duration` field.
  const displayModuleDuration = useMemo(() => {
    const week = selectedWeekData || curriculum[activeWeekIndex];
    const parsed = parseDurationToMinutes(week?.duration);

    return parsed > 0 ? formatMinutes(parsed) : formatMinutes(estimateWeekMinutes(week));
  }, [selectedWeekData, activeWeekIndex, curriculum]);


  // ─────────────────────────────────────────────
  // DRAGGABLE CAPTION — mouse
  // ─────────────────────────────────────────────
  const handleCaptionMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();

    const captionEl = e.currentTarget;
    const parent = captionEl.offsetParent as HTMLElement | null;
    if (!parent) return;

    captionDragParentRef.current = parent;
    isDraggingCaptionRef.current = true;

    const captionRect = captionEl.getBoundingClientRect();
    captionDragOffsetRef.current = {
      x: e.clientX - captionRect.left,
      y: e.clientY - captionRect.top,
    };

    document.addEventListener("mousemove", handleCaptionMouseMove);
    document.addEventListener("mouseup", handleCaptionMouseUp);
  };

  const handleCaptionMouseMove = (e: MouseEvent) => {
    if (!isDraggingCaptionRef.current || !captionDragParentRef.current) return;

    const parentRect = captionDragParentRef.current.getBoundingClientRect();

    let newX = e.clientX - parentRect.left - captionDragOffsetRef.current.x;
    let newY = e.clientY - parentRect.top - captionDragOffsetRef.current.y;

    // Keep it roughly within the image container
    newX = Math.max(0, Math.min(newX, parentRect.width - 60));
    newY = Math.max(0, Math.min(newY, parentRect.height - 30));

    setCaptionPos({ x: newX, y: newY });
  };

  const handleCaptionMouseUp = () => {
    isDraggingCaptionRef.current = false;
    document.removeEventListener("mousemove", handleCaptionMouseMove);
    document.removeEventListener("mouseup", handleCaptionMouseUp);
  };

  // ─────────────────────────────────────────────
  // DRAGGABLE CAPTION — touch (mobile)
  // ─────────────────────────────────────────────
  const handleCaptionTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    const touch = e.touches[0];
    const captionEl = e.currentTarget;
    const parent = captionEl.offsetParent as HTMLElement | null;
    if (!parent) return;

    captionDragParentRef.current = parent;
    isDraggingCaptionRef.current = true;

    const captionRect = captionEl.getBoundingClientRect();
    captionDragOffsetRef.current = {
      x: touch.clientX - captionRect.left,
      y: touch.clientY - captionRect.top,
    };

    document.addEventListener("touchmove", handleCaptionTouchMove, { passive: false });
    document.addEventListener("touchend", handleCaptionTouchEnd);
  };

  const handleCaptionTouchMove = (e: TouchEvent) => {
    if (!isDraggingCaptionRef.current || !captionDragParentRef.current) return;
    e.preventDefault();

    const touch = e.touches[0];
    const parentRect = captionDragParentRef.current.getBoundingClientRect();

    let newX = touch.clientX - parentRect.left - captionDragOffsetRef.current.x;
    let newY = touch.clientY - parentRect.top - captionDragOffsetRef.current.y;

    newX = Math.max(0, Math.min(newX, parentRect.width - 60));
    newY = Math.max(0, Math.min(newY, parentRect.height - 30));

    setCaptionPos({ x: newX, y: newY });
  };

  const handleCaptionTouchEnd = () => {
    isDraggingCaptionRef.current = false;
    document.removeEventListener("touchmove", handleCaptionTouchMove);
    document.removeEventListener("touchend", handleCaptionTouchEnd);
  };

  useEffect(() => {
    (window as any).isMutedGlobal = isMuted;

    if (audioRef.current) {
      audioRef.current.muted = isMuted;
    }
  }, [isMuted]);


  useEffect(() => {
    const saved = localStorage.getItem("captions_enabled");
    if (saved !== null) setCaptionsEnabled(saved === "true");
  }, []);




  const toggleCaptions = () => {
    setCaptionsEnabled((prev) => {
      const next = !prev;
      localStorage.setItem("captions_enabled", String(next));
      /* if (!next) setCaptionText("");  */  // clear immediately when turning off
      return next;
    });
  };

  const fetchInstructorImage = async (userEmail: string) => {
    try {
      const res = await axios.get(`${apiUrl}/api/prompts/courses/by-user`, {
        params: { user_email: userEmail }
      });
      const mentor = res.data?.mentor;
      // console.log('mentor details res =>', mentor);
      setMentorDetails(mentor);
      if (mentor?.profile_image) {
        const baseUrl = process.env.REACT_APP_RETURN_DOMAIN_NAME || "";
        const imageUrl = mentor.profile_image.startsWith("http")
          ? mentor.profile_image
          : `${baseUrl}${mentor.profile_image}`;
        setUserImage(imageUrl);
      }
    } catch (error) {
      console.log("Error fetching instructor image=>", error);
    }
  };

  useEffect(() => {
    if (!courseId) {
      toast.error("Something went wrong, Please try again later!");
      return;
    }
    if (hasFetched.current) return;
    hasFetched.current = true;
    getCourseDetail();
  }, [courseId]);

  // useEffect(() => {
  //   setOpenCoursePopup(true);
  // }, []);

  // ── Instructor detection (for certificate preview) ──
  const currentUserId =
    userDets?._id || userDets?.user_id || userDets?.id || "";
  const courseOwnerId = completeCourseDet?.user_id || mentorId || "";

  const isCourseInstructor =
    (userRole || "").toLowerCase() === "user" &&
    !!currentUserId &&
    !!courseOwnerId &&
    String(currentUserId) === String(courseOwnerId);

  // const handleDownloadCertificate = async () => {
  //   try {
  //     setDownloadingCertificate(true);

  //     const response = await axios.get(
  //       `${apiUrl}/api/digital-twin/student/certificate/${courseId}`,
  //       {
  //         params: { student_id: studentId },
  //         responseType: "blob",
  //       }
  //     );

  //     const blob = new Blob([response.data], { type: "application/pdf" });
  //     const downloadUrl = window.URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = downloadUrl;
  //     link.download = `Certificate-${(completeCourseDet?.title || "Course").replace(/[^a-z0-9]/gi, "_")}.pdf`;
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //     window.URL.revokeObjectURL(downloadUrl);
  //   } catch (error: any) {
  //     console.error("Certificate download error =>", error);
  //     toast.error(
  //       error?.response?.data?.detail || "Unable to download certificate. Please try again."
  //     );
  //   } finally {
  //     setDownloadingCertificate(false);
  //   }
  // };

  const handleDownloadCertificate = async () => {
    // Instructor preview: generate with the instructor's own id, as a sample.
    const isPreview = isCourseInstructor;
    const certificateUserId = isPreview ? currentUserId : studentId;

    if (!certificateUserId) {
      toast.error("User not found. Please log in again.");
      return;
    }

    try {
      setDownloadingCertificate(true);

      const response = await axios.get(
        `${apiUrl}/api/digital-twin/student/certificate/${courseId}`,
        {
          params: {
            student_id: certificateUserId,
            ...(isPreview ? { preview: true } : {}),
          },
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const downloadUrl = window.URL.createObjectURL(blob);

      const safeTitle = (completeCourseDet?.title || "Course").replace(/[^a-z0-9]/gi, "_");
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = isPreview
        ? `Sample-Certificate-${safeTitle}.pdf`
        : `Certificate-${safeTitle}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error: any) {
      console.error("Certificate download error =>", error);

      // With responseType "blob", the backend's JSON error arrives as a Blob.
      let message = "Unable to download certificate. Please try again.";
      try {
        const data = error?.response?.data;
        if (data instanceof Blob) {
          const parsed = JSON.parse(await data.text());
          message = parsed?.detail || message;
        } else if (data?.detail) {
          message = data.detail;
        }
      } catch { /* keep default message */ }

      toast.error(message);
    } finally {
      setDownloadingCertificate(false);
    }
  };

  const getCourseDetail = async () => {
    try {
      setLoadingCourse(true);
      const res = await axios.get(
        `${apiUrl}/api/prompts/get_course/${courseId}`,
      );
      console.log("course detail response=>", res?.data?.course);
      localStorage.setItem("mentor_id", res?.data?.course?.user_id);
      setCompleteCourseDet(res?.data?.course);
      const courseData = res?.data?.course;
      /* setCourseImage(
        courseData?.image_path_small ||
        courseData?.thumbnail_url ||
        courseData?.image_url ||
        courseData?.image_path ||
        courseData?.image ||
        ''
      ); */
      setUserImage(res?.data?.course?.user?.user_image);
      if (res?.data?.course?.user_email) {
        fetchInstructorImage(res.data.course.user_email);
      }
      const list = res?.data?.course?.curriculum || [];
      setCurriculum(list);
      setActiveWeekIndex(0);

      /* const initialSpeech = `
Course Title: ${res?.data?.course?.title || ""}.

Description:
${res?.data?.course?.description || ""}

Target Audience:
${res?.data?.course?.target_audience || ""}

Difficulty Level:
${res?.data?.course?.difficulty || ""}

Duration:
${res?.data?.course?.duration || ""}
`;

      stop();

      currentSpeechTypeRef.current = "course";

      playText(initialSpeech); */
    } catch (error: any) {
      console.log("Error fetching course detail=>", error);
      toast.error(error);
    } finally {
      setLoadingCourse(false);
    }
  };

  /* const getCourseProgress = async () => {
    if (!courseId || loggedIn !== "true") return;

    try {
      const response = await axios.get(
        `${apiUrl}/api/prompts/course-enrollment/${courseId}/progress`
      );

      const data = response?.data;

      console.log("Course progress response =>", data);

      // Overall progress MUST come from API
      const overall = Number(data?.completion_percentage ?? 0);

      setOverallCompletionPercentage(overall);

      // Week-wise progress MUST come from API weeks[]
      const progressMap: Record<number, number> = {};

      (data?.weeks || []).forEach((week: any) => {
        progressMap[Number(week.week)] = Number(
          week.completed_percent ?? 0
        );
      });

      weekProgressRef.current = progressMap;
      setWeekProgress(progressMap);
    } catch (error) {
      console.error("Error fetching course progress =>", error);
    }
  }; */
  const getCourseProgress = async () => {
    if (
      !enrollmentId ||
      !isEnrolled ||
      loggedIn !== "true"
    ) {
      return;
    }

    const seq = ++progressFetchSeqRef.current;

    try {
      const response = await axios.get(
        `${apiUrl}/api/prompts/course-enrollment/${enrollmentId}/progress`
      );


      //  NEW — a newer request has since been made; this response is stale, discard it
      if (seq !== progressFetchSeqRef.current) {
        console.log("Discarding stale course-progress response", { seq, latest: progressFetchSeqRef.current });
        return;
      }

      const data = response?.data;

      console.log(
        "Course progress response =>",
        data
      );

      // Overall progress
      const overall = Number(
        data?.completion_percentage ?? 0
      );

      setOverallCompletionPercentage(overall);

      // Week-wise progress
      const progressMap: Record<number, number> = {};

      (data?.weeks || []).forEach(
        (week: any) => {
          progressMap[Number(week.week)] =
            Number(
              week.completed_percent ?? 0
            );
        }
      );

      weekProgressRef.current =
        progressMap;

      setWeekProgress(progressMap);
    } catch (error) {
      console.error(
        "Error fetching course progress =>",
        error
      );
    }
  };

  /* useEffect(() => {
    if (loggedIn === "true" && courseId) {
      getCourseProgress();
    }
  }, [courseId, loggedIn]); */
  useEffect(() => {
    if (
      loggedIn === "true" &&
      isEnrolled &&
      enrollmentId
    ) {
      getCourseProgress();
    } else if (!isEnrolled) {
      // Only reset if we haven't already established real progress this session —
      // prevents a stale/duplicate check from wiping out progress we just earned.
      if (Object.keys(weekProgressRef.current).length === 0) {
        setOverallCompletionPercentage(0);
        setWeekProgress({});
        weekProgressRef.current = {};
      }
    }
  }, [
    enrollmentId,
    isEnrolled,
    loggedIn,
  ]);

  /* const updateWeekProgress = async (
    week: number,
    completedPercentage: number
  ) => {
    if (!courseId) return;

    const percentage = Math.max(
      0,
      Math.min(100, Math.round(completedPercentage))
    );

    try {
      await axios.post(
        `${apiUrl}/api/prompts/course-enrollment/${courseId}/progress`,
        {
          week,
          completed_percentage: percentage,
        }
      );

      console.log("Progress updated =>", {
        courseId,
        week,
        completed_percentage: percentage,
      });

      // Update week UI immediately
      weekProgressRef.current = {
        ...weekProgressRef.current,
        [week]: percentage,
      };

      setWeekProgress((prev) => ({
        ...prev,
        [week]: percentage,
      }));
    } catch (error) {
      console.error("Error updating week progress =>", error);
    }
  }; */
  const updateWeekProgress = async (
    week: number,
    completedPercentage: number
  ) => {
    if (
      !enrollmentId ||
      !isEnrolled
    ) {
      return;
    }

    const percentage = Math.max(
      0,
      Math.min(
        100,
        Math.round(completedPercentage)
      )
    );

    try {
      await axios.post(
        `${apiUrl}/api/prompts/course-enrollment/${enrollmentId}/progress`,
        {
          week,
          completed_percent:
            percentage,
        }
      );



      console.log(
        "Progress updated =>",
        {
          enrollmentId,
          week,
          completed_percent:
            percentage,
        }
      );

      // Update week UI immediately
      weekProgressRef.current = {
        ...weekProgressRef.current,
        [week]: percentage,
      };

      setWeekProgress((prev) => ({
        ...prev,
        [week]: percentage,
      }));



      // Refresh overall completion_percentage
      // from backend after the week update.
      await getCourseProgress();
    } catch (error) {
      console.error(
        "Error updating week progress =>",
        error
      );
    }
  };

  // NEW — adds a delta on top of whatever progress this week already has,
  // instead of overwriting it (which is what updateWeekProgress does).
  const addWeekProgress = async (week: number, deltaPercent: number) => {
    const current = weekProgressRef.current[week] ?? 0;
    const next = Math.min(100, current + deltaPercent);

    if (next <= current) return; // nothing to add

    await updateWeekProgress(week, next);
  };

  // const handleAudioChunkProgress = async (
  //   week: number,
  //   chunkIndex: number,
  //   totalChunks: number
  // ) => {
  //   if (!week || !totalChunks) return;

  //   const chunkKey = `${week}-${chunkIndex}`;

  //   // Same chunk should not increase progress twice
  //   if (playedProgressChunksRef.current.has(chunkKey)) {
  //     return;
  //   }

  //   playedProgressChunksRef.current.add(chunkKey);

  //   const currentProgress =
  //     weekProgressRef.current[week] ?? 0;

  //   const isLastChunk =
  //     chunkIndex === totalChunks - 1;

  //   let nextProgress: number;

  //   if (isLastChunk) {
  //     // ONLY last chunk gets 100%
  //     nextProgress = currentProgress;
  //   } else {
  //     // Sequential 10, 20, 30, 40...
  //     nextProgress = Math.min(
  //       90,
  //       currentProgress + 10
  //     );
  //   }

  //   // Don't send a lower value than what's already saved
  //   if (nextProgress <= currentProgress) {
  //     return;
  //   }

  //   await updateWeekProgress(
  //     week,
  //     nextProgress
  //   );
  // };

  const fetchData = async () => {
    try {
      const response = await getUserDetails({
        email: user_email || getCookie("user_email") || "",
        filter: "",
        start_date: "",
        end_date: "",
      });

      if ("data" in response) {
        setUserDets(response.data.data);
        // console.log('user details =>', response.data.data);
        // console.log(response.data.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Backfill student_id from fetched user data — only for students
  useEffect(() => {
    //if (studentId) return; // already have it

    const isStudent = (userRole || "").toLowerCase() === "student";
    if (!isStudent) return; // don't backfill for mentors/instructors/other roles

    const derivedId =
      userDets?.user_id ||
      userDets?._id ||
      userDets?.id ||
      userDets?.email ||
      user_email ||
      "";

    if (derivedId) {
      localStorage.setItem("student_id", derivedId);
      setStudentId(derivedId);
    }
  }, [userDets, studentId]);

  /* useEffect(() => {
    if (!curriculum?.length) return;

    const currentWeek = curriculum[activeWeekIndex];

    if (!currentWeek) return;

    const requestId = ++speechRequestIdRef.current;

    const playWeekContent = async () => {
      stop();

      const weekSpeech = `
Week ${activeWeekIndex + 1}

${currentWeek?.title || ""}

${currentWeek?.description || ""}

${currentWeek?.content || ""}
`;

      // prevent stale playback
      if (requestId !== speechRequestIdRef.current) return;

      currentSpeechTypeRef.current = "course";

      await playText(weekSpeech);
    };

    playWeekContent();
  }, [activeWeekIndex, curriculum]); */

  /* useEffect(() => {
    if (!curriculum?.length) return;

    const currentWeek = curriculum[activeWeekIndex];

    console.log("Current Week =>", currentWeek);
    console.log("title_audio_path =>", currentWeek?.title_audio_path);
    console.log("content_audio_path =>", currentWeek?.content_audio_path);

    if (!currentWeek) return;

    const requestId = ++speechRequestIdRef.current;

    const playWeekContent = async () => {
      stopAll();

      const titleAudio = currentWeek?.title_audio_path;
      const contentAudio = currentWeek?.content_audio_path;

      // PRIORITY 1 => WAV FILES
      const hasCustomAudio =
        (titleAudio && titleAudio.trim() !== "") ||
        (contentAudio && contentAudio.trim() !== "");

      if (hasCustomAudio) {
        const played = await playCurriculumAudio(
          titleAudio,
          contentAudio,
        );

        if (played) return;
      }

      // FALLBACK => TTS QUEUE
      const weekSpeech = `
Week ${activeWeekIndex + 1}

${currentWeek?.title || ""}

${currentWeek?.description || ""}

${currentWeek?.content || ""}
`;

      if (requestId !== speechRequestIdRef.current) return;

      currentSpeechTypeRef.current = "course";

      await playText(weekSpeech);
    };

    playWeekContent();
  }, [activeWeekIndex, curriculum]); */
  useEffect(() => {
    if (!hasStartedCourse) return;

    if (!curriculum?.length) return;

    // Lesson / quiz / course-overview audio each own their own effect
    // (below, near openQuiz/closeQuiz). Module narration should stay
    // completely out of their way while one of those is active, and
    // resume automatically once the user comes back to the module view.
    if (selectedSubtopic || isLessonQuiz || showCourseDefinition) return;

    let isCancelled = false;

    const playWeekContent = async () => {
      if (curriculumAudioRef.current?.src && curriculumAudioRef.current.paused === false) {
        console.log("playWeekContent: audio already playing, skipping re-entry");
        return;
      }
      if (curriculumAudioRef.current) {
        curriculumAudioRef.current.pause();
        curriculumAudioRef.current.currentTime = 0;
        curriculumAudioRef.current.src = "";
      }

      if (isCancelled) return;

      // const latestWeek = curriculum[activeWeekIndex];
      const latestWeek =
        selectedWeekData || curriculum[activeWeekIndex];

      if (!latestWeek) return;

      console.log("latestWeek =>", latestWeek);

      /* const titleAudio = latestWeek?.title_audio_path || "";
      const contentAudio = latestWeek?.content_audio_path || "";

      console.log("titleAudio =>", titleAudio);
      console.log("contentAudio =>", contentAudio);

      const hasCustomAudio =
        titleAudio.trim() !== "" ||
        contentAudio.trim() !== "";

      // PRIORITY => CUSTOM AUDIO
      if (hasCustomAudio) { */
      const titleAudio = latestWeek?.title_audio_path || "";
      const contentAudio = latestWeek?.content_audio_path || "";
      const contentSegments = latestWeek?.content_audio_segments || [];

      console.log("titleAudio =>", titleAudio);
      console.log("contentAudio =>", contentAudio);

      const weekNumber =
        Number(latestWeek?.week) || activeWeekIndex + 1;

      playedProgressChunksRef.current.clear();

      // NEW — start generating the first lesson's audio now, in the
      // background, so it's ready the instant module narration finishes.
      maybePrefetchLesson(weekNumber, latestWeek?.subtopics?.[0]);

      // Once this module's narration finishes, auto-move into its
      // first lesson.
      const goToFirstLesson = () => {
        console.log("goToFirstLesson called, isCancelled:", isCancelled);
        if (isCancelled) return;

        const firstLesson = latestWeek?.subtopics?.[0];

        if (!firstLesson) return;

        setSelectedWeekData(latestWeek);
        setSelectedSubtopic(firstLesson);
      };

      // PRIORITY 1 → content_audio_path + content_audio_segments
      // (single pre-rendered file, live segment captions)
      currentSpeechTypeRef.current = "course";
      const playedFromSegments = await playAudioWithSegments(
        contentAudio,
        contentSegments
      );

      if (playedFromSegments) {
        console.log("Module played via segments");
        activeModuleAudioTypeRef.current = "curriculum";

        if (!moduleSummaryProgressAddedRef.current.has(weekNumber)) {
          moduleSummaryProgressAddedRef.current.add(weekNumber);
          await addWeekProgress(weekNumber, 10);
        }

        goToFirstLesson();
        return;
      }

      if (isCancelled) return;

      const hasCustomAudio =
        titleAudio.trim() !== "" ||
        contentAudio.trim() !== "";

      // PRIORITY 2 => title/content audio without segments (old behaviour)
      if (hasCustomAudio) {
        /* const played = await playCurriculumAudio(
          titleAudio,
          contentAudio,
        ); */
        /*  const weekNumber =
           Number(latestWeek?.week) ||
           activeWeekIndex + 1;
 
         playedProgressChunksRef.current.clear(); */

        const played = await playCurriculumAudio(
          titleAudio,
          contentAudio,
          undefined,
          [
            stripHtml(latestWeek?.title || ""),
            stripHtml(latestWeek?.module_summary || latestWeek?.content || ""),
          ]
        );

        console.log("playCurriculumAudio resolved:", played);

        if (played) {
          activeModuleAudioTypeRef.current = "curriculum";

          if (!moduleSummaryProgressAddedRef.current.has(weekNumber)) {
            moduleSummaryProgressAddedRef.current.add(weekNumber);
            await addWeekProgress(weekNumber, 10);
          }

          goToFirstLesson();
          return;
        }
      }

      // FALLBACK => TTS
      /* const weekSpeech = `
Week ${activeWeekIndex + 1}

${latestWeek?.title || ""}

${latestWeek?.description || ""}

${latestWeek?.content || ""}
`; */
      //       const weekSpeech = cleanTextForTTS(`
      // Week ${activeWeekIndex + 1}

      // ${latestWeek?.title || ""}

      // ${latestWeek?.description || ""}

      // ${latestWeek?.content || ""}
      // `);

      const weekSpeech = cleanTextForTTS(
        stripHtml(`
  Week ${activeWeekIndex + 1}
  ${latestWeek?.title || ""}
  ${latestWeek?.description || ""}
  ${latestWeek?.content || ""}
  `)
      );

      /* currentSpeechTypeRef.current = "course";

      await playText(weekSpeech); */
      // prevent course TTS when chatbot is active
      if (isChatbotRequestRef.current) {
        console.log("isChatbotRequestRef true — skipping TTS fallback, still advancing to lesson"); // TEMP DEBUG
        goToFirstLesson();   // still transition, just don't speak
        return;
      }

      currentSpeechTypeRef.current = "course";
      activeModuleAudioTypeRef.current = "tts";
      // await playText(weekSpeech);
      /* const weekNumber =
        Number(latestWeek?.week) ||
        activeWeekIndex + 1;

      playedProgressChunksRef.current.clear(); */

      await playText(
        weekSpeech,
        undefined,
        undefined,
        (chunkIndex, totalChunks, chunkText) => {
          setCaptionText(chunkText);
        }
      );

      goToFirstLesson();
    };

    playWeekContent();

    return () => {
      isCancelled = true;
    };
  }, [
    hasStartedCourse,
    activeWeekIndex,
    curriculum,
    selectedWeekData,
    selectedSubtopic,
    isLessonQuiz,
    showCourseDefinition,
  ]);

  /* const getEnrolledCourses = async () => {
    try {
      setLoadingEnrollment(true);
      const user_email = localStorage.getItem("user_email");
      if (!user_email) return;
      const res = await axios.get(`${apiUrl}/api/student/courses/enrolled`, {
        params: { user_email },
      });
      const courses = res?.data?.courses || [];
      setIsEnrolled(courses.some((c: any) => c._id === courseId));
    } catch (err) {
      console.log("Enrollment fetch error", err);
    } finally {
      setLoadingEnrollment(false);
    }
  }; */

  const getEnrolledCourses = async () => {
    try {
      setLoadingEnrollment(true);

      const user_email = localStorage.getItem("user_email");

      if (!user_email) {
        setIsEnrolled(false);
        setEnrollmentId(null);
        return;
      }

      const res = await axios.get(
        `${apiUrl}/api/student/courses/enrolled`,
        {
          params: { user_email },
        }
      );

      const courses = res?.data?.courses || [];

      const enrolledCourse = courses.find(
        (course: any) => course._id === courseId
      );

      console.log('enrolled course response=>', enrolledCourse);
      console.log('course id response=>', courseId);

      const enrolled = !!enrolledCourse;

      setIsEnrolled(enrolled);

      if (enrolled) {
        const currentEnrollmentId =
          enrolledCourse?.enrollment_id;

        setEnrollmentId(
          currentEnrollmentId || null
        );

        console.log(
          "Current enrolled res =>",
          enrolled
        );

        console.log(
          "Current enrolled course =>",
          enrolledCourse
        );

        console.log(
          "Enrollment ID =>",
          currentEnrollmentId
        );
      } else {
        setEnrollmentId(null);

        // Important:
        // Don't keep previous course's progress
        if (Object.keys(weekProgressRef.current).length === 0) {
          setOverallCompletionPercentage(0);
          setWeekProgress({});
          weekProgressRef.current = {};
        }
      }
    } catch (err) {
      console.log(
        "Enrollment fetch error",
        err
      );

      setIsEnrolled(false);
      setEnrollmentId(null);

      if (Object.keys(weekProgressRef.current).length === 0) {
        setOverallCompletionPercentage(0);
        setWeekProgress({});
        weekProgressRef.current = {};
      }
    } finally {
      setLoadingEnrollment(false);
    }
  };

  useEffect(() => {
    if (loggedIn === "true" && courseId) {
      getEnrolledCourses();
    } else {
      setLoadingEnrollment(false);
    }
  }, [courseId]);



  // const formatCourseContent = (raw: string) => {
  //   if (!raw) return "";
  //   let html = raw;
  //   html = html.replace(/^[=\-]{3,}$/gm, "");
  //   html = html.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  //   html = html.replace(/^### (.*)$/gm, "<h3>$1</h3>");
  //   html = html.replace(/^## (.*)$/gm, "<h2>$1</h2>");
  //   html = html.replace(/\*\*(.*?)\*\*/g, "<h2>$1</h2>");
  //   html = html.replace(/(?:^|\n)([=•-]+ .*(?:\n[=•-]+ .*)*)/g, (match) => {
  //     const items = match
  //       .trim()
  //       .split("\n")
  //       .map((i) => `<li>${i.replace(/^[=•-]+ /, "")}</li>`)
  //       .join("");
  //     return `<ul>${items}</ul>`;
  //   });
  //   html = html.replace(
  //     /^(?!<h2>|<h3>|<ul>|<li>|<\/ul>)(?![=\-•\s]+$)(.+)$/gm,
  //     "<p>$1</p>",
  //   );
  //   html = html.replace(/<p>\s*<\/p>/g, "");
  //   return html;
  // };

  // const stripHtml = (html: string) => {
  //   const tempDiv = document.createElement("div");
  //   tempDiv.innerHTML = html;
  //   return tempDiv.textContent || tempDiv.innerText || "";
  // };

  const cleanTextForTTS = (text: string) => {
    if (!text) return "";

    return text
      // Week 1 / Week 2 / Week 10
      .replace(/\bweek\s+\d+\b\s*:?\s*/gi, "")

      // Chapter 1 / Chapter 2 / Chapter 10
      .replace(/\bchapter\s+\d+\b\s*:?\s*/gi, "")

      // Module 1 / Module 2 / Module 10
      .replace(/\bmodule\s+\d+\b\s*:?\s*/gi, "")

      // Remove extra blank spaces
      .replace(/\n{2,}/g, "\n")
      .replace(/[ \t]{2,}/g, " ")
      .trim();
  };



  const TARGET_WORDS_PER_CHUNK = 30;

  const splitText = (text: string): string[] => {
    if (!text) return [];

    text = text
      .replace(/\*+/g, " ")
      .replace(/#+/g, " ")
      .replace(/_+/g, " ")
      .replace(/`+/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    const sentences =
      text.match(/[^.!?]+[.!?]+/g) || [text];

    const chunks: string[] = [];

    let current = "";

    for (const sent of sentences) {
      const trimmed = sent.trim();

      if (!trimmed) continue;

      const combinedWords = (
        current +
        " " +
        trimmed
      ).split(/\s+/).length;

      if (
        current &&
        combinedWords > TARGET_WORDS_PER_CHUNK
      ) {
        chunks.push(current.trim());

        current = trimmed;
      } else {
        current = current
          ? current + " " + trimmed
          : trimmed;
      }
    }

    if (current.trim()) {
      chunks.push(current.trim());
    }

    return chunks;
  };

  const getHighlightedContent = (
    raw: string,
    currentIndex: number
  ) => {
    if (!raw) return "";

    const chunks = splitText(raw);

    let processed = raw;

    chunks.forEach((chunk, index) => {
      const cleanChunk = chunk
        .replace(/\s+/g, " ")
        .trim();

      if (!cleanChunk) return;

      const normalizedProcessed =
        processed.replace(/\s+/g, " ");

      const chunkIndex =
        normalizedProcessed.indexOf(cleanChunk);

      if (chunkIndex === -1) return;

      const originalSubstring =
        normalizedProcessed.substring(
          chunkIndex,
          chunkIndex + cleanChunk.length
        );

      processed = processed.replace(
        originalSubstring,
        index === currentIndex
          ? `@@HIGHLIGHT_START@@${originalSubstring}@@HIGHLIGHT_END@@`
          : originalSubstring
      );
    });

    processed = formatCourseContent(processed);

    processed = processed
      .replace(
        /@@HIGHLIGHT_START@@/g,
        `<span class="tts-highlight">`
      )
      .replace(
        /@@HIGHLIGHT_END@@/g,
        `</span>`
      );

    return processed;
  };

  const formatCourseContent = (raw: string) => {
    if (!raw) return "";

    let html = raw;

    // Remove unwanted HTML tags completely
    html = html.replace(/<\/?(div|span|section|article)[^>]*>/gi, "");

    // Remove markdown code blocks
    html = html.replace(/```[\s\S]*?```/g, "");

    // Remove horizontal rules or repeated symbols
    html = html.replace(/^[=\-_*]{3,}$/gm, "");

    // Escape HTML
    // html = html.replace(/</g, "&lt;").replace(/>/g, "&gt;"); (just commented for highlighting text feature testing)
    // html = html.replace(/<(?!\/?(span)\b)[^>]*>/gi, "");

    // Headers
    html = html.replace(/^###### (.*)$/gm, "<h6>$1</h6>");
    html = html.replace(/^##### (.*)$/gm, "<h5>$1</h5>");
    html = html.replace(/^#### (.*)$/gm, "<h4>$1</h4>");
    html = html.replace(/^### (.*)$/gm, "<h3>$1</h3>");
    html = html.replace(/^## (.*)$/gm, "<h2>$1</h2>");
    html = html.replace(/^# (.*)$/gm, "<h1>$1</h1>");

    // Bold
    // html = html.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
    html = html.replace(/^\*\*(.*?)\*\*$/gm, "<h6>$1</h6>");

    // Italic
    html = html.replace(/\*(.*?)\*/g, "<em>$1</em>");

    // Bullet lists
    html = html.replace(
      /(?:^|\n)([•\-=*]+ .*(?:\n[•\-=*]+ .*)*)/g,
      (match) => {
        const items = match
          .trim()
          .split("\n")
          .map((i) => `<li>${i.replace(/^[•\-=*]+ /, "").trim()}</li>`)
          .join("");

        return `<ul>${items}</ul>`;
      }
    );

    // Remove remaining markdown symbols
    // html = html.replace(/[#*_`>]+/g, "");

    // Paragraphs
    html = html.replace(
      /^(?!<h1>|<h2>|<h3>|<h4>|<h5>|<h6>|<ul>|<li>|<\/ul>)(.+)$/gm,
      "<p>$1</p>"
    );

    // Remove empty paragraphs
    html = html.replace(/<p>\s*<\/p>/g, "");

    // Remove multiple spaces/newlines
    html = html.replace(/\n{2,}/g, "\n").trim();

    return html;
  };



  useEffect(() => {
    const active =
      document.querySelector(".tts-highlight");

    if (active) {
      active.scrollIntoView({
        behavior: "smooth",
        // block: "center",
        block: "nearest",
        inline: "nearest",
      });
    }
  }, [currentIndex]);

  const getChatBotResponse = async (
    courseid: any,
    query: string,
    chapter: any,
  ) => {
    if (!query?.trim()) {
      return;
    }

    const requestId = ++chatRequestIdRef.current;

    if (query?.trim()) {
      setChatMessages((prev) => [...prev, { role: "user", text: query }]);
    }
    setPrompt("");
    setIsChatBotLoading(true);
    try {
      const res = await axios.post(`${apiUrl}/api/prompts/chat_answer_v2`, {
        courseid,
        query,
        chapter,
      });
      console.log("chatbot response=>", res);
      let answer = res?.data?.response;
      answer = answer.replace(/\*{2,}/g, "");
      answer = answer.replace(/#{1,}/g, "");
      answer = answer.replace(/^\* (.+)$/gm, "• $1");
      setChatMessages((prev) => [
        ...prev,
        { role: "bot", text: answer || "No response" },
      ]);
      const cleanText = stripHtml(answer);
      setLastBotText(cleanText);
    } catch (error: any) {
      console.log("Error fetching replies=>", error);
      toast.error(error);
    } finally {
      setIsChatBotLoading(false);
    }
  };

  /*  useEffect(() => {
     if (!lastBotText) return;
 
     // Prevent duplicate autoplay
     if (prevTextRef.current === lastBotText) return;
 
     // Mark as played
     prevTextRef.current = lastBotText;
 
     // STOP any existing TTS FIRST
     dispatch(stopTTS());
 
     // Small delay ensures clean reset (important)
     const timer = setTimeout(() => {
       dispatch(
         speakText({
           text: lastBotText,
           voice: "default.wav",
           id: "global-tts",
         })
       );
     }, 150);
 
     return () => clearTimeout(timer);
   }, [lastBotText, dispatch]); */


  /* const resumeModuleAfterChat = () => {
    const saved = resumeAfterChatRef.current;

    if (!saved.shouldResume) {
      return;
    }

    // Make sure user is still on the same module
    if (saved.weekIndex !== activeWeekIndex) {
      resumeAfterChatRef.current.shouldResume = false;
      return;
    }

    // Don't resume if user opened lesson / quiz / overview
    if (
      selectedSubtopic ||
      isLessonQuiz ||
      showCourseDefinition
    ) {
      resumeAfterChatRef.current.shouldResume = false;
      return;
    }

    console.log(
      "Resuming module after AI:",
      saved
    );

    if (saved.audioType === "curriculum") {
      const audio = curriculumAudioRef.current;

      if (audio) {
        // Position should already be preserved because
        // we paused instead of resetting the audio.
        audio.currentTime = saved.currentTime;

        audio
          .play()
          .then(() => {
            setIsCurriculumAudioPlaying(true);
          })
          .catch((error) => {
            console.log(
              "Unable to resume curriculum audio:",
              error
            );
          });
      }
    }

    if (saved.audioType === "tts") {
      resume();
    }

    resumeAfterChatRef.current.shouldResume = false;
  }; */

  /* const resumePreviousContentAfterChat = () => {
    const saved = resumeAfterChatRef.current;

    if (!saved.shouldResume) {
      return;
    }

    // Don't resume if user changed to another module.
    if (saved.weekIndex !== activeWeekIndex) {
      resumeAfterChatRef.current.shouldResume = false;
      return;
    }

    // If the saved content was a lesson,
    // make sure the SAME lesson is still selected.
    if (saved.speechType === "lesson") {
      const currentLessonKey = selectedSubtopic
        ? String(
          selectedSubtopic?._id ??
          selectedSubtopic?.id ??
          selectedSubtopic?.lesson_id ??
          selectedSubtopic?.lesson_title ??
          ""
        )
        : null;

      if (
        !selectedSubtopic ||
        currentLessonKey !== saved.lessonKey
      ) {
        resumeAfterChatRef.current.shouldResume = false;
        return;
      }
    }

    // If saved content was course definition,
    // it must still be open.
    if (
      saved.speechType === "overview" &&
      !showCourseDefinition
    ) {
      resumeAfterChatRef.current.shouldResume = false;
      return;
    }

    // If saved content was module,
    // lesson/overview/quiz should not have replaced it.
    if (
      saved.speechType === "course" &&
      (
        selectedSubtopic ||
        isLessonQuiz ||
        showCourseDefinition
      )
    ) {
      resumeAfterChatRef.current.shouldResume = false;
      return;
    }

    console.log(
      "Resuming previous content after AI:",
      saved
    );

    // --------------------------------------------------
    // Pre-rendered audio
    // --------------------------------------------------
    if (saved.audioType === "curriculum") {
      const audio = curriculumAudioRef.current;

      if (audio && audio.src) {
        audio.currentTime = saved.currentTime;

        audio
          .play()
          .then(() => {
            setIsCurriculumAudioPlaying(true);
          })
          .catch((error) => {
            console.log(
              "Unable to resume previous audio:",
              error
            );
          });
      }
    }

    // --------------------------------------------------
    // TTS stream
    // --------------------------------------------------
    if (saved.audioType === "tts") {
      resume();
    }

    resumeAfterChatRef.current.shouldResume = false;
  }; */

  const resumePreviousContentAfterChat = () => {
    const saved = resumeAfterChatRef.current;

    if (!saved.shouldResume) {
      return;
    }

    // Don't resume if user changed to another module.
    if (saved.weekIndex !== activeWeekIndex) {
      resumeAfterChatRef.current.shouldResume = false;
      return;
    }

    // If the saved content was a lesson,
    // make sure the SAME lesson is still selected.
    if (saved.speechType === "lesson") {
      const currentLessonKey = selectedSubtopic
        ? String(
          selectedSubtopic?._id ??
          selectedSubtopic?.id ??
          selectedSubtopic?.lesson_id ??
          selectedSubtopic?.lesson_title ??
          ""
        )
        : null;

      if (
        !selectedSubtopic ||
        currentLessonKey !== saved.lessonKey
      ) {
        resumeAfterChatRef.current.shouldResume = false;
        return;
      }
    }

    // If saved content was course definition,
    // it must still be open.
    if (
      saved.speechType === "overview" &&
      !showCourseDefinition
    ) {
      resumeAfterChatRef.current.shouldResume = false;
      return;
    }

    // If saved content was module,
    // lesson/overview/quiz should not have replaced it.
    if (
      saved.speechType === "course" &&
      (
        selectedSubtopic ||
        isLessonQuiz ||
        showCourseDefinition
      )
    ) {
      resumeAfterChatRef.current.shouldResume = false;
      return;
    }

    console.log(
      "Previous content still valid — asking user to confirm resume:",
      saved
    );

    // Instead of resuming immediately, ask the user first.
    setShowResumeConfirm(true);
  };

  // Called when the user taps "Resume" on the confirmation dialog.
  const handleConfirmResumeAfterChat = async () => {
    const saved = resumeAfterChatRef.current;

    setShowResumeConfirm(false);

    if (!saved.shouldResume) return;

    console.log(
      "Resuming previous content after AI:",
      saved
    );

    // --------------------------------------------------
    // Pre-rendered audio
    // --------------------------------------------------
    if (saved.audioType === "curriculum") {
      const audio = curriculumAudioRef.current;

      if (audio && audio.src) {
        audio.currentTime = saved.currentTime;

        audio
          .play()
          .then(() => {
            setIsCurriculumAudioPlaying(true);
          })
          .catch((error) => {
            console.log(
              "Unable to resume previous audio:",
              error
            );
          });
      }
    }

    // --------------------------------------------------
    // TTS stream
    // --------------------------------------------------
    if (saved.audioType === "tts") {
      // Lesson audio uses chunk-based TTS.
      // Do NOT call resume() here because after AI finishes,
      // the TTS stream belongs to the chatbot response.
      if (saved.speechType === "lesson") {
        //         const lessonSpeech = cleanTextForTTS(
        //           stripHtml(`
        // ${selectedSubtopic?.lesson_title || ""}
        // ${selectedSubtopic?.introduction || ""}
        // ${keyTakeaways.length ? keyTakeaways.join(". ") : ""}
        // `)
        // );

        const lessonSpeech = buildLessonSpeech(selectedSubtopic);
        const lessonChunks = splitText(lessonSpeech);

        const resumeChunkIndex = Math.min(
          saved.lessonChunkIndex,
          Math.max(lessonChunks.length - 1, 0)
        );

        const remainingChunks = lessonChunks.slice(resumeChunkIndex);

        // if (remainingChunks.length > 0) {
        //   setCaptionText(remainingChunks[0]);

        //   await playText(remainingChunks.join(" "));
        // }

        if (remainingChunks.length > 0) {
          currentSpeechTypeRef.current = "lesson";
          activeModuleAudioTypeRef.current = "tts";

          await playText(
            remainingChunks.join(" "),
            undefined,
            undefined,
            (chunkIndex, totalChunks, chunkText) => {
              setCaptionText(chunkText);   // ✅ keep captions correctly synced during resume too
            }
          );
        }

      } else if (saved.speechType === "course") {
        const latestWeek = selectedWeekData || curriculum[activeWeekIndex];
        const weekSpeech = buildWeekSpeech(latestWeek, activeWeekIndex);
        const weekChunks = splitText(weekSpeech);
        const resumeChunkIndex = Math.min(
          saved.lessonChunkIndex,
          Math.max(weekChunks.length - 1, 0)
        );
        const remainingChunks = weekChunks.slice(resumeChunkIndex);

        if (remainingChunks.length > 0) {
          currentSpeechTypeRef.current = "course";
          activeModuleAudioTypeRef.current = "tts";
          await playText(
            remainingChunks.join(" "),
            undefined,
            undefined,
            (chunkIndex, totalChunks, chunkText) => setCaptionText(chunkText)
          );
        }
      } else if (saved.speechType === "overview") {
        const overviewSpeech = cleanTextForTTS(
          stripHtml(`${courseDefinition?.title || ""}\n${courseDefinition?.description || ""}`)
        );
        const overviewChunks = splitText(overviewSpeech);
        const resumeChunkIndex = Math.min(
          saved.lessonChunkIndex,
          Math.max(overviewChunks.length - 1, 0)
        );
        const remainingChunks = overviewChunks.slice(resumeChunkIndex);

        if (remainingChunks.length > 0) {
          currentSpeechTypeRef.current = "overview";
          activeModuleAudioTypeRef.current = "tts";
          await playText(
            remainingChunks.join(" "),
            undefined,
            undefined,
            (chunkIndex, totalChunks, chunkText) => setCaptionText(chunkText)
          );
        }
      }
      else {
        resume();
      }
    }

    resumeAfterChatRef.current.shouldResume = false;
  };

  // Called when the user taps "No" / closes the confirmation dialog.
  const handleDeclineResumeAfterChat = () => {
    setShowResumeConfirm(false);
    resumeAfterChatRef.current.shouldResume = false;
  };

  useEffect(() => {
    if (!lastBotText) return;

    const requestId = ++speechRequestIdRef.current;

    const playBotResponse = async () => {
      // force stop ALL previous speech
      stopAll();
      // stopAll();

      // small reset delay
      await new Promise((r) => setTimeout(r, 100));

      // if newer request came meanwhile cancel this
      if (requestId !== speechRequestIdRef.current) return;

      currentSpeechTypeRef.current = "chatbot";

      await playText(lastBotText);

      if (requestId !== speechRequestIdRef.current) {
        return;
      }

      isChatbotRequestRef.current = false;

      // resumeModuleAfterChat();
      resumePreviousContentAfterChat();
    };

    playBotResponse();
  }, [lastBotText]);

  const handleBuyNow = async () => {
    try {
      setLoadingCheckout(true);
      const studentEmail = localStorage.getItem("user_email");
      const returnDomain = process.env.REACT_APP_RETURN_DOMAIN_NAME;
      const response = await axios.post(
        `${apiUrl}/api/subscription/create-course-checkout-session`,
        null,
        {
          params: {
            student_email: studentEmail,
            course_id: courseId,
            return_domain: returnDomain,
          },
        },
      );
      if (response?.data?.checkout_url) {
        window.location.href = response.data.checkout_url;
      }
    } catch (error) {
      console.error("Checkout error:", error);
    } finally {
      setLoadingCheckout(false);
    }
  };

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);
      audioChunksRef.current = [];
      mediaRecorder.ondataavailable = (event) => {
        audioChunksRef.current.push(event.data);
      };
      mediaRecorder.onstop = async () => {
        setIsTranscribing(true);
        const audioBlob = new Blob(audioChunksRef.current, {
          type: "audio/webm",
        });
        const audioUrl = URL.createObjectURL(audioBlob);
        setAudioURL(audioUrl);
        const formData = new FormData();
        formData.append("audio", audioBlob, "recording.webm");
        const res = await axios.post(
          `${process.env.REACT_APP_SPEECH_TO_TEXT_SERVICE}/speech_to_text`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } },
        );
        const transcribedText = res.data.text;
        setPrompt(transcribedText);
        setAudioURL(null);
        setIsTranscribing(false);
      };
      mediaRecorderRef.current = mediaRecorder;
      mediaRecorder.start();
      setIsRecording(true);
    } catch (err) {
      console.error("Error accessing microphone:", err);
    } finally {
      setIsTranscribing(false);
      setAudioURL(null);
    }
  };

  const stopRecording = () => {
    mediaRecorderRef.current?.stop();
    setIsRecording(false);
  };

  /* const toggleMute = () => {
    if (!audioRef.current) return;
    if (isMuted) {
      audioRef.current.play().catch(console.error);
    } else {
      audioRef.current.pause();
    }
    setIsMuted((p) => !p);
  }; */
  const toggleMute = () => {
    setIsMuted((prev) => {
      const newState = !prev;

      // TTS Queue Audio
      if (audioRef.current) {
        audioRef.current.muted = newState;

        if (newState) {
          // mute => pause
          audioRef.current.pause();
        } else {
          // unmute => resume only if paused
          if (audioRef.current.paused) {
            audioRef.current.play().catch(() => { });
          }
        }
      }

      // Curriculum WAV Audio
      if (curriculumAudioRef.current) {
        curriculumAudioRef.current.muted = newState;

        if (newState) {
          // mute => pause
          curriculumAudioRef.current.pause();
        } else {
          // unmute => resume only if paused
          if (curriculumAudioRef.current.paused) {
            curriculumAudioRef.current.play().catch(() => { });
          }
        }
      }

      return newState;
    });
  };

  /* const playCurriculumAudio = async (
    titleAudio?: string,
    contentAudio?: string,
  ) => {
    try {
      // FULL STOP
      stopAll();

      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = "";
      }

      // stop previous curriculum audio
      if (curriculumAudioRef.current) {
        curriculumAudioRef.current.pause();
        curriculumAudioRef.current.currentTime = 0;
        curriculumAudioRef.current.src = "";
      }

      const audioQueue = [titleAudio, contentAudio].filter(
        (item) =>
          typeof item === "string" &&
          item.trim() !== "",
      ) as string[];

      console.log("audioQueue =>", audioQueue);

      if (!audioQueue.length) {
        return false;
      }

      const playAudio = (src: string) => {
        return new Promise<void>((resolve, reject) => {
          const audio = new Audio(src);

          curriculumAudioRef.current = audio;

          audio.muted = isMuted;

          audio.onended = () => {
            resolve();
          };

          audio.onerror = (err) => {
            console.log("Audio play error =>", err);
            reject(err);
          };

          audio.play().catch(reject);
        });
      };

      setIsCurriculumAudioPlaying(true);

      for (const src of audioQueue) {
        await playAudio(src);
      }

      setIsCurriculumAudioPlaying(false);

      return true;
    } catch (error) {
      console.log("Curriculum audio error =>", error);

      setIsCurriculumAudioPlaying(false);

      return false;
    }
  }; */
  const playCurriculumAudio = async (
    titleAudio?: string,
    contentAudio?: string,
    onPartPlayed?: (partIndex: number, totalParts: number) => void,
    captions?: string[]   // NEW — same order as [titleAudio, contentAudio]
  ) => {
    try {
      const audioQueue = [titleAudio, contentAudio].filter(
        (item) => typeof item === "string" && item.trim() !== "",
      ) as string[];

      if (audioQueue.length === 0) return false;

      if (curriculumAudioRef.current) {
        curriculumAudioRef.current.pause();
        curriculumAudioRef.current.onended = null;
        curriculumAudioRef.current.onerror = null;
        curriculumAudioRef.current.src = "";
        curriculumAudioRef.current.load();
        curriculumAudioRef.current = null;
      }

      setIsCurriculumAudioPlaying(true);

      for (let partIndex = 0; partIndex < audioQueue.length; partIndex++) {
        const audioSrc = audioQueue[partIndex];

        // NEW — set caption as this part starts
        if (captions?.[partIndex]) {
          setCaptionText(captions[partIndex]);
        }

        await new Promise<void>((resolve, reject) => {
          const audio = new Audio(audioSrc);
          curriculumAudioRef.current = audio;
          audio.preload = "auto";
          audio.muted = isMuted;

          audio.onended = () => {
            onPartPlayed?.(partIndex, audioQueue.length);
            resolve();
          };
          audio.onerror = (e) => {
            console.log("Audio error =>", e);
            reject(e);
          };
          audio.play().catch((err) => {
            console.log("Play error =>", err);
            reject(err);
          });
        });
      }

      setIsCurriculumAudioPlaying(false);
      return true;
    } catch (error) {
      console.log("Curriculum audio error =>", error);
      setIsCurriculumAudioPlaying(false);
      return false;
    }
  };

  // ─────────────────────────────────────────────
  // SINGLE AUDIO + LIVE SEGMENT CAPTIONS
  // Plays one pre-rendered TTS audio file and syncs
  // captionText to it in real time using the
  // backend segment timings (start/end), instead of
  // splitting text into client-side TTS chunks.
  // Resolves false (so caller can fall back to
  // chunk-based playText) when the audio/segments
  // are missing, empty, or fail to play.
  // ─────────────────────────────────────────────
  const playAudioWithSegments = (
    audioUrl?: string,
    segments?: { text: string; start: number; end: number }[]
  ): Promise<boolean> => {
    return new Promise((resolve) => {
      if (
        !audioUrl ||
        audioUrl.trim() === "" ||
        !Array.isArray(segments) ||
        segments.length === 0
      ) {
        resolve(false);
        return;
      }

      // stop anything already playing on this ref
      if (curriculumAudioRef.current) {
        curriculumAudioRef.current.pause();
        curriculumAudioRef.current.onended = null;
        curriculumAudioRef.current.onerror = null;
        curriculumAudioRef.current.ontimeupdate = null;
        curriculumAudioRef.current.src = "";
        curriculumAudioRef.current.load();
        curriculumAudioRef.current = null;
      }

      const audio = new Audio(audioUrl);
      curriculumAudioRef.current = audio;
      audio.preload = "auto";
      audio.muted = isMuted;

      let lastSegmentIndex = -1;

      const finish = (success: boolean) => {
        audio.ontimeupdate = null;
        audio.onended = null;
        audio.onerror = null;
        setIsCurriculumAudioPlaying(false);
        resolve(success);
      };

      audio.ontimeupdate = () => {
        const t = audio.currentTime;

        const idx = segments.findIndex(
          (seg) => t >= seg.start && t < seg.end
        );

        if (idx !== -1 && idx !== lastSegmentIndex) {
          lastSegmentIndex = idx;
          setCaptionText(segments[idx].text);
        }
      };

      audio.onended = () => finish(true);

      audio.onerror = (e) => {
        console.log("Segment audio error =>", e);
        finish(false);
      };

      setIsCurriculumAudioPlaying(true);

      audio.play().catch((err) => {
        console.log("Segment audio play error =>", err);
        finish(false);
      });
    });
  };

  /* useEffect(() => {
    return () => {
      stop();
    };
  }, []); */
  /* useEffect(() => {
    return () => {
      stopAll();

      if (curriculumAudioRef.current) {
        curriculumAudioRef.current.pause();
        curriculumAudioRef.current = null;
      }
    };
  }, []); */

  /* const saveModulePlaybackState = () => {
    const moduleWasPlaying =
      isCurriculumAudioPlaying || isPlaying;

    if (!moduleWasPlaying) {
      resumeAfterChatRef.current.shouldResume = false;
      return;
    }

    let currentTime = 0;
    let audioType: "curriculum" | "tts" | null = null;

    if (
      curriculumAudioRef.current &&
      !curriculumAudioRef.current.paused
    ) {
      currentTime = curriculumAudioRef.current.currentTime || 0;
      audioType = "curriculum";
    } else if (audioRef.current && !audioRef.current.paused) {
      currentTime = audioRef.current.currentTime || 0;
      audioType = "tts";
    }

    resumeAfterChatRef.current = {
      shouldResume: true,
      weekIndex: activeWeekIndex,
      audioType,
      currentTime,
    };

    console.log(
      "Saved module playback state:",
      resumeAfterChatRef.current
    );
  }; */

  const savePlaybackStateBeforeChat = () => {
    const currentlyPlaying =
      isCurriculumAudioPlaying || isPlaying;

    if (!currentlyPlaying) {
      resumeAfterChatRef.current.shouldResume = false;
      return;
    }

    let currentTime = 0;
    let audioType: "curriculum" | "tts" | null = null;

    // Pre-rendered audio: module / lesson / course definition
    if (
      curriculumAudioRef.current &&
      !curriculumAudioRef.current.paused
    ) {
      currentTime =
        curriculumAudioRef.current.currentTime || 0;

      audioType = "curriculum";
    }

    // TTS stream
    else if (
      audioRef.current &&
      !audioRef.current.paused
    ) {
      currentTime =
        audioRef.current.currentTime || 0;

      audioType = "tts";
    }

    // let speechType = currentSpeechTypeRef.current;
    let speechType: "course" | "lesson" | "overview" | null =
      currentSpeechTypeRef.current === "course" ||
        currentSpeechTypeRef.current === "lesson" ||
        currentSpeechTypeRef.current === "overview"
        ? currentSpeechTypeRef.current
        : null;

    // Safety fallback
    if (!speechType /* || speechType === "chatbot" */) {
      if (selectedSubtopic) {
        speechType = "lesson";
      } else if (showCourseDefinition) {
        speechType = "overview";
      } else {
        speechType = "course";
      }
    }

    const lessonKey = selectedSubtopic
      ? String(
        selectedSubtopic?._id ??
        selectedSubtopic?.id ??
        selectedSubtopic?.lesson_id ??
        selectedSubtopic?.lesson_title ??
        ""
      )
      : null;

    resumeAfterChatRef.current = {
      shouldResume: true,
      weekIndex: activeWeekIndex,
      speechType,
      audioType,
      currentTime,
      lessonKey,
      lessonChunkIndex: audioType === "tts" ? currentIndex : 0,
    };

    console.log(
      "Saved playback state before AI:",
      resumeAfterChatRef.current
    );
  };

  const stopAllAudio = () => {
    stopAll();

    if (curriculumAudioRef.current) {
      curriculumAudioRef.current.pause();
      curriculumAudioRef.current.ontimeupdate = null;
      curriculumAudioRef.current.onended = null;
      curriculumAudioRef.current.onerror = null;
      curriculumAudioRef.current.currentTime = 0;
      curriculumAudioRef.current.src = "";
    }
    setCaptionText("");
  };

  // console.log('intro video url =>', completeCourseDet?.video_url);

  // Closes the Introduction Video popup. If it was opened as part of the
  // "Start Course" flow (pendingStartAfterVideo), closing it (via the close
  // button, backdrop click, or the video finishing) continues on into the
  // Course Definition, just like the old direct "Start Course" behavior.
  const handleCloseIntroVideo = () => {
    setIntroVideoOpen(false);

    if (pendingStartAfterVideo) {
      setPendingStartAfterVideo(false);
      setHasStartedCourse(true);
      setShowCourseDefinition(true);

      document
        .getElementById("course-content")
        ?.scrollIntoView({ behavior: "smooth" });
    }

    handleConfirmResumeAfterChat();
  };

  // Stop all audio when the user switches tabs, minimizes the browser,
  // navigates away (back/forward), or leaves this page — so playback
  // doesn't keep going in the background.
  /* useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        stopAllAudio();
      }
    };

    const handlePageHide = () => {
      stopAllAudio();
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("pagehide", handlePageHide);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("pagehide", handlePageHide);
      stopAllAudio();
    };
  }, []); */

  const currentWeek =
    selectedWeekData || curriculum[activeWeekIndex];

  const courseDefinition = completeCourseDet?.course_definition || null;
  const introVideoUrl = completeCourseDet?.video_url || null;

  const totalLessons = curriculum.reduce(
    (sum, w) => sum + (w.subtopics?.length || 0),
    0
  );

  const learningOutcomes: string[] = Array.isArray(completeCourseDet?.learning_outcomes)
    ? completeCourseDet.learning_outcomes
    : [];

  const currentQuiz = currentWeek?.module_quiz || [];
  const currentQuestion = currentQuiz[currentQuizIndex];

  const currentWeekImage =
    currentWeek?.chapter_image ||
    completeCourseDet?.image_path_small ||
    "";

  const currentLessonImage =
    selectedSubtopic?.lession_image || "";

  const keyTakeawaysRaw =
    selectedSubtopic?.key_takeaways ??
    null;

  // console.log('key take aways res=>', keyTakeawaysRaw);

  const keyTakeaways: string[] = Array.isArray(keyTakeawaysRaw)
    ? keyTakeawaysRaw
      .map((item: any) => (typeof item === "string" ? item : String(item ?? "")))
      .map((item: string) => item.trim())
      .filter((item: string) => item !== "")
    : typeof keyTakeawaysRaw === "string" && keyTakeawaysRaw.trim() !== ""
      ? keyTakeawaysRaw
        .split(/\r?\n+|(?:^|\n)[•\-*]\s+/)
        .map((item) => item.replace(/^[•\-*]\s*/, "").trim())
        .filter((item) => item !== "")
      : [];

  // Icons cycle across the takeaway strip (eye / map / puzzle / checklist)
  const TAKEAWAY_ICONS = [
    VisibilityOutlinedIcon,
    ExploreOutlinedIcon,
    ExtensionOutlinedIcon,
    TaskAltOutlinedIcon,
  ];

  const isSpeakerAnimating = !isMuted && (isPlaying || isCurriculumAudioPlaying);

  // useEffect(() => {
  //   if (!currentWeek || !isEnrolled) return;

  //   const weekNum = Number(currentWeek?.week) || activeWeekIndex + 1;
  //   const progress = weekProgress[weekNum] ?? 0;

  //   // Only fire once per module, and only if there's a next module to go to
  //   if (
  //     progress >= 100 &&
  //     !shownCompletionRef.current.has(weekNum) &&
  //     activeWeekIndex < curriculum.length - 1
  //   ) {
  //     shownCompletionRef.current.add(weekNum);
  //     setCompletedModuleInfo({
  //       index: activeWeekIndex,
  //       title: currentWeek?.title?.replace(/\bweeks?\b/i, "Module") || `Module ${weekNum}`,
  //     });
  //     setModuleCompletePopup(true);
  //   }
  // }, [weekProgress, currentWeek, activeWeekIndex, curriculum.length, isEnrolled]);

  useEffect(() => {
    if (!isEnrolled) return;

    const prevMap = prevWeekProgressRef.current;

    Object.entries(weekProgress).forEach(([weekStr, pct]) => {
      const week = Number(weekStr);
      const prevPct = prevMap[week];

      const justCompletedNow = prevPct !== undefined && prevPct < 100 && pct >= 100;

      if (justCompletedNow) {
        const idx = curriculum.findIndex((w) => Number(w.week) === week);

        if (idx !== -1 && idx < curriculum.length - 1) {
          setCompletedModuleInfo({
            index: idx,
            title: curriculum[idx]?.title?.replace(/\bweeks?\b/i, "Module") || `Module ${week}`,
          });
          setModuleCompletePopup(true);
        }
      }
    });

    prevWeekProgressRef.current = { ...weekProgress };
  }, [weekProgress, isEnrolled, curriculum]);

  useEffect(() => {
    if (!showResult) return;
    if (!currentQuiz.length) return;

    const weekNumber =
      Number(currentWeek?.week) ||
      activeWeekIndex + 1;

    updateWeekProgress(
      weekNumber,
      100
    );
  }, [showResult]);

  // useEffect(() => {
  //   if (currentSpeechTypeRef.current !== "course") return;

  //   const latestWeek = selectedWeekData || currentWeek;
  //   if (!latestWeek) return;

  //   const weekSpeech = cleanTextForTTS(
  //     stripHtml(`
  //   Week ${activeWeekIndex + 1}
  //   ${latestWeek?.title || ""}
  //   ${latestWeek?.description || ""}
  //   ${latestWeek?.content || ""}
  //   `)
  //   );

  //   const chunks = splitText(weekSpeech);

  //   if (chunks[currentIndex]) {
  //     setCaptionText(chunks[currentIndex]);
  //   }
  // }, [currentIndex, activeWeekIndex, currentWeek, selectedWeekData]);

  const handleContinueToNextModule = () => {
    setModuleCompletePopup(false);
    getCourseProgress();
    /*  setSelectedSubtopic(null);
 
     if (curriculumAudioRef.current) {
       curriculumAudioRef.current.pause();
       curriculumAudioRef.current.currentTime = 0;
       curriculumAudioRef.current.src = "";
     }
 
     setActiveWeekIndex((p) => {
       const nextIndex = Math.min(p + 1, curriculum.length - 1);
       setSelectedSubtopic(null);
       setSelectedWeekData(curriculum[nextIndex]);
       return nextIndex;
     }); */
  };

  const getPartnerDetails = async () => {
    try {

      const response = await axios.get(
        `${apiUrl}/api/users/partners/details`,
        {
          params: {
            partner_name: (localStorage.getItem("partner_name") ||
              userDets?.partner)/* "GPA" */,
          },
        }
      );

      if (
        response.data?.status === "success" &&
        response.data?.data
      ) {
        const data = response.data.data;
        setGBAUserLogo(data.logo_url);
      }
    } catch (err) {
      console.log("Partner details not found", err);
    }
  };

  useEffect(() => {
    if ((localStorage.getItem("partner_name") /* === "GPA" */ || userDets?.partner /* === "GPA" */)) {
      getPartnerDetails();
    }
  }, []);

  /* console.log("chatMessages", chatMessages);
  console.log("length", chatMessages.length);
  console.log("loading", isChatBotLoading); */

  useEffect(() => {
    const handler = (e: any) => {
      setGBAUserLogo(e.detail.logo);
    };

    window.addEventListener("partner-logo-updated", handler);

    return () => {
      window.removeEventListener("partner-logo-updated", handler);
    };
  }, []);

  /* const openExamplePreview = (example: any, title: string) => {
    if (example === null || example === undefined || example === "") {
      return;
    }

    const formattedExample =
      typeof example === "string"
        ? example
        : JSON.stringify(example, null, 2);

    setSelectedExample(formattedExample);
    setSelectedExampleTitle(title || "Example");
    setExamplePreviewOpen(true);
  }; */

  const openExamplePreview = (subtopics: any[], moduleTitle: string) => {
    const examples: { title: string; content: string }[] = [];

    (subtopics || []).forEach((sub: any) => {
      const lessonExamples = Array.isArray(sub?.examples)
        ? sub.examples
        : Array.isArray(sub?.example)
          ? sub.example
          : [];

      lessonExamples.forEach((example: any) => {
        if (!example) return;

        const title =
          typeof example === "object"
            ? example?.title || "Example"
            : "Example";

        const content =
          typeof example === "object"
            ? example?.content || ""
            : String(example);

        if (title || content) {
          examples.push({
            title,
            content,
          });
        }
      });
    });

    if (!examples.length) return;

    setSelectedExamples(examples);
    setSelectedModuleTitle(moduleTitle || "");
    setExamplePreviewOpen(true);
  };

  const toggleExpandWeek = (wIndex: number) => {
    setExpandedWeeks((prev) => {
      if (prev.includes(wIndex)) {
        return prev.filter((i) => i !== wIndex);
      }
      // Only one module's subtopic list open at a time
      return [wIndex];
    });
  };

  /* const handlePlayModule = (wIndex: number) => {
    const selectedModule = curriculum[wIndex];

    if (!selectedModule) return;

    const isSameModule = activeWeekIndex === wIndex;
    const currentlyPlaying = isCurriculumAudioPlaying || isPlaying;

    // Clicking the pause icon on the ALREADY-ACTIVE, PLAYING module → pause it
    if (isSameModule && currentlyPlaying) {
      if (curriculumAudioRef.current) {
        curriculumAudioRef.current.pause();
      }
      if (audioRef.current) {
        audioRef.current.pause();
      }
      pause(); // stop the TTS stream's internal state too
      setIsCurriculumAudioPlaying(false);
      return;
    }

    // Clicking the play icon on the ALREADY-ACTIVE, PAUSED module → resume it
    if (isSameModule && !currentlyPlaying) {
      if (curriculumAudioRef.current && curriculumAudioRef.current.src) {
        curriculumAudioRef.current.play().catch(() => { });
        setIsCurriculumAudioPlaying(true);
        return;
      }
      if (audioRef.current) {
        resume();
        return;
      }
    }

    stopAllAudio();
    setShowCourseDefinition(false);
    setSelectedSubtopic(null);
    setActiveWeekIndex(wIndex);
    setSelectedWeekData(selectedModule);
  }; */

  const handlePlayModule = (wIndex: number) => {
    const selectedModule = curriculum[wIndex];

    if (!selectedModule) return;

    const isSameModule = activeWeekIndex === wIndex && !showCourseDefinition;
    const currentlyPlaying =
      isCurriculumAudioPlaying || isPlaying;

    // ─────────────────────────────────────
    // SAME MODULE + PLAYING → PAUSE
    // ─────────────────────────────────────
    if (isSameModule && currentlyPlaying) {
      if (curriculumAudioRef.current) {
        curriculumAudioRef.current.pause();
      }

      if (audioRef.current) {
        audioRef.current.pause();
      }

      pause();

      setIsCurriculumAudioPlaying(false);

      return;
    }

    // ─────────────────────────────────────
    // SAME MODULE + PAUSED → RESUME
    // ─────────────────────────────────────
    // if (isSameModule && !currentlyPlaying) {
    //   if (
    //     curriculumAudioRef.current &&
    //     curriculumAudioRef.current.src
    //   ) {
    //     curriculumAudioRef.current
    //       .play()
    //       .catch(() => { });

    //     setIsCurriculumAudioPlaying(true);

    //     return;
    //   }

    //   if (activeModuleAudioTypeRef.current === "tts" && audioRef.current) {
    //     resume();
    //     return;
    //   }

    //   // Fallback — shouldn't normally hit this, but keep old heuristic as a safety net
    //   if (curriculumAudioRef.current && curriculumAudioRef.current.src) {
    //     curriculumAudioRef.current.play().catch(() => {});
    //     setIsCurriculumAudioPlaying(true);
    //     return;
    //   }

    //   if (audioRef.current) {
    //     resume();
    //     return;
    //   }
    // }
    if (isSameModule && !currentlyPlaying) {
      if (
        activeModuleAudioTypeRef.current === "curriculum" &&
        curriculumAudioRef.current &&
        curriculumAudioRef.current.src
      ) {
        curriculumAudioRef.current.play().catch(() => { });
        setIsCurriculumAudioPlaying(true);
        return;
      }

      if (activeModuleAudioTypeRef.current === "tts" && audioRef.current) {
        resume();
        return;
      }

      // Fallback — only reached if activeModuleAudioTypeRef was never set
      // (shouldn't normally happen, but keep as a safety net)
      if (curriculumAudioRef.current && curriculumAudioRef.current.src) {
        curriculumAudioRef.current.play().catch(() => { });
        setIsCurriculumAudioPlaying(true);
        return;
      }

      if (audioRef.current) {
        resume();
        return;
      }
    }

    // ─────────────────────────────────────
    // DIFFERENT MODULE
    // Stop current audio and switch module
    // ─────────────────────────────────────

    stopAllAudio();

    isChatbotRequestRef.current = false;

    setShowCourseDefinition(false);
    setSelectedSubtopic(null);

    // Speaker click should also open that module's topics
    setExpandedWeeks([wIndex]);

    // Change active module/content
    setSelectedWeekData(selectedModule);
    setActiveWeekIndex(wIndex);

    setOpenChatBot(false);
    setIsLessonQuiz(false);
    setQuizOpen(false);
  };

  const fetchLessonQuizAnswers = async (
    weekNumber: number,
    quizLength: number
  ) => {
    if (!courseId || !studentId || !weekNumber) {
      return;
    }

    try {
      setIsQuizLoading(true);

      const response = await axios.get(
        `${apiUrl}/api/student/quiz-answers/${courseId}/${studentId}/${weekNumber}`
      );

      const data = response?.data;

      setIsQuizCompleted(data?.status === "completed");

      // console.log("Lesson quiz previous answers =>", data);

      if (!data || !Array.isArray(data.answers)) {
        setQuizAnswers({});
        setAnsweredQuestions(new Set());
        setQuizProgressPercentage(0);
        return;
      }

      const restoredAnswers: Record<
        number,
        {
          selected_answer: string;
          is_correct: boolean;
        }
      > = {};

      const restoredAnsweredQuestions = new Set<number>();

      data.answers.forEach((answer: any) => {
        const index = Number(answer.question_index);

        if (
          Number.isInteger(index) &&
          index >= 0 &&
          index < quizLength &&
          answer.selected_answer
        ) {
          restoredAnswers[index] = {
            selected_answer: answer.selected_answer,
            is_correct: Boolean(answer.is_correct),
          };

          restoredAnsweredQuestions.add(index);
        }
      });

      setQuizAnswers(restoredAnswers);
      setAnsweredQuestions(restoredAnsweredQuestions);

      setCorrectCount(Number(data.correct_answers ?? 0));

      setQuizProgressPercentage(
        Number(data.progress_percentage ?? 0)
      );

    } catch (error: any) {
      // 404/no previous quiz should NOT break the lesson quiz.
      console.log(
        "No previous lesson quiz answers found =>",
        error?.response?.data || error
      );

      setQuizAnswers({});
      setAnsweredQuestions(new Set());
      setCorrectCount(0);
      setQuizProgressPercentage(0);
      setIsQuizCompleted(false);

    } finally {
      setIsQuizLoading(false);
    }
  };

  const saveLessonQuizAnswers = async (
    latestAnswer?: {
      question_index: number;
      selected_answer: string;
      is_correct: boolean;
    }
  ) => {
    if (!courseId) {
      toast.error("Course information not found.");
      return false;
    }

    if (!studentId) {
      toast.error("Student information not found. Please log in again.");
      return false;
    }

    if (!currentQuiz.length) {
      toast.error("No quiz questions found.");
      return false;
    }

    try {
      setIsQuizSaving(true);

      const weekNumber =
        Number(currentWeek?.week) || activeWeekIndex + 1;

      const mergedQuizAnswers = {
        ...quizAnswers,
      };

      if (latestAnswer) {
        mergedQuizAnswers[latestAnswer.question_index] = {
          selected_answer: latestAnswer.selected_answer,
          is_correct: latestAnswer.is_correct,
        };
      }

      const answers = currentQuiz.map(
        (question: any, index: number) => {
          const savedAnswer = mergedQuizAnswers[index];

          return {
            question_index: index,
            selected_answer:
              savedAnswer?.selected_answer || "",
            is_correct:
              savedAnswer?.is_correct === true,
          };
        }
      );

      const answeredCount = answers.filter(
        (answer: any) =>
          answer.selected_answer &&
          answer.selected_answer.trim() !== ""
      ).length;

      const correctAnswers = answers.filter(
        (answer: any) => answer.is_correct
      ).length;

      const wrongAnswers =
        answeredCount - correctAnswers;

      const totalQuestions = currentQuiz.length;

      const progressPercentage =
        totalQuestions > 0
          ? Math.round(
            (correctAnswers / totalQuestions) * 100
          )
          : 0;

      const payload = {
        course_id: courseId,
        student_id: studentId,
        week: weekNumber,
        status: "completed",
        total_questions: totalQuestions,
        answered_questions: answeredCount,
        correct_answers: correctAnswers,
        wrong_answers: wrongAnswers,
        progress_percentage: progressPercentage,
        answers,
      };

      console.log(
        "Saving lesson quiz answers =>",
        payload
      );

      const response = await axios.post(
        `${apiUrl}/api/student/quiz-answers-save`,
        payload
      );

      console.log(
        "Lesson quiz save response =>",
        response?.data
      );

      if (response?.data?.success) {
        setCorrectCount(correctAnswers);
        setQuizProgressPercentage(progressPercentage);

        toast.success(
          "Quiz answers saved successfully"
        );

        return true;
      }

      toast.error(
        response?.data?.message ||
        "Failed to save quiz answers."
      );

      return false;

    } catch (error: any) {
      console.error(
        "Lesson quiz save error =>",
        error?.response?.data || error
      );

      toast.error(
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        "Failed to save quiz answers. Please try again."
      );

      return false;

    } finally {
      setIsQuizSaving(false);
    }
  };

  const handleLessonQuizAnswer = (
    questionIndex: number,
    answer: string
  ) => {
    const question = currentQuiz[questionIndex];

    if (!question) return;

    const isCorrect = answer === question.correct_answer;

    setSelectedAnswer(answer);

    setQuizAnswers((prev) => ({
      ...prev,
      [questionIndex]: {
        selected_answer: answer,
        is_correct: isCorrect,
      },
    }));
  };

  const openQuiz = async (weekIndex = activeWeekIndex) => {
    const quiz = curriculum[weekIndex]?.module_quiz || [];

    if (!quiz.length) {
      console.log("No quiz found for module:", weekIndex);
      return;
    }

    // Stop currently playing lesson/module audio
    stopAllAudio();

    isChatbotRequestRef.current = false;

    // Reset normal lesson state
    setShowCourseDefinition(false);
    setSelectedSubtopic(null);

    // Select the module whose quiz was clicked
    setSelectedWeekData(curriculum[weekIndex]);
    setActiveWeekIndex(weekIndex);

    // Reset lesson quiz UI state
    setCurrentQuizIndex(0);
    setSelectedAnswer(null);
    setCorrectCount(0);
    setShowResult(false);
    setQuizAnswers({});
    setAnsweredQuestions(new Set());
    setQuizProgressPercentage(0);

    // Enter lesson quiz mode
    setIsLessonQuiz(true);

    // Load previously saved answers for this module
    const weekNumber =
      Number(curriculum[weekIndex]?.week) || weekIndex + 1;

    await fetchLessonQuizAnswers(
      weekNumber,
      quiz.length
    );

    // Close chatbot
    setOpenChatBot(false);
  };

  const closeQuiz = () => {
    setIsLessonQuiz(false);
    setQuizOpen(false);

    setCurrentQuizIndex(0);
    setSelectedAnswer(null);
    setCorrectCount(0);
    setShowResult(false);

    setAnsweredQuestions(new Set());
    setQuizAnswers({});
    setQuizProgressPercentage(0);
    setIsQuizCompleted(false);
  };



  const buildLessonSpeech = (lesson: any) => {
    if (!lesson) return "";

    const parts: string[] = [];

    // 1. Lesson title
    if (lesson?.lesson_title) {
      parts.push(lesson.lesson_title);
    }

    // 2. Introduction
    if (lesson?.introduction) {
      parts.push(lesson.introduction);
    }

    // 3. Sections
    if (Array.isArray(lesson?.sections)) {
      lesson.sections.forEach((section: any) => {
        if (!section) return;

        const heading =
          section?.heading ||
          section?.title ||
          section?.section_title ||
          "";

        const content =
          section?.content ||
          section?.description ||
          "";

        if (heading) {
          parts.push(heading);
        }

        if (content) {
          parts.push(content);
        }
      });
    }

    // 4. Examples
    const examples = Array.isArray(lesson?.examples)
      ? lesson.examples
      : Array.isArray(lesson?.example)
        ? lesson.example
        : [];

    if (examples.length > 0) {
      parts.push("Example");   //  NEW — spoken once, before all examples
    }

    examples.forEach((example: any, index: number) => {
      if (!example) return;

      //  NEW — numbered label before each example
      parts.push(examples.length > 1 ? `Example ${index + 1}` : "Example");


      const title =
        typeof example === "object"
          ? example?.title || ""
          : "";

      const content =
        typeof example === "object"
          ? example?.content || ""
          : String(example);

      if (title) {
        parts.push(title);
      }

      if (content) {
        parts.push(content);
      }
    });

    // 5. Key takeaways
    const takeaways = Array.isArray(lesson?.key_takeaways)
      ? lesson.key_takeaways
      : typeof lesson?.key_takeaways === "string"
        ? lesson.key_takeaways
          .split(/\r?\n+/)
          .map((item: string) => item.trim())
          .filter(Boolean)
        : [];

    if (takeaways.length > 0) {
      parts.push("Key Takeaways");   //  NEW — spoken once, before the list
    }

    takeaways.forEach((takeaway: any) => {
      if (typeof takeaway === "string" && takeaway.trim()) {
        parts.push(takeaway.trim());
      }
    });

    return cleanTextForTTS(
      stripHtml(parts.join("\n\n"))
    );
  };


  const buildWeekSpeech = (week: any, weekIndexForLabel: number) => {
    return cleanTextForTTS(
      stripHtml(`
      Week ${weekIndexForLabel + 1}
      ${week?.title || ""}
      ${week?.description || ""}
      ${week?.content || ""}
      `)
    );
  };


  const lessonHasPrerenderedAudio = (lesson: any) => {
    const audio = lesson?.audio_path || "";
    const segments = lesson?.segments || [];
    return audio.trim() !== "" && Array.isArray(segments) && segments.length > 0;
  };

  const getLessonCacheKey = (weekNumber: number, lesson: any) => {
    const id =
      lesson?._id ?? lesson?.id ?? lesson?.lesson_id ?? lesson?.lesson_title ?? "";
    return `lesson-${weekNumber}-${id}`;
  };


  const maybePrefetchLesson = (weekNumber: number, lesson: any) => {
    if (!lesson) return;
    if (lessonHasPrerenderedAudio(lesson)) return; // WAV lesson — nothing to generate

    const speech = buildLessonSpeech(lesson);
    if (!speech) return;

    prefetchText(getLessonCacheKey(weekNumber, lesson), speech);
  };

  // ─────────────────────────────────────────────
  // LESSON AUDIO — reads the selected lesson's own
  // fields (title, introduction, key takeaways) as
  // soon as a subtopic is picked from the sidebar.
  // ─────────────────────────────────────────────
  useEffect(() => {
    if (!selectedSubtopic) return;

    if (isChatbotRequestRef.current) return;

    let isCancelled = false;

    /*  const playLessonContent = async () => {
       stopAllAudio();
 
       if (isCancelled) return;
 
       const lessonSpeech = cleanTextForTTS(
         stripHtml(`
 ${selectedSubtopic?.lesson_title || ""}
 ${selectedSubtopic?.introduction || ""}
 ${keyTakeaways.length ? keyTakeaways.join(". ") : ""}
 `)
       );
 
       if (!lessonSpeech || isCancelled) return;
 
       currentSpeechTypeRef.current = "lesson";
       setCaptionText(lessonSpeech);
 
       await playText(lessonSpeech);
     }; */

    // Once this lesson finishes reading, auto-move to the next lesson in
    // the same module. If this was the last lesson, auto-open the module
    // quiz.


    const goToNextLessonOrQuiz = async () => {
      if (isCancelled) return;

      const week = selectedWeekData || curriculum[activeWeekIndex];
      const weekNumber = Number(week?.week) || activeWeekIndex + 1;
      const subtopics = week?.subtopics || [];

      const idx = subtopics.findIndex(
        (s: any) => s?.lesson_title === selectedSubtopic?.lesson_title
      );


      // NEW — this lesson's share of the 80% lesson pool
      if (idx !== -1 && subtopics.length > 0) {
        const lessonKey = `${weekNumber}-${idx}`;
        if (!lessonProgressAddedRef.current.has(lessonKey)) {
          lessonProgressAddedRef.current.add(lessonKey);
          const perLessonPercent = 80 / subtopics.length;
          addWeekProgress(weekNumber, perLessonPercent);
        }
      }

      const nextLesson = idx !== -1 ? subtopics[idx + 1] : undefined;

      if (nextLesson) {
        setSelectedWeekData(week);
        setSelectedSubtopic(nextLesson);
        return;
      }

      // Last lesson in this module — move on to the module quiz, if any.
      if ((week?.module_quiz || []).length > 0) {
        openQuiz(activeWeekIndex);
      }
    };

    const playLessonContent = async () => {
      stopAllAudio();

      if (isCancelled) return;

      currentSpeechTypeRef.current = "lesson";

      const week = selectedWeekData || curriculum[activeWeekIndex];
      const weekNumber = Number(week?.week) || activeWeekIndex + 1;
      const subtopics = week?.subtopics || [];
      const idx = subtopics.findIndex(
        (s: any) => s?.lesson_title === selectedSubtopic?.lesson_title
      );
      const nextLesson = idx !== -1 ? subtopics[idx + 1] : undefined;

      // NEW — start generating the NEXT lesson's audio now, regardless
      // of whether THIS lesson plays via WAV or TTS.
      maybePrefetchLesson(weekNumber, nextLesson);

      // PRIORITY 1 → subtopic audio_path + segments
      const lessonAudio = selectedSubtopic?.audio_path || "";
      const lessonSegments = selectedSubtopic?.segments || [];

      const playedFromAudio = await playAudioWithSegments(
        lessonAudio,
        lessonSegments
      );

      if (playedFromAudio) {
        activeModuleAudioTypeRef.current = "curriculum";
        goToNextLessonOrQuiz();
        return;
      }

      if (isCancelled) return;

      // FALLBACK → chunk-based TTS
      /* const lessonSpeech = cleanTextForTTS(
        stripHtml(`
${selectedSubtopic?.lesson_title || ""}
${selectedSubtopic?.introduction || ""}
${keyTakeaways.length ? keyTakeaways.join(". ") : ""}
`)
      ); */
      const lessonSpeech = buildLessonSpeech(selectedSubtopic);

      if (!lessonSpeech || isCancelled) {
        goToNextLessonOrQuiz();
        return;
      }

      // setCaptionText(lessonSpeech);
      const lessonChunks = splitText(lessonSpeech);

      if (lessonChunks.length > 0) {
        setCaptionText(lessonChunks[0]);
      }

      // NEW — reuse whatever the module-level prefetch already generated
      const cacheKey = getLessonCacheKey(weekNumber, selectedSubtopic);

      activeModuleAudioTypeRef.current = "tts";

      //await playText(lessonSpeech);
      await playText(
        lessonSpeech,
        undefined,
        undefined, // no progress tracking needed for lessons currently — pass undefined, not omitted, since onChunkStart is the 4th positional param
        (chunkIndex, totalChunks, chunkText) => {
          setCaptionText(chunkText);
        },
        cacheKey
      );

      goToNextLessonOrQuiz();
    };

    playLessonContent();

    return () => {
      isCancelled = true;
    };
  }, [selectedSubtopic]);


  //   useEffect(() => {
  //     if (!selectedSubtopic) return;

  //     // Only update subtitles for lesson chunk-based TTS.
  //     // When DB audio_path exists, playAudioWithSegments()
  //     // controls the captions instead.
  //     const lessonAudio = selectedSubtopic?.audio_path || "";
  //     const lessonSegments = selectedSubtopic?.segments || [];

  //     if (
  //       lessonAudio.trim() !== "" &&
  //       Array.isArray(lessonSegments) &&
  //       lessonSegments.length > 0
  //     ) {
  //       return;
  //     }

  //     const lessonSpeech = cleanTextForTTS(
  //       stripHtml(`
  // ${selectedSubtopic?.lesson_title || ""}
  // ${selectedSubtopic?.introduction || ""}
  // ${keyTakeaways.length ? keyTakeaways.join(". ") : ""}
  // `)
  //     );

  //     const lessonChunks = splitText(lessonSpeech);

  //     if (lessonChunks[currentIndex]) {
  //       setCaptionText(lessonChunks[currentIndex]);
  //     }
  //   }, [
  //     currentIndex,
  //     selectedSubtopic,
  //     keyTakeaways,
  //   ]);

  // ─────────────────────────────────────────────
  // QUIZ AUDIO — reads just the current question,
  // re-fires whenever the quiz opens or the user
  // moves to the next/previous question.
  // ─────────────────────────────────────────────
  useEffect(() => {
    if (!isLessonQuiz) return;

    if (!currentQuestion?.question) return;

    let isCancelled = false;

    const playQuizQuestion = async () => {
      stopAllAudio();

      if (isCancelled) return;

      const questionSpeech = cleanTextForTTS(
        stripHtml(currentQuestion.question)
      );

      if (!questionSpeech || isCancelled) return;

      currentSpeechTypeRef.current = "quiz";
      activeModuleAudioTypeRef.current = "tts";
      setCaptionText(questionSpeech);

      await playText(questionSpeech);
    };

    playQuizQuestion();

    return () => {
      isCancelled = true;
    };
  }, [isLessonQuiz, currentQuizIndex, currentQuestion?.question]);

  // ─────────────────────────────────────────────
  // COURSE OVERVIEW AUDIO — reads the course
  // definition (title + description) when the
  // "Overview" entry is opened.
  // ─────────────────────────────────────────────
  useEffect(() => {
    if (!showCourseDefinition || !courseDefinition || introVideoOpen) return;

    let isCancelled = false;


    // Once the course-definition narration finishes, auto-move into
    // Module 1 (same as clicking Module 1 in the sidebar).
    const goToFirstModule = () => {
      if (isCancelled) return;
      if (!curriculum?.length) return;

      setShowCourseDefinition(false);
      setSelectedSubtopic(null);
      setExpandedWeeks([0]);
      setSelectedWeekData(curriculum[0]);
      setActiveWeekIndex(0);
    };

    const playOverview = async () => {
      stopAllAudio();

      if (isCancelled) return;

      currentSpeechTypeRef.current = "overview";
      activeModuleAudioTypeRef.current = "tts";
      // PRIORITY 1 → pre-rendered course_definition audio + segments
      const overviewAudio =
        completeCourseDet?.course_definition_audio_path || "";
      const overviewSegments =
        completeCourseDet?.course_definition_audio_segments || [];

      const playedFromAudio = await playAudioWithSegments(
        overviewAudio,
        overviewSegments
      );

      if (playedFromAudio) {
        activeModuleAudioTypeRef.current = "curriculum";
        goToFirstModule();
        return;
      }

      if (isCancelled) return;

      // FALLBACK → chunk-based TTS (field missing/empty)
      const overviewSpeech = cleanTextForTTS(
        stripHtml(`
${courseDefinition?.title || ""}
${courseDefinition?.description || ""}
`)
      );

      if (!overviewSpeech || isCancelled) {
        goToFirstModule();
        return;
      }

      setCaptionText(overviewSpeech);

      await playText(overviewSpeech);

      goToFirstModule();
    };

    playOverview();

    return () => {
      isCancelled = true;
      stopAllAudio();
    };
  }, [showCourseDefinition, courseDefinition, completeCourseDet, curriculum, introVideoOpen]);

  const selectLessonQuizQuestion = (index: number) => {
    setCurrentQuizIndex(index);

    const savedAnswer = quizAnswers[index];

    setSelectedAnswer(
      savedAnswer?.selected_answer || null
    );
  };

  useEffect(() => {
    if (!isLessonQuiz) return;

    const savedAnswer = quizAnswers[currentQuizIndex];

    setSelectedAnswer(
      savedAnswer?.selected_answer || null
    );
  }, [
    isLessonQuiz,
    currentQuizIndex,
    quizAnswers,
  ]);

  const cleanExampleTitle = (title: string) => {
    return String(title || "")
      .replace(/^Example\s*(?:\d+)?\s*:\s*/i, "")
      .trim();
  };

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          // overflow: isMobile ? 'auto' : "hidden",
          overflow: 'visible',
          display: "flex",
          flexDirection: "column",
        }}
      >
        <style>{`
            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
            .course-detail-root, .course-detail-root * { 
                font-family: 'Inter', sans-serif !important; 
            }
        `}</style>
        {/* ── Header ───────────────────────────────────────────────────────────── */}
        <div className="container" style={{ minHeight: '88px', flexShrink: 0 }}>
          <div className="row">
            <nav className="navbar navbar-expand-md">
              <div className="container-fluid">
                <a className="navbar-brand" href="/" style={{ width: "5%" }}>
                  <img
                    src={OceshaLogo}
                    className="img-fluid"
                    alt=""
                    style={{ width: "60%"/* "95%" */ }}
                  />
                </a>
                {((localStorage.getItem("partner_name") /* === "GPA" */ ||
                  userDets?.partner /* === "GPA" */) && GBAUserLogo) && (
                    <img
                      src={GBAUserLogo}
                      className="img-fluid"
                      alt="GBA Logo"
                      style={{ height: "64px", maxHeight: "64px", width: "auto", objectFit: "contain" }}
                    />
                  )}
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarScroll"
                  aria-controls="navbarScroll"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="">
                    <i className="bi bi-list text-white" />
                  </span>
                </button>
                <div className="collapse navbar-collapse justify-content-end" id="navbarScroll">
                  {/* <ul className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll ms-md-5 gap-4">
                  <li className="nav-item">
                    <a
                      className="nav-link nav_active"
                      style={{ color: "#4ba5eb", fontWeight: 800 }}
                      href="/"
                    >
                      Home
                    </a>
                  </li>
                  <li
                    className="nav-item"
                    onClick={() => {
                      localStorage.setItem("pricing_from_landing", "true");
                      navigate("/pricing");
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <a className="nav-link nav_simple">Pricing</a>
                  </li>
                  <li
                    className="nav-item"
                    onClick={() => {
                      navigate("/contactus");
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <a className="nav-link nav_simple">Contact</a>
                  </li>
                  <li
                    className="nav-item"
                    onClick={() => {
                      window.open(`/blogs?userid=${supportUserid}`, "_blank");
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <a className="nav-link nav_simple">Blogs</a>
                  </li>
                  <li
                    className="nav-item"
                    onClick={() => navigate("/aboutus")}
                    style={{ cursor: "pointer" }}
                  >
                    <a className="nav-link nav_simple">About Us</a>
                  </li>
                  <li
                    className="nav-item"
                    onClick={() => navigate("/codegenie/creator-directory")}
                    style={{ cursor: "pointer" }}
                  >
                    <a className="nav-link nav_simple">Creator Directory</a>
                  </li>
                  <li
                    className="nav-item"
                    onClick={() => navigate("/codegenie/courses-directory")}
                    style={{ cursor: "pointer" }}
                  >
                    <a className="nav-link nav_simple" style={{ color: "#4ba5eb", fontWeight: 700 }}>Courses Directory</a>
                  </li>
                </ul> */}
                  {loggedIn === "true" ? (
                    <div className="d-flex gap-4" role="search">

                      <button
                        className="button_leniar px-3"
                        type="button"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "4px",
                        }}
                        onClick={() => {
                          stopAllAudio();

                          if (isNewTab) {
                            window.close();
                          } else {
                            window.history.back();
                          }
                        }}
                      >
                        {isNewTab ? <CloseIcon /> : <NavigateBeforeIcon />}
                        {isNewTab ? "Close" : "Go Back"}
                      </button>
                    </div>
                  ) : (
                    <div className="d-flex gap-4" role="search">
                      {/* <button
                        className="btn btn-outline-primary px-3"
                        onClick={() => {
                          if (localStorage.getItem("logged_in") === "true") {
                            localStorage.setItem("activeItem", "blogs");
                            navigate("/codegenie/generated-blogs");
                          } else {
                            navigate("/signin");
                          }
                        }}
                      >
                        Sign In
                      </button>
                      <button
                        className="button_leniar px-3"
                        type="submit"
                        onClick={() => {
                          navigate("/signup");
                        }}
                      >
                        Sign Up
                      </button> */}
                    </div>
                  )}
                </div>
              </div>
            </nav>
            <hr className="mt-1" style={{ color: "#9aa0a3" }} />
          </div>
        </div>



        {/* ── Main Content ──────────────────────────────────────────────────────── */}
        <Box
          className="overlay-container"
          sx={{
            pr: 0, pl: 2,/* px: { xs: 2, md: 3 }, */ /* minHeight: "100vh", */ backgroundColor: '#fff !important', flex: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
          }}
        >



          <Grid container columnSpacing={2} rowSpacing={3}/* spacing={3} */ sx={{
            /* px: {
              xs: 2,
              md: 4,
              lg: 4,
            }, */
            /* background: "rgba(255, 255, 255, 0.04)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255,255,255,0.06)", */
            pb: 2,
            pr: 2,
            // background: "rgba(245, 245, 245, 0.06)",
            background: '#fff',
            backdropFilter: "blur(12px)",
            border: "1px solid rgba(180, 180, 180, 0.12)",
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
            borderRadius: '10px',
            // minHeight: 0/* isMobile ?  *//* '100%' */ /* : "calc(100vh - 65px)" */,
            overflow: "visible",
            alignItems: "stretch",
            // flex: 1,
            display: 'flex'
          }}>

            {isMobile && (
              <Grid item xs={12} md={12} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                {/* menu icon */}
                {!isCourseContentsOpen && (
                  <IconButton
                    onClick={() => setIsCourseContentsOpen(true)}
                    sx={{
                      mt: 0.3,
                      width: 40,
                      height: 40,
                      bgcolor: "#fff",
                      border: "1px solid #E5E7EB",
                      boxShadow: 1,
                    }}
                  >
                    <MenuIcon sx={{ color: "#000" }} />
                  </IconButton>
                )}
                {/* end menu icon */}

                {/* chat icon */}
                {!isConversationOpen && (
                  <IconButton
                    onClick={() => setIsConversationOpen(true)}
                    sx={{
                      mt: 0.3,
                      width: 40,
                      height: 40,
                      bgcolor: "#fff",
                      border: "1px solid #E5E7EB",
                      boxShadow: 1,
                    }}
                  >
                    <TextsmsOutlinedIcon sx={{ color: "#000" }} />
                  </IconButton>
                )}
                {/* end chat icon */}
              </Grid>)}

            {/* LEFT PANEL */}
            {isCourseContentsOpen && (
              <Grid item xs={12} md={isCourseContentsOpen ? 2.5 : 0}
                sx={{
                  overflow: "hidden",
                  transition: "all .35s ease",
                  display: isCourseContentsOpen ? "flex" : "none",
                  flexDirection: "column",                            // NEW
                  alignItems: 'stretch',
                  // height: "100%",                                      // NEW
                  minHeight: 0,
                  contain: { md: "size" },                                         // NEW — critical fix
                }}>
                <Paper
                  sx={{
                    p: 0,
                    borderRadius: "10px",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #E5E7EB",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
                    // overflow: "hidden",
                    // height: {
                    //   xs: 420,
                    //   md: 638,
                    // },
                    height: "100%",
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Stack spacing={1.5} sx={{ height: "100%", minHeight: 0, display: "flex", flexDirection: "column" }}>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{
                        px: 2,
                        pt: 2,
                        pb: 1.5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "15px",
                          fontWeight: 600,
                          color: "#111827",
                        }}
                      >
                        Course contents
                      </Typography>

                      {/* <IconButton
                        size="small"
                        onClick={() => setIsCourseContentsOpen(false)}
                        sx={{
                          width: 26,
                          height: 26,
                          backgroundColor: "#F5F5F5",

                          "&:hover": {
                            backgroundColor: "#EAEAEA",
                          },
                        }}
                      >
                        <CloseIcon
                          sx={{
                            fontSize: 16,
                            color: "#374151",
                          }}
                        />
                      </IconButton> */}
                    </Stack>

                    <Box
                      sx={{
                        // maxHeight: "100vh",
                        // maxHeight: {
                        //   xs: 350,
                        //   md: 420,
                        //   lg: 480,
                        // },
                        flex: 1,
                        minHeight: 0,
                        overflowY: "auto",
                        pr: 1,

                        // mild scrollbar
                        "&::-webkit-scrollbar": {
                          width: "5px",
                        },

                        "&::-webkit-scrollbar-track": {
                          background: "transparent",
                        },

                        "&::-webkit-scrollbar-thumb": {
                          background: "rgba(0,0,0,0.18)",
                          borderRadius: "10px",
                        },

                        "&::-webkit-scrollbar-thumb:hover": {
                          background: "rgba(0,0,0,0.3)",
                        },

                        scrollbarColor: "rgba(0,0,0,0.18) transparent",

                        scrollbarWidth: "thin"
                      }}
                    >
                      <Stack spacing={4.3}>
                        {loadingCourse ? (
                          <Stack spacing={1.5}>
                            {[1, 2, 3, 4, 5].map((i) => (
                              <Box key={i}>
                                <Skeleton
                                  variant="rectangular"
                                  height={80}
                                  sx={{
                                    borderRadius: "8px",
                                    bgcolor: "#F3F4F6",
                                  }}
                                />
                              </Box>
                            ))}
                          </Stack>
                        ) : (
                          <>
                            {/* Overall Course Progress */}
                            {isEnrolled && (<Box
                              sx={{
                                px: 2,
                                pb: 2,
                                borderBottom: "1px solid #E5E7EB",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: 600,
                                  color: "#374151",
                                  mb: 1.2,
                                }}
                              >
                                Module {activeWeekIndex + 1} of {curriculum.length} in progress
                              </Typography>

                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={1}
                              >
                                <LinearProgress
                                  variant="determinate"
                                  /* value={
                                    curriculum.length > 0
                                      ? ((activeWeekIndex + 1) / curriculum.length) * 100
                                      : 0
                                  } */
                                  value={overallCompletionPercentage}
                                  sx={{
                                    flex: 1,
                                    height: 5,
                                    borderRadius: "10px",
                                    backgroundColor: "#E5E7EB",

                                    "& .MuiLinearProgress-bar": {
                                      borderRadius: "10px",
                                      backgroundColor: "#2563EB",
                                    },
                                  }}
                                />

                                <Typography
                                  sx={{
                                    fontSize: "10px",
                                    fontWeight: 500,
                                    color: "#6B7280",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {/* {Math.round(
                                    curriculum.length > 0
                                      ? ((activeWeekIndex + 1) / curriculum.length) * 100
                                      : 0
                                  )} */}{Math.round(overallCompletionPercentage)}
                                  % Complete
                                </Typography>
                              </Stack>
                            </Box>)}

                            {/* Modules */}
                            <Stack spacing={0}>
                              {/* Introduction Video */}
                              {/* <Box
                                sx={{
                                  position: "relative",
                                  mb: 1,
                                  borderLeft: "2px solid transparent",
                                  borderRadius: "0 6px 6px 0",
                                  transition: "all 0.2s ease",
                                  "&:hover": {
                                    backgroundColor: "#FAFAFA",
                                  },
                                }}
                              >
                                <Box
                                  sx={{
                                    px: 1.2,
                                    py: 1.2,
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    stopAllAudio();
                                    setIntroVideoOpen(true);
                                  }}
                                >
                                  <Stack
                                    direction="row"
                                    alignItems="flex-start"
                                    sx={{ width: "100%" }}
                                  >
                                    <PlayCircleOutlineIcon
                                      sx={{
                                        fontSize: 24,
                                        color: "#6B7280",
                                        mr: 1.5,
                                        flexShrink: 0,
                                      }}
                                    />
                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                      <Typography
                                        sx={{
                                          fontSize: "12px",
                                          fontWeight: 500,
                                          color: "#111827",
                                          lineHeight: 1.3,
                                          mb: 0.35,
                                        }}
                                      >
                                        Introduction Video
                                      </Typography>

                                      <Typography
                                        sx={{
                                          fontSize: "11px",
                                          fontWeight: 400,
                                          color: "#111827",
                                          lineHeight: 1.45,
                                          maxWidth: "220px",
                                        }}
                                      >
                                        A quick video overview before you dive in
                                      </Typography>
                                    </Box>

                                    <ChevronRightIcon
                                      sx={{
                                        fontSize: 22,
                                        color: "#6B7280",
                                        ml: 1,
                                        flexShrink: 0,
                                      }}
                                    />
                                  </Stack>
                                </Box>
                              </Box> */}
                              {introVideoUrl && (<Box
                                sx={{
                                  position: "relative",
                                  mb: 1,
                                  borderLeft: introVideoOpen
                                    ? "2px solid #2563EB"
                                    : "2px solid transparent",
                                  backgroundColor: introVideoOpen ? "#F3F8FF" : "transparent",
                                  borderRadius: "0 6px 6px 0",
                                  transition: "all 0.2s ease",
                                  "&:hover": {
                                    backgroundColor: introVideoOpen ? "#F3F8FF" : "#FAFAFA",
                                  },
                                }}
                              >
                                <Box
                                  sx={{
                                    px: 1.2,
                                    py: 1.2,
                                    cursor: "pointer",
                                  }}
                                  /* onClick={() => {
                                    stopAllAudio();
                                    setIntroVideoOpen(true);
                                  }} */
                                  onClick={() => {
                                    savePlaybackStateBeforeChat(); // captures current audio type + position
                                    if (curriculumAudioRef.current) {
                                      curriculumAudioRef.current.pause(); // pause only, don't reset time/src
                                    }
                                    stopAll(); // stop the TTS queue
                                    setIntroVideoOpen(true);
                                  }}
                                >
                                  <Stack
                                    direction="row"
                                    alignItems="flex-start"
                                    sx={{ width: "100%" }}
                                  >
                                    {/* File Icon */}
                                    <PlayCircleOutlineIcon
                                      sx={{
                                        fontSize: 24,
                                        color: introVideoOpen ? "#2563EB" : "#6B7280",
                                        mr: 1.5,
                                        flexShrink: 0,
                                      }}
                                    />

                                    {/* Content */}
                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                      <Typography
                                        sx={{
                                          fontSize: "12px",
                                          fontWeight: introVideoOpen ? 600 : 500,
                                          color: introVideoOpen ? "#2563EB" : "#111827",
                                          lineHeight: 1.3,
                                          mb: 0.35,
                                        }}
                                      >
                                        Introduction Video
                                      </Typography>

                                      <Typography
                                        sx={{
                                          fontSize: "11px",
                                          fontWeight: 400,
                                          color: "#111827",
                                          lineHeight: 1.45,
                                          maxWidth: "220px",
                                        }}
                                      >
                                        A quick video overview before you dive in
                                      </Typography>
                                    </Box>

                                    {/* Right Arrow */}
                                    <ChevronRightIcon
                                      sx={{
                                        fontSize: 22,
                                        color: introVideoOpen ? "#2563EB" : "#6B7280",
                                        ml: 1,
                                        flexShrink: 0,
                                      }}
                                    />
                                  </Stack>
                                </Box>
                              </Box>)}
                              {/* Course Definition */}
                              <Box
                                sx={{
                                  position: "relative",
                                  mb: 1,
                                  borderLeft: showCourseDefinition && !introVideoOpen
                                    ? "2px solid #2563EB"
                                    : "2px solid transparent",
                                  backgroundColor: showCourseDefinition && !introVideoOpen ? "#F3F8FF" : "transparent",
                                  borderRadius: "0 6px 6px 0",
                                  transition: "all 0.2s ease",
                                  "&:hover": {
                                    backgroundColor: showCourseDefinition && !introVideoOpen ? "#F3F8FF" : "#FAFAFA",
                                  },
                                }}
                              >
                                <Box
                                  sx={{
                                    px: 1.2,
                                    py: 1.2,
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    stopAllAudio();
                                    isChatbotRequestRef.current = false;

                                    setSelectedSubtopic(null);
                                    setIsLessonQuiz(false);
                                    setQuizOpen(false);

                                    setExpandedWeeks([]);
                                    setOpenChatBot(false);
                                    setShowCourseDefinition(true);
                                  }}
                                >
                                  <Stack
                                    direction="row"
                                    alignItems="flex-start"
                                    sx={{ width: "100%" }}
                                  >
                                    {/* File Icon */}
                                    <DescriptionOutlinedIcon
                                      sx={{
                                        fontSize: 24,
                                        color: showCourseDefinition && !introVideoOpen ? "#2563EB" : "#6B7280",
                                        mr: 1.5,
                                        flexShrink: 0,
                                      }}
                                    />

                                    {/* Content */}
                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                      <Typography
                                        sx={{
                                          fontSize: "12px",
                                          fontWeight: showCourseDefinition && !introVideoOpen ? 600 : 500,
                                          color: showCourseDefinition && !introVideoOpen ? "#2563EB" : "#111827",
                                          lineHeight: 1.3,
                                          mb: 0.35,
                                        }}
                                      >
                                        Course Definition
                                      </Typography>

                                      <Typography
                                        sx={{
                                          fontSize: "11px",
                                          fontWeight: 400,
                                          color: "#111827",
                                          lineHeight: 1.45,
                                          maxWidth: "220px",
                                        }}
                                      >
                                        Overview, audience, objectives, and what you'll achieve
                                      </Typography>
                                    </Box>

                                    {/* Right Arrow */}
                                    <ChevronRightIcon
                                      sx={{
                                        fontSize: 22,
                                        color: showCourseDefinition && !introVideoOpen ? "#2563EB" : "#6B7280",
                                        ml: 1,
                                        flexShrink: 0,
                                      }}
                                    />
                                  </Stack>
                                </Box>
                              </Box>
                              {curriculum.map((weekItem, wIndex) => {
                                const isLocked = isOwnCourse
                                  ? false
                                  : loggedIn !== "true"
                                    ? wIndex > 0
                                    : !isEnrolled;

                                /* const totalSubtopics =
                                  weekItem.subtopics?.length || 0;

                                const completedSubtopics =
                                  weekItem.completed_subtopics ?? 0;

                                const progressPercent =
                                  totalSubtopics > 0
                                    ? Math.round(
                                      (completedSubtopics / totalSubtopics) * 100
                                    )
                                    : 0; */
                                const progressPercent =
                                  weekProgress[Number(weekItem.week)] ?? 0;


                                const isExpanded =
                                  expandedWeeks.includes(wIndex);

                                const isActive =
                                  wIndex === activeWeekIndex && !showCourseDefinition && !introVideoOpen;;

                                return (
                                  <Box
                                    key={weekItem.week}
                                    sx={{
                                      position: "relative",

                                      /* Active module left blue line */
                                      borderLeft: isActive
                                        ? "2px solid #2563EB"
                                        : "2px solid transparent",

                                      backgroundColor: isActive
                                        ? "#F3F8FF"
                                        : "transparent",

                                      borderRadius: "0 6px 6px 0",

                                      transition: "all 0.2s ease",

                                      "&:hover": {
                                        backgroundColor: isActive
                                          ? "#F3F8FF"
                                          : "#FAFAFA",
                                      },
                                    }}
                                  >
                                    {/* Module Header */}
                                    <Tooltip
                                      title={
                                        isLocked
                                          ? "Complete enrollment to access this module"
                                          : isExpanded
                                            ? "Click to collapse module"
                                            : "Click to expand module"
                                      }
                                      placement="top"
                                      arrow
                                      enterDelay={400}
                                    >
                                      <Box
                                        sx={{
                                          px: 1.2,
                                          py: 1.4,
                                          cursor: isLocked
                                            ? "not-allowed"
                                            : "pointer",
                                        }}
                                        onClick={() => {
                                          if (isLocked) {
                                            if (loggedIn !== "true") {
                                              setLoginPopup(true);
                                            } else {
                                              setEnrollPopup(true);
                                            }

                                            return;
                                          }

                                          /* isChatbotRequestRef.current = false;
                                          setSelectedSubtopic(null);
                                          setShowCourseDefinition(false);
                                          setSelectedWeekData(weekItem);
                                          setActiveWeekIndex(wIndex);
                                          setOpenChatBot(false);
  
                                          setIsLessonQuiz(false);
                                          setQuizOpen(false); */

                                          toggleExpandWeek(wIndex);

                                        }}
                                      >
                                        <Stack
                                          direction="row"
                                          spacing={1}
                                          alignItems="flex-start"
                                        >
                                          {/* Module Number */}
                                          <Box
                                            sx={{
                                              width: 20,
                                              height: 20,
                                              minWidth: 20,

                                              borderRadius: "50%",

                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",

                                              mt: "1px",

                                              border: isActive
                                                ? "none"
                                                : "1px solid #6B7280",

                                              backgroundColor: isActive
                                                ? "#2563EB"
                                                : "#FFFFFF",

                                              color: isActive
                                                ? "#FFFFFF"
                                                : "#374151",

                                              fontSize: "11px",
                                              fontWeight: 600,
                                            }}
                                          >
                                            {wIndex + 1}
                                          </Box>

                                          {/* Module Content */}
                                          <Box
                                            sx={{
                                              flex: 1,
                                              minWidth: 0,
                                            }}
                                          >
                                            <Stack
                                              direction="row"
                                              alignItems="flex-start"
                                              justifyContent="space-between"
                                              spacing={0.5}
                                            >
                                              <Typography
                                                sx={{
                                                  fontSize: "12px",
                                                  lineHeight: 1.45,
                                                  fontWeight: isActive
                                                    ? 600
                                                    : 500,

                                                  color: isActive
                                                    ? "#2563EB"
                                                    : "#111827",

                                                  pr: 0.5,
                                                  textAlign: 'left'
                                                }}
                                              >
                                                Module {weekItem.week}
                                                <br />
                                                {weekItem.title?.replace(/\bweeks?\b/i, "Module")}
                                              </Typography>

                                              {/* Chevron */}
                                              {isExpanded ? (
                                                <KeyboardArrowUpIcon
                                                  sx={{
                                                    fontSize: 18,
                                                    color: isActive
                                                      ? "#2563EB"
                                                      : "#6B7280",
                                                    flexShrink: 0,
                                                    mt: "1px",
                                                  }}
                                                />
                                              ) : (
                                                <KeyboardArrowDownIcon
                                                  sx={{
                                                    fontSize: 18,
                                                    color: isActive
                                                      ? "#2563EB"
                                                      : "#6B7280",
                                                    flexShrink: 0,
                                                    mt: "1px",
                                                  }}
                                                />
                                              )}
                                            </Stack>

                                            {/* Module Progress */}
                                            {isEnrolled && (<Stack
                                              direction="row"
                                              alignItems="center"
                                              spacing={0.8}
                                              sx={{
                                                mt: 1,
                                              }}
                                            >
                                              <LinearProgress
                                                variant="determinate"
                                                value={progressPercent}
                                                sx={{
                                                  flex: 1,

                                                  height: 4,

                                                  borderRadius: "10px",

                                                  backgroundColor: "#E5E7EB",

                                                  "& .MuiLinearProgress-bar": {
                                                    borderRadius: "10px",
                                                    backgroundColor: progressPercent > 0 ? "#2563EB" : "#D1D5DB",
                                                  },
                                                }}
                                              />

                                              <Typography
                                                sx={{
                                                  fontSize: "9px",
                                                  color: "#6B7280",
                                                  whiteSpace: "nowrap",
                                                  minWidth: "55px",
                                                  textAlign: "right",
                                                }}
                                              >
                                                {progressPercent}% Complete
                                              </Typography>
                                            </Stack>)}
                                          </Box>

                                          <Tooltip
                                            title={
                                              isActive && (isCurriculumAudioPlaying || isPlaying)
                                                ? "Pause module audio"
                                                : "Play module audio"
                                            }
                                            placement="top"
                                            arrow
                                            enterDelay={300}
                                          >
                                            <IconButton
                                              size="small"
                                              onClick={(e) => {
                                                e.stopPropagation();

                                                handlePlayModule(wIndex);
                                              }}
                                              sx={{
                                                width: 28,
                                                height: 28,
                                                borderRadius: "50%",
                                                color:
                                                  /* activeWeekIndex === wIndex */
                                                  isActive
                                                    ? "#2563EB"
                                                    : "#6B7280",
                                                backgroundColor:
                                                  /* activeWeekIndex === wIndex */
                                                  isActive
                                                    ? "#EFF6FF"
                                                    : "#F3F4F6",

                                                "&:hover": {
                                                  backgroundColor: "#DBEAFE",
                                                  color: "#2563EB",
                                                },
                                              }}
                                            >
                                              {/* activeWeekIndex === wIndex */ isActive && (isCurriculumAudioPlaying || isPlaying) ? (
                                                <PauseOutlinedIcon sx={{ fontSize: 16 }} />
                                              ) : (
                                                <PlayArrowRoundedIcon sx={{ fontSize: 17 }} />
                                              )}
                                            </IconButton>
                                          </Tooltip>

                                        </Stack>
                                      </Box>
                                    </Tooltip>

                                    {/* Subtopics */}
                                    {isExpanded && (
                                      <Stack
                                        spacing={0.8}
                                        sx={{
                                          pl: 5.2,
                                          pr: 1.5,
                                          pb: 1.5,
                                        }}
                                      >
                                        {/* {weekItem.subtopics?.map(
                                          (sub: any, i: number) => {
                                            const isSubLocked =
                                              isOwnCourse
                                                ? false
                                                : loggedIn !== "true"
                                                  ? wIndex > 0 || i > 0
                                                  : !isEnrolled &&
                                                  (wIndex > 0 || i > 0);

                                            const lessonTitle =
                                              sub?.lesson_title?.replace(/\bweeks?\b/gi, "Module") || "";

                                            const subExample =
                                              sub?.example ??
                                              sub?.examples ??
                                              sub?.Example ??
                                              "";

                                            const hasExample =
                                              subExample !== null &&
                                              subExample !== undefined &&
                                              (typeof subExample === "string"
                                                ? subExample.trim() !== ""
                                                : Object.keys(subExample || {}).length > 0);

                                            return (
                                              <Stack
                                                key={i}
                                                direction="column"
                                                alignItems="flex-start"
                                                spacing={0.5}
                                                sx={{
                                                  minWidth: 0,
                                                  width: "100%",
                                                  py: 0.35,
                                                }}
                                              >
                                                <Typography
                                                  key={i}
                                                  sx={{
                                                    fontSize: "11px",
                                                    lineHeight: 1.4,
                                                    color: "#4B5563",
                                                    cursor: isSubLocked
                                                      ? "not-allowed"
                                                      : "pointer",

                                                    "&:hover": {
                                                      color: isSubLocked
                                                        ? "#4B5563"
                                                        : "#2563EB",
                                                    },
                                                  }}
                                                  onClick={(e) => {
                                                    e.stopPropagation();

                                                    if (isSubLocked) {
                                                      if (loggedIn !== "true") {
                                                        setLoginPopup(true);
                                                      } else {
                                                        setEnrollPopup(true);
                                                      }

                                                      return;
                                                    }

                                                    if (openChatBot) {
                                                      setChatMessages((prev) => [
                                                        ...prev,
                                                        {
                                                          role: "user",
                                                          text: lessonTitle,
                                                        },
                                                      ]);

                                                      getChatBotResponse(
                                                        courseId,
                                                        "",
                                                        // weekItem?.title
                                                        lessonTitle
                                                      );

                                                      return;
                                                    }

                                                    // Select the lesson so the center panel shows
                                                    // the lesson-specific title, introduction,
                                                    // core instruction, practical application and image.
                                                    stopAllAudio();
                                                    isChatbotRequestRef.current = false;
                                                    setShowCourseDefinition(false);
                                                    setSelectedWeekData(weekItem);
                                                    setActiveWeekIndex(wIndex);
                                                    setSelectedSubtopic(sub);

                                                    requestAnimationFrame(() => {
                                                      courseContentRef.current?.scrollTo({
                                                        top: 0,
                                                        behavior: "smooth",
                                                      });
                                                    });
                                                  }}
                                                >
                                                  • {lessonTitle}
                                                </Typography>

                                                {!isSubLocked && hasExample && (
                                                  <Button
                                                    size="small"
                                                    variant="outlined"
                                                    startIcon={
                                                      <CodeOutlinedIcon sx={{ fontSize: 14 }} />
                                                    }
                                                    onClick={(e) => {
                                                      e.stopPropagation();

                                                      openExamplePreview(
                                                        subExample,
                                                        `${lessonTitle} — Example`
                                                      );
                                                    }}
                                                    sx={{
                                                      flexShrink: 0,
                                                      minWidth: 0,
                                                      px: 1,
                                                      py: 0.35,
                                                      borderRadius: "7px",
                                                      textTransform: "none",
                                                      fontSize: "10px",
                                                      lineHeight: 1.2,
                                                      fontWeight: 600,
                                                      color: "#2563EB",
                                                      borderColor: "#BFDBFE",
                                                      backgroundColor: "#EFF6FF",

                                                      "&:hover": {
                                                        borderColor: "#60A5FA",
                                                        backgroundColor: "#DBEAFE",
                                                      },
                                                    }}
                                                  >
                                                    View Example
                                                  </Button>
                                                )}
                                              </Stack>
                                            );
                                          }
                                        )} */}
                                        {weekItem.subtopics?.map(
                                          (sub: any, i: number) => {
                                            const isSubLocked =
                                              isOwnCourse
                                                ? false
                                                : loggedIn !== "true"
                                                  ? wIndex > 0 || i > 0
                                                  : !isEnrolled &&
                                                  (wIndex > 0 || i > 0);

                                            const lessonTitle =
                                              sub?.lesson_title?.replace(/\bweeks?\b/gi, "Module") || "";

                                            /* const subExample =
                                              sub?.examples ??
                                              "";

                                            const hasExample =
                                              subExample !== null &&
                                              subExample !== undefined &&
                                              (typeof subExample === "string"
                                                ? subExample.trim() !== ""
                                                : Object.keys(subExample || {}).length > 0); */

                                            // Is this the lesson currently open in the center panel?
                                            const isSubActive =
                                              wIndex === activeWeekIndex && !introVideoOpen &&
                                              selectedSubtopic?.lesson_title === sub?.lesson_title;

                                            // Adjust the field name below to match whatever your API
                                            // actually returns for lesson-level completion status.
                                            const isSubCompleted = Boolean(
                                              sub?.is_completed || sub?.completed || sub?.isCompleted
                                            );

                                            return (
                                              <Box
                                                key={i}
                                                sx={{
                                                  borderRadius: "6px",
                                                  backgroundColor: isSubActive ? "#EFF6FF" : "transparent",
                                                  px: 1,
                                                  py: 0.7,
                                                  transition: "all 0.15s ease",
                                                  "&:hover": {
                                                    backgroundColor: isSubLocked
                                                      ? "transparent"
                                                      : isSubActive
                                                        ? "#EFF6FF"
                                                        : "#F3F4F6",
                                                  },
                                                }}
                                              >
                                                <Stack
                                                  direction="row"
                                                  alignItems="center"
                                                  justifyContent="space-between"
                                                  spacing={1}
                                                  sx={{
                                                    cursor: isSubLocked ? "not-allowed" : "pointer",
                                                  }}
                                                  onClick={(e) => {
                                                    e.stopPropagation();

                                                    if (isSubLocked) {
                                                      if (loggedIn !== "true") {
                                                        setLoginPopup(true);
                                                      } else {
                                                        setEnrollPopup(true);
                                                      }

                                                      return;
                                                    }

                                                    /* if (openChatBot) {
                                                      setChatMessages((prev) => [
                                                        ...prev,
                                                        {
                                                          role: "user",
                                                          text: lessonTitle,
                                                        },
                                                      ]);

                                                      getChatBotResponse(
                                                        courseId,
                                                        "",
                                                        lessonTitle
                                                      );

                                                      return;
                                                    } */

                                                    // Select the lesson so the center panel shows
                                                    // the lesson-specific title, introduction,
                                                    // core instruction, practical application and image.
                                                    resumeAfterChatRef.current.shouldResume = false;

                                                    // stopAllAudio();
                                                    isChatbotRequestRef.current = false;


                                                    stopAll();

                                                    if (curriculumAudioRef.current) {
                                                      curriculumAudioRef.current.pause();
                                                      curriculumAudioRef.current.ontimeupdate = null;
                                                      curriculumAudioRef.current.onended = null;
                                                      curriculumAudioRef.current.onerror = null;
                                                      curriculumAudioRef.current.currentTime = 0;
                                                      curriculumAudioRef.current.src = "";
                                                    }

                                                    setOpenChatBot(false);

                                                    // Reset chatbot speech state.
                                                    setLastBotText("");

                                                    setShowCourseDefinition(false);
                                                    setIsLessonQuiz(false);
                                                    setQuizOpen(false);

                                                    setSelectedWeekData(weekItem);
                                                    setActiveWeekIndex(wIndex);
                                                    setSelectedSubtopic(sub);

                                                    requestAnimationFrame(() => {
                                                      courseContentRef.current?.scrollTo({
                                                        top: 0,
                                                        behavior: "smooth",
                                                      });
                                                    });
                                                  }}
                                                >
                                                  <Typography
                                                    sx={{
                                                      fontSize: "11.5px",
                                                      lineHeight: 1.45,
                                                      fontWeight: isSubActive ? 600 : 500,
                                                      color: isSubLocked
                                                        ? "#9CA3AF"
                                                        : isSubActive
                                                          ? "#2563EB"
                                                          : "#374151",
                                                      flex: 1,
                                                      minWidth: 0,
                                                      textAlign: 'left'
                                                    }}
                                                  >
                                                    {wIndex + 1}.{i + 1} {lessonTitle}
                                                  </Typography>

                                                  {/* Status indicator: green tick / blue radio / empty radio */}
                                                  {isSubCompleted ? (
                                                    <CheckCircleIcon
                                                      sx={{ fontSize: 17, color: "#22C55E", flexShrink: 0 }}
                                                    />
                                                  ) : isSubActive ? (
                                                    <RadioButtonCheckedIcon
                                                      sx={{ fontSize: 17, color: "#2563EB", flexShrink: 0 }}
                                                    />
                                                  ) : (
                                                    <RadioButtonUncheckedIcon
                                                      sx={{ fontSize: 17, color: "#D1D5DB", flexShrink: 0 }}
                                                    />
                                                  )}
                                                </Stack>

                                                {/* {!isSubLocked && hasExample && (
                                                  <Button
                                                    size="small"
                                                    variant="outlined"
                                                    startIcon={<CodeOutlinedIcon sx={{ fontSize: 14 }} />}
                                                    onClick={(e) => {
                                                      e.stopPropagation();

                                                      openExamplePreview(
                                                        subExample,
                                                        `${lessonTitle} — Example`
                                                      );
                                                    }}
                                                    sx={{
                                                      mt: 0.6,
                                                      flexShrink: 0,
                                                      minWidth: 0,
                                                      px: 1,
                                                      py: 0.35,
                                                      borderRadius: "7px",
                                                      textTransform: "none",
                                                      fontSize: "10px",
                                                      lineHeight: 1.2,
                                                      fontWeight: 600,
                                                      color: "#2563EB",
                                                      borderColor: "#BFDBFE",
                                                      backgroundColor: "#EFF6FF",

                                                      "&:hover": {
                                                        borderColor: "#60A5FA",
                                                        backgroundColor: "#DBEAFE",
                                                      },
                                                    }}
                                                  >
                                                    View Example
                                                  </Button>
                                                )} */}
                                              </Box>
                                            );
                                          }
                                        )}
                                        {weekItem.module_quiz?.length > 0 && (
                                          <Box
                                            sx={{
                                              borderRadius: "6px",
                                              backgroundColor:
                                                isLessonQuiz && activeWeekIndex === wIndex
                                                  ? "#EFF6FF"
                                                  : "transparent",
                                              px: 1,
                                              py: 0.8,
                                              mt: 0.3,
                                              transition: "all 0.15s ease",
                                              "&:hover": {
                                                backgroundColor: "#F3F4F6",
                                              },
                                            }}
                                          >
                                            <Stack
                                              direction="row"
                                              alignItems="center"
                                              justifyContent="space-between"
                                              spacing={1}
                                              sx={{
                                                cursor: "pointer",
                                              }}
                                              onClick={(e) => {
                                                e.stopPropagation();

                                                if (isLocked) {
                                                  if (loggedIn !== "true") {
                                                    setLoginPopup(true);
                                                  } else {
                                                    setEnrollPopup(true);
                                                  }
                                                  return;
                                                }

                                                openQuiz(wIndex);
                                              }}
                                            >
                                              <Stack
                                                direction="row"
                                                alignItems="center"
                                                spacing={1}
                                                sx={{ minWidth: 0 }}
                                              >
                                                <QuizIcon
                                                  sx={{
                                                    fontSize: 16,
                                                    color:
                                                      isLessonQuiz && activeWeekIndex === wIndex
                                                        ? "#2563EB"
                                                        : "#6B7280",
                                                    flexShrink: 0,
                                                  }}
                                                />

                                                <Box sx={{ minWidth: 0 }}>
                                                  <Typography
                                                    sx={{
                                                      fontSize: "11.5px",
                                                      lineHeight: 1.45,
                                                      fontWeight:
                                                        isLessonQuiz && activeWeekIndex === wIndex
                                                          ? 600
                                                          : 500,
                                                      color:
                                                        isLessonQuiz && activeWeekIndex === wIndex
                                                          ? "#2563EB"
                                                          : "#374151",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    Lesson Quiz
                                                  </Typography>

                                                  <Typography
                                                    sx={{
                                                      fontSize: "10px",
                                                      color: "#6B7280",
                                                      lineHeight: 1.4,
                                                    }}
                                                  >
                                                    Test Your Knowledge
                                                  </Typography>
                                                </Box>
                                              </Stack>

                                              {isLessonQuiz && activeWeekIndex === wIndex ? (
                                                <RadioButtonCheckedIcon
                                                  sx={{
                                                    fontSize: 17,
                                                    color: "#2563EB",
                                                    flexShrink: 0,
                                                  }}
                                                />
                                              ) : (
                                                <RadioButtonUncheckedIcon
                                                  sx={{
                                                    fontSize: 17,
                                                    color: "#D1D5DB",
                                                    flexShrink: 0,
                                                  }}
                                                />
                                              )}
                                            </Stack>
                                          </Box>
                                        )}

                                        {(() => {
                                          const moduleExamples = (weekItem.subtopics || []).flatMap(
                                            (sub: any) =>
                                              Array.isArray(sub?.examples)
                                                ? sub.examples
                                                : Array.isArray(sub?.example)
                                                  ? sub.example
                                                  : []
                                          );

                                          const hasModuleExamples = moduleExamples.some(
                                            (example: any) =>
                                              example &&
                                              typeof example === "object" &&
                                              (example?.title || example?.content)
                                          );

                                          if (!hasModuleExamples) return null;

                                          return (
                                            <Box
                                              sx={{
                                                px: 1,
                                                pt: 0.5,
                                              }}
                                            >
                                              <Button
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                                startIcon={
                                                  <CodeOutlinedIcon sx={{ fontSize: 14 }} />
                                                }
                                                onClick={(e) => {
                                                  e.stopPropagation();

                                                  if (isLocked) {
                                                    if (loggedIn !== "true") {
                                                      setLoginPopup(true);
                                                    } else {
                                                      setEnrollPopup(true);
                                                    }

                                                    return;
                                                  }

                                                  openExamplePreview(weekItem.subtopics || [], weekItem.title);
                                                }}
                                                sx={{
                                                  minWidth: 0,
                                                  py: 0.55,
                                                  borderRadius: "7px",
                                                  textTransform: "none",
                                                  fontSize: "10.5px",
                                                  lineHeight: 1.2,
                                                  fontWeight: 600,
                                                  color: "#2563EB",
                                                  borderColor: "#BFDBFE",
                                                  backgroundColor: "#EFF6FF",

                                                  "&:hover": {
                                                    borderColor: "#60A5FA",
                                                    backgroundColor: "#DBEAFE",
                                                  },
                                                }}
                                              >
                                                {/* View Example */}Practice
                                              </Button>
                                            </Box>
                                          );
                                        })()}

                                      </Stack>
                                    )}
                                  </Box>
                                );
                              })}
                            </Stack>
                          </>
                        )}
                      </Stack>
                    </Box>

                    {/* Example / Code Preview Dialog */}
                    <Dialog
                      open={examplePreviewOpen}
                      onClose={() => setExamplePreviewOpen(false)}
                      fullWidth
                      maxWidth="md"
                      PaperProps={{
                        sx: {
                          borderRadius: "14px",
                          overflow: "hidden",
                          backgroundColor: "#fff !important",
                          boxShadow: "0 24px 70px rgba(0,0,0,0.45)",
                        },
                      }}
                    >
                      <DialogTitle
                        sx={{
                          px: 2,
                          py: 1.25,
                          backgroundColor: "#fff",
                          color: "#000",
                          borderBottom: "1px solid #E5E7EB",
                        }}
                      >
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <CodeOutlinedIcon
                              sx={{
                                color: "#2563EB",
                                fontSize: 19,
                              }}
                            />

                            <Typography
                              sx={{
                                fontSize: "14px",
                                fontWeight: 700,
                              }}
                            >
                              {selectedModuleTitle} - Practices{/* Examples */}
                            </Typography>
                          </Stack>

                          <IconButton
                            size="small"
                            onClick={() => setExamplePreviewOpen(false)}
                            sx={{
                              color: "#6B7280",
                              "&:hover": {
                                color: "#111827",
                                backgroundColor: "#F3F4F6",
                              },
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Stack>
                      </DialogTitle>

                      <DialogContent
                        sx={{
                          p: 0,
                          backgroundColor: "#fff",
                        }}
                      >
                        <Box
                          sx={{
                            p: {
                              xs: 1.5,
                              sm: 2.5,
                            },
                            maxHeight: "65vh",
                            overflow: "auto",

                            "&::-webkit-scrollbar": {
                              width: "7px",
                            },

                            "&::-webkit-scrollbar-track": {
                              background: "#F3F4F6",
                            },

                            "&::-webkit-scrollbar-thumb": {
                              background: "#CBD5E1",
                              borderRadius: "8px",
                            },
                          }}
                        >
                          <Stack spacing={2}>
                            {selectedExamples.map((example, index) => (
                              <Box
                                key={`${example.title}-${index}`}
                                sx={{
                                  border: "1px solid #E5E7EB",
                                  borderRadius: "10px",
                                  overflow: "hidden",
                                  backgroundColor: "#fff",
                                }}
                              >
                                {/* Example title */}
                                <Box
                                  sx={{
                                    px: 1.5,
                                    py: 1,
                                    backgroundColor: "#EFF6FF",
                                    borderBottom: "1px solid #DBEAFE",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "13px",
                                      fontWeight: 700,
                                      color: "#1D4ED8",
                                    }}
                                  >
                                    Practice {index + 1}: {cleanExampleTitle(example.title)}
                                  </Typography>
                                </Box>

                                {/* Example content */}
                                <Box
                                  sx={{
                                    px: 1.5,
                                    py: 1.5,
                                    color: "#374151",
                                    fontSize: "12px",
                                    lineHeight: 1.7,
                                    overflowWrap: "anywhere",

                                    "& p": {
                                      margin: 0,
                                      marginBottom: "8px",
                                    },

                                    "& p:last-child": {
                                      marginBottom: 0,
                                    },

                                    "& ul, & ol": {
                                      paddingLeft: "20px",
                                    },

                                    "& img": {
                                      maxWidth: "100%",
                                      height: "auto",
                                    },
                                  }}
                                >
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: example.content || "",
                                    }}
                                  />
                                </Box>
                              </Box>
                            ))}
                          </Stack>
                        </Box>
                      </DialogContent>
                    </Dialog>

                    {/* quiz btn */}
                    {/* {currentQuiz.length > 0 && (
                      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        < Button
                          startIcon={<QuizIcon />}
                          sx={{
                            px: 3,
                            py: 1.2,
                            borderRadius: "30px",
                            bgcolor: "#FFF7ED",
                            color: "#EA580C",
                            border: "2px solid #FDBA74",
                            fontWeight: 700,
                            textTransform: "none",
                            animation: "bounce 2s infinite",

                            "@keyframes bounce": {
                              "0%,100%": { transform: "translateY(0)" },
                              "50%": { transform: "translateY(-4px)" },
                            },

                            "&:hover": {
                              bgcolor: "#FFEDD5",
                            },
                            width: '50%'
                          }}
                          onClick={() => openQuiz(activeWeekIndex)}
                        >
                          Take Quiz
                        </Button>
                      </Box>
                    )} */}
                    {/* end quiz btn */}

                  </Stack>
                </Paper>
              </Grid>)}

            {/* LEFT SIDE OPEN/CLOSE TAB */}
            {!isMobile && (
              <Tooltip
                title={
                  isCourseContentsOpen
                    ? "Close Course Contents"
                    : "Open Course Contents"
                }
                placement="right"
                arrow
              >
                <Box
                  onClick={() =>
                    setIsCourseContentsOpen((prev) => !prev)
                  }
                  sx={{
                    position: "absolute",
                    left: 0,
                    top: 2,
                    zIndex: 30,

                    width: 40,
                    height: 40,

                    borderRadius: "0 10px 10px 0",
                    backgroundColor: "#EFF6FF",
                    border: "1px solid #93C5FD",
                    borderLeft: "none",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",

                    cursor: "pointer",

                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",

                    transition: "all 0.2s ease",

                    "&:hover": {
                      backgroundColor: "#DBEAFE",
                      width: 44,
                    },
                  }}
                >
                  {isCourseContentsOpen ? (
                    <ArrowBackIosNewIcon
                      sx={{
                        fontSize: 18,
                        color: "#2563EB",
                      }}
                    />
                  ) : (
                    <ArrowForwardIosIcon
                      sx={{
                        fontSize: 18,
                        color: "#2563EB",
                      }}
                    />
                  )}
                </Box>
              </Tooltip>
            )}

            {/* RIGHT PANEL */}
            <Grid item xs={12} md={isCourseContentsOpen ? 9.5 : 12} sx={{
              transition: "all .35s ease",
              alignSelf: 'stretch',
              // height: "100%",      // NEW
              minHeight: 0,         // NEW
              display: 'flex',
              flexDirection: 'column'
            }}>
              <Grid container columnSpacing={2} sx={{ height: "100%", minHeight: 0, alignItems: 'stretch', flex: 1 }}/* spacing={3} */>

                <Grid item xs={12} md={
                  isCourseContentsOpen && isConversationOpen
                    ? 9
                    : isCourseContentsOpen && !isConversationOpen
                      ? 12
                      : !isCourseContentsOpen && isConversationOpen
                        ? 9
                        : 12
                } sx={{ height: "100%", minHeight: { xs: 0, md: 560 } }}/* md={isCourseContentsOpen && isConversationOpen ? 8 : isCourseContentsOpen || isConversationOpen ? 9 : 12} */>
                  {/*  {openChatBot ? (
                  <Box
                    ref={chatContainerRef}
                    sx={{
                      height: { xs: "auto", md: "calc(100vh - 140px)" },
                      overflowY: "auto",
                      p: 1.5,
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    {chatMessages.map((msg, i) => {
                      const isLastUser =
                        msg.role === "user" &&
                        i ===
                        [...chatMessages].map((m) => m.role).lastIndexOf("user");
                      return (
                        <Box
                          key={i}
                          ref={isLastUser ? lastUserMsgRef : null}
                          sx={{
                            position: "relative",
                            alignSelf:
                              msg.role === "user" ? "flex-end" : "flex-start",
                            background: msg.role === "user" ? "#2563eb" : "#2b2d36",
                            color: "#fff",
                            px: 1.5,
                            py: 1,
                            borderRadius: 2,
                            maxWidth: "80%",
                            fontSize: "13px",
                            lineHeight: 1.6,
                            whiteSpace: msg.role === "bot" ? "normal" : "pre-wrap",
                          }}
                        >
                          {msg.role === "bot" ? (
                            <Box
                              sx={{
                                "& h1, & h2, & h3, & h4, & h5, & h6": {
                                  margin: "4px 0",
                                  lineHeight: 1.3,
                                },
                                "& p": { margin: "4px 0" },
                                "& ul": { margin: "4px 0", paddingLeft: "18px" },
                                "& li": { margin: "2px 0" },
                              }}
                              dangerouslySetInnerHTML={{ __html: msg.text }}
                            />
                          ) : (
                            msg.text
                          )}
                        </Box>
                      );
                    })}
                    {isChatBotLoading && (
                      <Box
                        sx={{
                          alignSelf: "flex-start",
                          background: "#2b2d36",
                          color: "#9CA3AF",
                          px: 1.5,
                          py: 1,
                          borderRadius: 2,
                          fontSize: "13px",
                        }}
                      >
                        Typing...
                      </Box>
                    )}
                  </Box>
                ) : ( */}
                  <Stack
                    // spacing={2}
                    sx={{
                      // height: { xs: "auto", md: "calc(140vh - 140px)" },
                      height: "100%",
                      minHeight: 0,
                      // overflow: "hidden",
                      overflowY: "auto",
                      overflowX: "hidden",
                      /* width: {
                        xs: "100%",
                        md: '90%'
                      } */
                      width: "100%",
                      pr: 2,
                    }}
                  >

                    <Box sx={{
                      display: "flex",
                      flexDirection: {
                        xs: "column-reverse",
                        md: "row",
                      },
                      alignItems: {
                        xs: "center",
                        md: "flex-start",
                      },
                      width: "100%",
                      gap: 2.5,
                    }}/* sx={{ display: 'flex', width: '100%', gap: 2.5 }} */>

                      {/* menu icon */}
                      {/* {!isMobile && !isCourseContentsOpen && (
                        <IconButton
                          onClick={() => setIsCourseContentsOpen(true)}
                          sx={{
                            mt: 0.3,
                            width: 40,
                            height: 40,
                            bgcolor: "#fff",
                            border: "1px solid #E5E7EB",
                            boxShadow: 1,
                          }}
                        >
                          <MenuIcon sx={{ color: "#000" }} />
                        </IconButton>
                      )} */}
                      {/* end menu icon */}

                      {/* main content */}
                      <Box sx={{
                        width: {
                          xs: "100%",
                          md: isLessonQuiz
                            ? "100%" : isCourseContentsOpen ? "70%" : "80%",
                        },/* width: isCourseContentsOpen ? '70%' : '80%' */
                      }}>
                        {isLessonQuiz ? (
                          <Box
                            sx={{
                              width: "100%",
                              pb: 2,
                            }}
                          >
                            {/* Breadcrumb */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1.2,
                                pb: 1,
                                mb: 3,
                                borderBottom: "1px solid #E5E7EB",
                                fontSize: "11px",
                              }}
                            >
                              <MenuBookOutlinedIcon
                                sx={{
                                  fontSize: 16,
                                  color: "#1E3A8A",
                                }}
                              />

                              <Typography
                                sx={{
                                  fontSize: "11px",
                                  fontWeight: 600,
                                  color: "#1E3A8A",
                                }}
                              >
                                Course Overview
                              </Typography>

                              <Typography sx={{ color: "#9CA3AF" }}>
                                ›
                              </Typography>

                              <Typography
                                sx={{
                                  fontSize: "11px",
                                  fontWeight: 600,
                                  color: "#1E3A8A",
                                }}
                              >
                                {curriculum[activeWeekIndex]?.title?.replace(
                                  /\bweeks?\b/i,
                                  "Module"
                                )}
                              </Typography>

                              <Typography sx={{ color: "#9CA3AF" }}>
                                ›
                              </Typography>

                              <Typography
                                sx={{
                                  fontSize: "11px",
                                  fontWeight: 600,
                                  color: "#1E3A8A",
                                  textDecoration: "underline",
                                }}
                              >
                                Lesson Quiz
                              </Typography>
                            </Box>

                            <Stack
                              direction={{ xs: "column", md: "row" }}
                              justifyContent="space-between"
                              alignItems={{ xs: "flex-start", md: "flex-start" }}
                              spacing={2}
                              sx={{ mb: 3 }}
                            >
                              <Box>
                                <Box
                                  sx={{
                                    display: "inline-flex",
                                    px: 1.2,
                                    py: 0.5,
                                    borderRadius: "6px",
                                    backgroundColor: "#F3E8FF",
                                    mb: 1.5,
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "9px",
                                      fontWeight: 700,
                                      color: "#6D28D9",
                                      letterSpacing: 0.5,
                                    }}
                                  >
                                    LESSON QUIZ
                                  </Typography>
                                </Box>

                                <Typography
                                  sx={{
                                    fontSize: {
                                      xs: "24px",
                                      md: "30px",
                                    },
                                    fontWeight: 700,
                                    color: "#111827",
                                    lineHeight: 1.2,
                                    mb: 1,
                                  }}
                                >
                                  Test Your Knowledge
                                </Typography>

                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    lineHeight: 1.7,
                                    color: "#4B5563",
                                    maxWidth: 400,
                                  }}
                                >
                                  Answer the questions below to check your understanding
                                  of this lesson.
                                </Typography>
                              </Box>

                              <Box
                                sx={{
                                  /*  width: { xs: "180px", md: "240px" },
                                   height: { xs: "120px", md: "150px" }, */
                                  borderRadius: "20px",
                                  background:
                                    "linear-gradient(135deg,#EEF2FF,#F5F3FF)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  position: "relative",
                                  overflow: "hidden",
                                }}
                              >
                                {/* <QuizIcon
                                  sx={{
                                    fontSize: { xs: 70, md: 100 },
                                    color: "#6366F1",
                                    opacity: 0.85,
                                  }}
                                /> */}
                                <img src={QuizImg} />
                              </Box>
                            </Stack>

                            <Box
                              sx={{
                                border: "1px solid #E5E7EB",
                                borderRadius: "10px",
                                px: 2,
                                py: 1.5,
                                mb: 2,
                                backgroundColor: "#fff",
                              }}
                            >
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={1.5}
                              >
                                <Box
                                  sx={{
                                    width: 30,
                                    height: 30,
                                    borderRadius: "50%",
                                    backgroundColor: "#EEF2FF",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0,
                                  }}
                                >
                                  <QuizIcon
                                    sx={{
                                      fontSize: 17,
                                      color: "#2563EB",
                                    }}
                                  />
                                </Box>

                                <Typography
                                  sx={{
                                    fontSize: "11px",
                                    fontWeight: 700,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Question {currentQuizIndex + 1} of {currentQuiz.length}
                                </Typography>

                                <LinearProgress
                                  variant="determinate"
                                  value={
                                    currentQuiz.length
                                      ? ((currentQuizIndex + 1) / currentQuiz.length) * 100
                                      : 0
                                  }
                                  sx={{
                                    flex: 1,
                                    height: 6,
                                    borderRadius: "10px",
                                    backgroundColor: "#EEF2FF",
                                    "& .MuiLinearProgress-bar": {
                                      borderRadius: "10px",
                                      backgroundColor: "#7C3AED",
                                    },
                                  }}
                                />

                                <Typography
                                  sx={{
                                    fontSize: "10px",
                                    color: "#6B7280",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {quizProgressPercentage}% Complete
                                </Typography>
                              </Stack>
                            </Box>

                            <Box
                              sx={{
                                border: "1px solid #E5E7EB",
                                borderRadius: "12px",
                                p: {
                                  xs: 2,
                                  md: 3,
                                },
                                backgroundColor: "#fff",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: {
                                    xs: "17px",
                                    md: "18px",
                                  },
                                  fontWeight: 700,
                                  color: "#111827",
                                  lineHeight: 1.4,
                                  mb: 2.5,
                                }}
                              >
                                {currentQuestion?.question}
                              </Typography>

                              {currentQuestion?.options?.map(
                                (option: string, index: number) => {
                                  const isSelected = selectedAnswer === option;
                                  const isCorrect =
                                    option === currentQuestion.correct_answer;

                                  return (
                                    <Box
                                      key={option}
                                      onClick={() => {
                                        // setSelectedAnswer(option);
                                        handleLessonQuizAnswer(currentQuizIndex, option);
                                      }}
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1.5,
                                        px: 1.5,
                                        py: 1.3,
                                        mb: 1.2,
                                        borderRadius: "8px",
                                        border: isSelected
                                          ? "1.5px solid #2563EB"
                                          : "1px solid #E5E7EB",
                                        backgroundColor: isSelected
                                          ? "#F8FAFF"
                                          : "#fff",
                                        cursor: "pointer",
                                        transition: "all .2s ease",

                                        "&:hover": {
                                          borderColor: "#93C5FD",
                                          backgroundColor: "#F8FAFC",
                                        },
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          width: 16,
                                          height: 16,
                                          minWidth: 16,
                                          borderRadius: "50%",
                                          border: isSelected
                                            ? "5px solid #2563EB"
                                            : "2px solid #CBD5E1",
                                          backgroundColor: "#fff",
                                        }}
                                      />

                                      <Typography
                                        sx={{
                                          fontSize: "11.5px",
                                          fontWeight: 500,
                                          color: "#374151",
                                        }}
                                      >
                                        {String.fromCharCode(65 + index)}. {option}
                                      </Typography>
                                    </Box>
                                  );
                                }
                              )}
                            </Box>

                            {selectedAnswer && (
                              <Box
                                sx={{
                                  mt: 2,
                                  p: 1.5,
                                  borderRadius: "8px",
                                  backgroundColor:
                                    selectedAnswer === currentQuestion?.correct_answer
                                      ? "#ECFDF5"
                                      : "#FEF2F2",
                                  border:
                                    selectedAnswer === currentQuestion?.correct_answer
                                      ? "1px solid #A7F3D0"
                                      : "1px solid #FECACA",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "11px",
                                    fontWeight: 700,
                                    color:
                                      selectedAnswer === currentQuestion?.correct_answer
                                        ? "#059669"
                                        : "#DC2626",
                                    mb: 0.5,
                                  }}
                                >
                                  {selectedAnswer === currentQuestion?.correct_answer
                                    ? "Correct!"
                                    : "Incorrect"}
                                </Typography>

                                <Typography
                                  sx={{
                                    fontSize: "10px",
                                    lineHeight: 1.6,
                                    color: "#4B5563",
                                  }}
                                >
                                  {currentQuestion?.explanation}
                                </Typography>
                              </Box>
                            )}

                            <Stack
                              direction="row"
                              justifyContent="space-between"
                              alignItems="center"
                              sx={{ mt: 3 }}
                            >
                              <Button
                                variant="outlined"
                                disabled={currentQuizIndex === 0}
                                onClick={() => {
                                  const previousIndex = Math.max(
                                    currentQuizIndex - 1,
                                    0
                                  );

                                  selectLessonQuizQuestion(previousIndex);
                                }}
                                sx={{
                                  px: 2.5,
                                  py: 0.9,
                                  borderRadius: "7px",
                                  textTransform: "none",
                                  fontSize: "11px",
                                  borderColor: "#E5E7EB",
                                  color: "#374151",
                                }}
                              >
                                ‹ Previous
                              </Button>

                              <Button
                                // disabled={!selectedAnswer}
                                disabled={
                                  !selectedAnswer ||
                                  (currentQuizIndex === currentQuiz.length - 1 && isQuizCompleted)
                                }
                                onClick={async () => {
                                  if (!selectedAnswer) return;

                                  const isLastQuestion = currentQuizIndex === currentQuiz.length - 1;

                                  // Only block re-submitting when the quiz was already completed.
                                  // Navigating between questions must still work.
                                  if (isLastQuestion && isQuizCompleted) return;

                                  const isCorrect =
                                    selectedAnswer === currentQuestion?.correct_answer;

                                  const latestAnswer = {
                                    question_index: currentQuizIndex,
                                    selected_answer: selectedAnswer,
                                    is_correct: isCorrect,
                                  };

                                  setQuizAnswers((prev) => ({
                                    ...prev,
                                    [currentQuizIndex]: {
                                      selected_answer: selectedAnswer,
                                      is_correct: isCorrect,
                                    },
                                  }));

                                  setAnsweredQuestions((prev) => {
                                    const next = new Set(prev);
                                    next.add(currentQuizIndex);
                                    return next;
                                  });

                                  if (!isLastQuestion) {
                                    const nextIndex = currentQuizIndex + 1;

                                    setCurrentQuizIndex(nextIndex);

                                    setSelectedAnswer(
                                      quizAnswers[nextIndex]?.selected_answer || null
                                    );

                                    return;
                                  }

                                  const saved = await saveLessonQuizAnswers(
                                    latestAnswer
                                  );

                                  /* if (saved) {
                                    setCorrectCount(
                                      Object.values({
                                        ...quizAnswers,
                                        [currentQuizIndex]: {
                                          selected_answer: selectedAnswer,
                                          is_correct: isCorrect,
                                        },
                                      }).filter((answer) => answer.is_correct).length
                                    );

                                    setQuizProgressPercentage(100);

                                    // Mark quiz as completed after successful POST
                                    setIsQuizCompleted(true);

                                    setShowResult(true);
                                  } */
                                  if (saved) {
                                    /* setCorrectCount(
                                      Object.values({
                                        ...quizAnswers,
                                        [currentQuizIndex]: {
                                          selected_answer: selectedAnswer,
                                          is_correct: isCorrect,
                                        },
                                      }).filter((answer) => answer.is_correct).length
                                    ); */
                                    const finalCorrectCount = Object.values({
                                      ...quizAnswers,
                                      [currentQuizIndex]: {
                                        selected_answer: selectedAnswer,
                                        is_correct: isCorrect,
                                      },
                                    }).filter((answer) => answer.is_correct).length;

                                    setCorrectCount(finalCorrectCount);

                                    const finalPercentage =
                                      currentQuiz.length > 0
                                        ? Math.round((finalCorrectCount / currentQuiz.length) * 100)
                                        : 0;

                                    setQuizProgressPercentage(finalPercentage);

                                    // Mark quiz as completed after successful POST
                                    setIsQuizCompleted(true);

                                    // Show quiz result
                                    setShowResult(true);

                                    // Show module completed popup if this is not the last module
                                    //if (activeWeekIndex < curriculum.length - 1) {
                                    const weekNumber =
                                      Number(currentWeek?.week) ||
                                      activeWeekIndex + 1;

                                    setCompletedModuleInfo({
                                      index: activeWeekIndex,
                                      title:
                                        currentWeek?.title?.replace(/\bweeks?\b/i, "Module") ||
                                        `Module ${weekNumber}`,
                                    });

                                    setTimeout(() => {
                                      setModuleCompletePopup(true);
                                    }, 500);
                                    //}
                                  }
                                }}
                                variant="contained"
                                sx={{
                                  px: 2.5,
                                  py: 0.9,
                                  borderRadius: "7px",
                                  textTransform: "none",
                                  fontSize: "11px",
                                  backgroundColor: "#2563EB",
                                  "&:hover": {
                                    backgroundColor: "#1D4ED8",
                                    color: '#fff'
                                  },
                                  color: '#fff'
                                }}
                              >
                                {currentQuizIndex === currentQuiz.length - 1
                                  ? isQuizCompleted
                                    ? "Completed"
                                    : "Finish"
                                  : "Next Question ›"}
                              </Button>
                            </Stack>

                          </Box>
                        ) : showCourseDefinition && courseDefinition ? (
                          <Box>
                            {/* Module Breadcrumb */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                                pb: 1,
                                mb: '6px',
                                borderBottom: "1px solid #E5E7EB",
                              }}
                            >
                              {/* Icon + Module count */}
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                  flexShrink: 0,
                                  height: "22px",
                                }}
                              >
                                <MenuBookOutlinedIcon
                                  sx={{
                                    fontSize: 20,
                                    color: "#000",
                                    display: "block",
                                  }}
                                />

                                <Typography
                                  sx={{
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    color: "#000",
                                    whiteSpace: "nowrap",
                                    lineHeight: "22px",
                                  }}
                                >
                                  Course Overview
                                </Typography>
                              </Box>

                              {/* Separator */}
                              <Typography
                                sx={{
                                  fontSize: "16px",
                                  fontWeight: 600,
                                  color: "#9CA3AF",
                                  lineHeight: "22px",
                                  flexShrink: 0,
                                }}
                              >
                                •
                              </Typography>

                              {/* Current Module / Selected Lesson */}
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  fontWeight: 600,
                                  color: "#000",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  lineHeight: "22px",
                                  minWidth: 0,
                                }}
                              >
                                {courseDefinition?.title}
                              </Typography>
                            </Box>
                            {/* Title + Description */}
                            <Typography sx={{ fontSize: "28px", color: "#000", fontWeight: "bold", mb: 1 }}>
                              {courseDefinition?.title}
                            </Typography>
                            <Typography sx={{ fontSize: "14px", lineHeight: 1.8, color: "#4B5563", mb: 2.5 }}>
                              {courseDefinition?.description}
                            </Typography>

                            {/* Stats row: Level / Duration / Modules / Lessons */}
                            <Stack
                              direction="row"
                              flexWrap="wrap"
                              spacing={4}
                              sx={{
                                p: 2,
                                mb: 3,
                                borderRadius: "10px",
                                border: "1px solid #E5E7EB",
                                backgroundColor: "#F9FAFB",
                              }}
                            >
                              <Stack direction="row" spacing={1} alignItems="center">
                                <BarChartOutlinedIcon sx={{ fontSize: 18, color: "#2563EB" }} />
                                <Box>
                                  <Typography sx={{ fontSize: "10px", color: "#6B7280" }}>Level</Typography>
                                  <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#111827" }}>
                                    {courseDefinition?.learner_level || "—"}
                                  </Typography>
                                </Box>
                              </Stack>

                              <Stack direction="row" spacing={1} alignItems="center">
                                <AccessTimeOutlinedIcon sx={{ fontSize: 18, color: "#2563EB" }} />
                                <Box>
                                  <Typography sx={{ fontSize: "10px", color: "#6B7280" }}>Duration</Typography>
                                  <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#111827" }}>
                                    {courseDefinition?.total_duration || courseDefinition?.duration || "—"}
                                  </Typography>
                                </Box>
                              </Stack>

                              <Stack direction="row" spacing={1} alignItems="center">
                                <MenuBookOutlinedIcon sx={{ fontSize: 18, color: "#2563EB" }} />
                                <Box>
                                  <Typography sx={{ fontSize: "10px", color: "#6B7280" }}>Modules</Typography>
                                  <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#111827" }}>
                                    {curriculum.length}
                                  </Typography>
                                </Box>
                              </Stack>

                              <Stack direction="row" spacing={1} alignItems="center">
                                <SchoolIcon sx={{ fontSize: 18, color: "#2563EB" }} />
                                <Box>
                                  <Typography sx={{ fontSize: "10px", color: "#6B7280" }}>Lessons</Typography>
                                  <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#111827" }}>
                                    {totalLessons}
                                  </Typography>
                                </Box>
                              </Stack>
                            </Stack>
                          </Box>
                        ) : (<>
                          {/* Module Breadcrumb */}
                          {/* Module Breadcrumb */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1.5,
                              pb: 1,
                              mb: '6px',
                              borderBottom: "1px solid #E5E7EB",
                            }}
                          >
                            {/* Icon + Module count */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                flexShrink: 0,
                                height: "22px",
                              }}
                            >
                              <MenuBookOutlinedIcon
                                sx={{
                                  fontSize: 20,
                                  color: "#000",
                                  display: "block",
                                }}
                              />

                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  fontWeight: 600,
                                  color: "#000",
                                  whiteSpace: "nowrap",
                                  lineHeight: "22px",
                                }}
                              >
                                Module {activeWeekIndex + 1} of {curriculum.length}
                              </Typography>
                            </Box>

                            {/* Separator */}
                            <Typography
                              sx={{
                                fontSize: "16px",
                                fontWeight: 600,
                                color: "#9CA3AF",
                                lineHeight: "22px",
                                flexShrink: 0,
                              }}
                            >
                              •
                            </Typography>

                            {/* Current Module / Selected Lesson */}
                            <Typography
                              sx={{
                                fontSize: "14px",
                                fontWeight: 600,
                                color: "#000",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                lineHeight: "22px",
                                minWidth: 0,
                              }}
                            >
                              {selectedSubtopic
                                ? selectedSubtopic?.lesson_title?.replace(/\bweeks?\b/gi, "Module")
                                : `Module ${activeWeekIndex + 1}: ${curriculum[activeWeekIndex]?.title?.replace(/\bweeks?\b/i, "Module") || ""}`}
                            </Typography>
                          </Box>

                          <Typography
                            sx={{ fontSize: "28px", color: "#000", fontWeight: "bold", mb: 1, textAlign: 'left' }}
                          >
                            {selectedSubtopic
                              ? selectedSubtopic?.lesson_title?.replace(/\bweeks?\b/gi, "Module")
                              : /* completeCourseDet?.title? */curriculum[activeWeekIndex]?.title?.replace(/"/g, "").replace(/\bweeks?\b/i, "Module")}
                          </Typography>

                          {selectedSubtopic && (
                            <>
                              <Box
                                ref={courseContentRef}
                                sx={{
                                  width: "100%",
                                  maxHeight: "calc(100vh - 300px)",
                                  overflowY: "auto",
                                  pr: 1,
                                  pb: 2,
                                  color: "#111827",
                                  scrollbarWidth: "thin",
                                  scrollbarColor: "rgba(0,0,0,0.18) transparent",
                                  "&::-webkit-scrollbar": { width: "6px" },
                                  "&::-webkit-scrollbar-track": { background: "transparent" },
                                  "&::-webkit-scrollbar-thumb": {
                                    background: "rgba(0,0,0,0.18)",
                                    borderRadius: "10px",
                                  },
                                }}
                              >
                                {selectedSubtopic?.introduction && (
                                  <Box sx={{ mb: 2.2 }}>
                                    <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "#111827", mb: 0.7 }}>
                                      Introduction
                                    </Typography>
                                    <Typography sx={{ fontSize: "13px", lineHeight: 1.75, color: "#4B5563", whiteSpace: "pre-wrap" }}>
                                      {selectedSubtopic.introduction}
                                    </Typography>
                                  </Box>
                                )}
                              </Box>

                              {/*  {currentLessonImage && (
                              <Box sx={{ width: "100%", border: "1px solid #E5E7EB", borderRadius: "10px", overflow: "hidden", backgroundColor: "#F8FAFC", mt: 1 }}>
                                <Box
                                  component="img"
                                  src={currentLessonImage}
                                  alt={selectedSubtopic?.lesson_title || "Lesson"}
                                  sx={{ width: "100%", height: "auto", display: "block", cursor: "pointer" }}
                                />
                              </Box>
                            )} */}
                            </>
                          )}

                          {/* <Typography
                          variant="subtitle1"
                          fontWeight={600}
                          sx={{ mb: 1, color: '#000' }}
                        >
                          {curriculum[activeWeekIndex]?.title}
                        </Typography> */}

                          {/* <Typography sx={{ color: "#000", fontSize: "16px" }}>
                          {completeCourseDet?.description.slice(0, 120) + '....'}
                        </Typography> */}
                          {!selectedSubtopic && (<Tooltip
                            title={
                              <Box sx={{ maxWidth: 420 }}>
                                <Typography
                                  sx={{
                                    fontSize: "14px",
                                    lineHeight: 1.6,
                                    color: "#fff",
                                    fontWeight: 400,
                                  }}
                                >
                                  {/* completeCourseDet?.description */curriculum[activeWeekIndex]?.module_summary?.replace(/\bweeks?\b/i, "Module")}
                                </Typography>
                              </Box>
                            }
                            arrow
                            placement="top-start"
                            enterTouchDelay={0}
                            leaveTouchDelay={3000}
                            slotProps={{
                              tooltip: {
                                sx: {
                                  backgroundColor: "#1F2937",
                                  borderRadius: "12px",
                                  padding: "14px 16px",
                                  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.18)",
                                  maxWidth: "420px",
                                },
                              },
                              arrow: {
                                sx: {
                                  color: "#1F2937",
                                },
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                color: "#000",
                                fontSize: "16px",
                                cursor: "pointer",
                                display: "-webkit-box",
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                transition: "color 0.2s ease",
                                "&:hover": {
                                  color: "#3B82F6",
                                },
                              }}
                            >
                              {/* completeCourseDet?.description */curriculum[activeWeekIndex]?.module_summary?.slice(0, 150).replace(/\bweeks?\b/i, "Module")}
                              {/* completeCourseDet?.description */curriculum[activeWeekIndex]?.module_summary?.length > 150 ? "...." : ""}
                            </Typography>
                          </Tooltip>)}


                          {/* {loadingCourse ? (
                        <Box sx={{ flex: 1, overflowY: "auto", pr: 1 }}>
                          <Stack spacing={1}>
                            <Skeleton
                              height={28}
                              width="60%"
                              sx={{ bgcolor: "#E5E7EB" }}
                            />
                            <Skeleton
                              height={18}
                              width="90%"
                              sx={{ bgcolor: "#E5E7EB" }}
                            />
                            <Skeleton
                              height={18}
                              width="95%"
                              sx={{ bgcolor: "#E5E7EB" }}
                            />
                            <Skeleton
                              height={18}
                              width="85%"
                              sx={{ bgcolor: "#E5E7EB" }}
                            />
                            <Skeleton
                              height={24}
                              width="40%"
                              sx={{ mt: 2, bgcolor: "#E5E7EB" }}
                            />
                            <Skeleton
                              height={18}
                              width="92%"
                              sx={{ bgcolor: "#E5E7EB" }}
                            />
                            <Skeleton
                              height={18}
                              width="88%"
                              sx={{ bgcolor: "#E5E7EB" }}
                            />
                            <Skeleton
                              height={18}
                              width="90%"
                              sx={{ bgcolor: "#E5E7EB" }}
                            />
                            <Skeleton
                              height={18}
                              width="70%"
                              sx={{ mt: 1, bgcolor: "#E5E7EB" }}
                            />
                            <Skeleton
                              height={18}
                              width="75%"
                              sx={{ bgcolor: "#E5E7EB" }}
                            />
                            <Skeleton
                              height={18}
                              width="65%"
                              sx={{ bgcolor: "#E5E7EB" }}
                            />
                          </Stack>
                        </Box>
                      ) : (
                        curriculum[activeWeekIndex] && (
                          <Box
                            ref={courseContentRef}
                            sx={{
                              flex: 1,
                              // minHeight: 0,
                              // maxHeight: 250,
                              // overflowY: "auto",
                              overflowX: "hidden",
                              pr: 1,

                              color: "#000",
                              fontSize: "16px",
                              fontWeight: "lighter",
                              lineHeight: 1.8,

                              // Scrollbar styling
                              scrollbarWidth: "thin",
                              scrollbarColor: "rgba(0,0,0,0.18) transparent",

                              "&::-webkit-scrollbar": {
                                width: "6px",
                              },
                              "&::-webkit-scrollbar-track": {
                                background: "transparent",
                              },
                              "&::-webkit-scrollbar-thumb": {
                                background: "rgba(0,0,0,0.18)",
                                borderRadius: "10px",
                              },
                              "&::-webkit-scrollbar-thumb:hover": {
                                background: "rgba(0,0,0,0.3)",
                              },
                              "& .tts-highlight": {
                                background:
                                  "linear-gradient(90deg,#2563eb,#3b82f6)",
                                color: "#fff",
                                padding: "2px 4px",
                                borderRadius: "4px",
                                transition: "all 0.3s ease",
                              },
                            }}
                            dangerouslySetInnerHTML={{
                              __html: formatCourseContent(
                                curriculum[activeWeekIndex].content,
                              ),
                            }}
                            dangerouslySetInnerHTML={{
                              __html: getHighlightedContent(
                                curriculum[activeWeekIndex].bullet_summary,
                                currentIndex
                              ),
                            }}
                          >
                          </Box>
                        )
                      )} */}
                        </>)}
                      </Box>

                      {/* user image */}
                      {!isLessonQuiz && (<Box sx={{
                        position: "relative",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexShrink: 0,
                        width: {
                          xs: "100%",
                          md: "auto",
                        },
                      }}/* sx={{ position: 'relative', width: isCourseContentsOpen ? '30%' : '20%' }} */>
                        <Box
                          component="img"
                          src={userImage ? userImage : defaultUserImage1}
                          /* sx={{
                            width: "100%",
                            height: 200,
                            objectFit: "cover",
                            objectPosition: "top center",
                            borderRadius: '100px',
                            border: '4px solid #fff',
                            boxShadow: `
                                0 4px 12px rgba(0, 0, 0, 0.08),
                                0 12px 30px rgba(0, 0, 0, 0.15)
                                `,
                          }} */
                          sx={{
                            width: {
                              xs: 120,
                              sm: 150,
                              md: 180,
                            },
                            height: {
                              xs: 120,
                              sm: 150,
                              md: 180,
                            },
                            borderRadius: "50%",
                            objectFit: "cover",
                            objectPosition: "top center",
                            border: "4px solid #fff",
                            boxShadow: `0 4px 12px rgba(0,0,0,.08),
                                      0 12px 30px rgba(0,0,0,.15)
                                      `,
                          }}
                        />

                        {/* Speaker Icon - Overlay on image */}
                        <IconButton
                          onClick={toggleMute}
                          title={isMuted ? "Unmute" : "Mute"}
                          sx={{
                            position: "absolute",
                            top: {
                              xs: 6,
                              sm: 8,
                              md: 10,
                            },
                            right: {
                              xs: 6,
                              sm: 8,
                              md: 10,
                            },
                            zIndex: 10,

                            background: isMuted
                              ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                              : "linear-gradient(135deg, #4BA5EB 0%, #1E7BC0 100%)",

                            width: 42,
                            height: 42,
                            borderRadius: "50%",

                            boxShadow: isMuted
                              ? "0 4px 15px rgba(102,126,234,0.5)"
                              : "0 4px 15px rgba(75,165,235,0.5)",

                            border: "2px solid #fff",
                            transition: "all 0.3s ease",

                            "&:hover": {
                              transform: "scale(1.1)",
                              boxShadow: isMuted
                                ? "0 6px 20px rgba(102,126,234,0.7)"
                                : "0 6px 20px rgba(75,165,235,0.7)",
                            },

                            animation: !isMuted ? "speakerPulse 2s infinite" : "none",

                            "@keyframes speakerPulse": {
                              "0%": {
                                boxShadow: "0 4px 15px rgba(75,165,235,0.5)",
                              },
                              "50%": {
                                boxShadow: "0 4px 25px rgba(75,165,235,0.9)",
                              },
                              "100%": {
                                boxShadow: "0 4px 15px rgba(75,165,235,0.5)",
                              },
                            },
                          }}
                        >
                          {isMuted ? (
                            <VolumeOffIcon sx={{ color: "#fff", fontSize: 22 }} />
                          ) : (
                            <VolumeUpIcon sx={{ color: "#fff", fontSize: 22 }} />
                          )}
                        </IconButton>

                        {/* Captions Icon - Overlay on image */}
                        <IconButton
                          title={captionsEnabled ? "Disable Captions" : "Enable Captions"}
                          onClick={toggleCaptions}
                          sx={{
                            position: "absolute",
                            top: {
                              xs: 6,
                              sm: 8,
                              md: 10,
                            },
                            left: {
                              xs: 6,
                              sm: 8,
                              md: 10,
                            },
                            zIndex: 10,

                            background: captionsEnabled
                              ? "linear-gradient(135deg, #4BA5EB 0%, #1E7BC0 100%)"
                              : "rgba(107,114,128,0.85)",

                            width: 42,
                            height: 42,
                            borderRadius: "50%",

                            border: "2px solid #fff",
                            boxShadow: captionsEnabled
                              ? "0 4px 15px rgba(75,165,235,0.5)"
                              : "0 4px 15px rgba(107,114,128,0.4)",

                            transition: "all 0.3s ease",

                            "&:hover": {
                              transform: "scale(1.1)",
                            },
                          }}
                        >
                          {captionsEnabled ? (
                            <SubtitlesIcon sx={{ color: "#fff", fontSize: 22 }} />
                          ) : (
                            <SubtitlesOffIcon sx={{ color: "#fff", fontSize: 22 }} />
                          )}
                        </IconButton>

                        {/* Waveform bars — overlaid on the bottom of the image */}
                        <Box
                          sx={{
                            display: isSpeakerAnimating ? "flex" : "none",
                            position: "absolute",
                            left: "50%",
                            bottom: /* isMobile ? '10px' :  */"-10px"/* (isCourseContentsOpen ? "170px" : "146px") */,
                            transform: "translateX(-50%)",
                            zIndex: 5,

                            width: "60px",
                            height: "36px",

                            borderRadius: "999px",

                            background: "linear-gradient(135deg, #2563EB, #3B82F6)",

                            alignItems: "center",
                            justifyContent: "center",
                            gap: "2px",

                            boxShadow: "0 8px 20px rgba(37,99,235,.35)",

                            pointerEvents: "none",
                          }}
                        >
                          {/* [
                          4, 10, 18, 8, 22, 14, 26, 6, 16, 30, 12, 20, 8, 24, 10, 18, 4, 14, 22, 8,
                          16, 28, 10, 20, 6, 24, 12, 18, 8, 14, 26, 10, 16, 22, 6, 20, 12, 8, 24, 14,
                        ] */[6, 12, 18, 10, 24, 30, 24, 10, 18, 12, 6].map((peak, i) => (
                            <Box
                              key={i}
                              sx={{
                                /* width: "2.5px",
                                minWidth: "2.5px", */
                                width: "2px",
                                minWidth: "2px",
                                borderRadius: "2px",
                                // background: "#3B82F6",
                                background: "#fff",
                                animation: `waveStrip${i} 1.1s ease-in-out infinite`,
                                animationDelay: `${(i % 10) * 0.08}s`,
                                [`@keyframes waveStrip${i}`]: {
                                  "0%, 100%": { height: "6px" },
                                  "50%": { height: `${peak}px` },
                                },
                              }}
                            />
                          ))}
                        </Box>
                      </Box>)}

                      {/* chat icon */}
                      {/*  {!isMobile && !isConversationOpen && (
                        <IconButton
                          onClick={() => setIsConversationOpen(true)}
                          sx={{
                            mt: 0.3,
                            width: 40,
                            height: 40,
                            bgcolor: "#fff",
                            border: "1px solid #E5E7EB",
                            boxShadow: 1,
                          }}
                        >
                          <TextsmsOutlinedIcon sx={{ color: "#000" }} />
                        </IconButton>
                      )} */}
                      {/* end chat icon */}

                    </Box>

                    {/* Course Meta Information */}
                    {!selectedSubtopic && !showCourseDefinition && !isLessonQuiz && (<Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 4,
                        px: 1,
                        py: 1.2,
                        // borderBottom: "1px solid #E5E7EB",
                      }}
                    >
                      {/* Level */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.8,
                        }}
                      >
                        <BarChartOutlinedIcon
                          sx={{
                            fontSize: 17,
                            color: "#6B7280",
                          }}
                        />

                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: 500,
                            color: "#6B7280",
                            lineHeight: 1.4,
                          }}
                        >
                          Level:{" "}
                          <Box
                            component="span"
                            sx={{
                              fontWeight: 500,
                              color: "#6B7280",
                            }}
                          >
                            {/* {completeCourseDet?.difficulty} */}
                            {completeCourseDet?.difficulty
                              ? completeCourseDet.difficulty.charAt(0).toUpperCase() +
                              completeCourseDet.difficulty.slice(1)
                              : ""}
                          </Box>
                        </Typography>
                      </Box>

                      {/* Duration */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.8,
                        }}
                      >
                        <AccessTimeOutlinedIcon
                          sx={{
                            fontSize: 17,
                            color: "#6B7280",
                          }}
                        />

                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: 500,
                            color: "#6B7280",
                            lineHeight: 1.4,
                          }}
                        >
                          Duration:{" "}
                          <Box
                            component="span"
                            sx={{
                              fontWeight: 500,
                              color: "#6B7280",
                            }}
                          >
                            {/* {completeCourseDet?.duration} */}
                            {displayModuleDuration}
                            {/* {completeCourseDet?.duration?.replace(/weeks?/i, "Modules")} */}
                          </Box>
                        </Typography>
                      </Box>

                    </Box>)}

                    {/* {currentWeekImage && (
                      <Box
                        sx={{
                          width: "100%",
                          height: 360,
                          overflow: "hidden",
                          borderRadius: "10px",
                          display: "flex",
                          justifyContent: "center",   // centers horizontally
                          alignItems: "center",
                          position: "relative",
                          "&:hover .zoom-icon-overlay": {
                            opacity: 1,
                          },
                        }}
                      >
                        <Box
                          key={`${activeWeekIndex}-${currentWeekImage}`}
                          component="img"
                          src={
                            /^(https?:)?\/\//i.test(currentWeekImage)
                              ? currentWeekImage
                              : `${process.env.REACT_APP_RETURN_DOMAIN_NAME}${currentWeekImage?.startsWith("/") ? "" : "/"
                              }${currentWeekImage}`
                          }
                          onClick={() => setImageZoomOpen(true)}
                          sx={{
                            width: 'auto',
                            height: "100%",
                            cursor: "pointer",
                            transition: "transform 0.2s ease",
                            "&:hover": {
                              transform: "scale(1.01)",
                            },
                          }}
                        />
                        <Box
                          className="zoom-icon-overlay"
                          onClick={() => setImageZoomOpen(true)}
                          sx={{
                            position: "absolute",
                            bottom: 12,
                            right: 12,
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                            bgcolor: "rgba(0,0,0,0.55)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            opacity: 0,
                            transition: "opacity 0.2s ease",
                            "&:hover": { bgcolor: "rgba(0,0,0,0.75)" },
                          }}
                        >
                          <ZoomInIcon sx={{ color: "#fff", fontSize: 20 }} />
                        </Box>
                      </Box>
                    )} */}

                    {/* <Stack direction="row" justifyContent="space-between">
                      <Button
                        startIcon={<ArrowBackIosNewIcon />}
                        sx={{
                          textTransform: "none",
                          color: "#4BA5EB",
                          border: "1px solid #4BA5EB",
                          borderRadius: "4px",
                          px: 2,
                          fontSize: "16px",
                          "&.Mui-disabled": {
                            color: "#BDBDBD",
                            border: "1px solid #E0E0E0",
                          },
                        }}
                        disabled={activeWeekIndex === 0}
                        onClick={() => {
                          if (loggedIn !== "true") {
                            navigate("/signup", { state: { role: "student" } });
                            return;
                          }

                          // stop all playing audio
                          stopAllAudio();

                          // reset chatbot mode
                          isChatbotRequestRef.current = false;

                          setActiveWeekIndex((p) => {
                            const prevIndex = Math.max(p - 1, 0);

                            setSelectedSubtopic(null);
                               setSelectedWeekData(curriculum[prevIndex]);

                            return prevIndex;
                          });

                          // setActiveWeekIndex((p) => Math.max(p - 1, 0));
                        }}
                      >
                        Back
                      </Button>

                      {currentQuiz.length > 0 && (

                        < Button
                          startIcon={<QuizIcon />}
                          sx={{
                            px: 3,
                            py: 1.2,
                            borderRadius: "30px",
                            bgcolor: "#FFF7ED",
                            color: "#EA580C",
                            border: "2px solid #FDBA74",
                            fontWeight: 700,
                            textTransform: "none",
                            animation: "bounce 2s infinite",

                            "@keyframes bounce": {
                              "0%,100%": { transform: "translateY(0)" },
                              "50%": { transform: "translateY(-4px)" },
                            },

                            "&:hover": {
                              bgcolor: "#FFEDD5",
                            },
                          }}
                          onClick={() => {
                            setQuizOpen(true);
                            setCurrentQuizIndex(0);
                            setSelectedAnswer(null);
                            setCorrectCount(0);
                            setShowResult(false);
                          }}
                        >
                          Take Quiz
                        </Button>
                      )}

                      <Button
                        endIcon={<ArrowForwardIosIcon />}
                        variant="contained"
                        sx={{
                          textTransform: "none",
                          borderRadius: "4px",
                          background: "linear-gradient(90deg,#2563eb,#1d9bf0)",
                          color: "#fff",
                          fontSize: "16px",
                        }}
                        disabled={activeWeekIndex === curriculum.length - 1}
                        onClick={() => {
                          if (loggedIn !== "true") {
                            setLoginPopup(true);
                            return;
                          }
                          if (!isOwnCourse && !isEnrolled) {
                            setEnrollPopup(true);
                            return;
                          }
                          // stop ONLY current curriculum wav audio
                          if (curriculumAudioRef.current) {
                            curriculumAudioRef.current.pause();
                            curriculumAudioRef.current.currentTime = 0;
                            curriculumAudioRef.current.src = "";
                          }
                          setActiveWeekIndex((p) => {
                            const nextIndex = Math.min(
                              p + 1,
                              curriculum.length - 1,
                            );

                            setSelectedSubtopic(null);
                                 setSelectedWeekData(curriculum[nextIndex]);

                            return nextIndex;
                          });
                        }}
                      >
                        Next Module
                      </Button>
                    </Stack> */}
                    {(showCourseDefinition && courseDefinition) && (
                      <Box
                        sx={{
                          position: "relative",
                          width: "100%",
                          border: "1px solid #E5E7EB",
                          borderRadius: "10px",
                          overflow: "hidden",
                          backgroundColor: "#FFFFFF",
                          mt: 1,
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          minHeight: 0,
                        }}
                      >
                        <Box
                          sx={{
                            flex: 1,
                            minHeight: 0,
                            overflowY: "auto",
                            p: 2.5,
                            scrollbarWidth: "thin",
                            scrollbarColor: "rgba(0,0,0,0.18) transparent",
                            "&::-webkit-scrollbar": { width: "6px" },
                            "&::-webkit-scrollbar-track": { background: "transparent" },
                            "&::-webkit-scrollbar-thumb": {
                              background: "rgba(0,0,0,0.18)",
                              borderRadius: "10px",
                            },
                          }}
                        >
                          {/* What You'll Learn */}
                          {learningOutcomes.length > 0 && (
                            <Box sx={{ mb: 3 }}>
                              <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1.6 }}>
                                <SchoolIcon sx={{ fontSize: 20, color: "#2563EB" }} />
                                <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "#111827" }}>
                                  What You'll Learn
                                </Typography>
                              </Stack>

                              <Grid container spacing={1.5}>
                                {learningOutcomes.map((point, idx) => {
                                  const IconComp = TAKEAWAY_ICONS[idx % TAKEAWAY_ICONS.length];
                                  const color = AVATAR_COLORS[idx % AVATAR_COLORS.length];
                                  return (
                                    <Grid item xs={12} sm={4} key={idx}>
                                      <Box
                                        sx={{
                                          height: "100%",
                                          p: 1.8,
                                          borderRadius: "10px",
                                          border: "1px solid #E5E7EB",
                                          backgroundColor: "#F9FAFB",
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            width: 36,
                                            height: 36,
                                            borderRadius: "8px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor: `${color}1A`,
                                            mb: 1.2,
                                          }}
                                        >
                                          <IconComp sx={{ fontSize: 20, color }} />
                                        </Box>
                                        <Typography sx={{ fontSize: "12.5px", color: "#374151", lineHeight: 1.6 }}>
                                          {point}
                                        </Typography>
                                      </Box>
                                    </Grid>
                                  );
                                })}
                              </Grid>
                            </Box>
                          )}

                          {/* Who This Course Is For + Prerequisites */}
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <Box
                                sx={{
                                  height: "100%",
                                  p: 2,
                                  borderRadius: "10px",
                                  backgroundColor: "#ECFDF5",
                                  border: "1px solid #A7F3D0",
                                }}
                              >
                                <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                  <PersonIcon sx={{ fontSize: 18, color: "#059669" }} />
                                  <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#065F46" }}>
                                    Who This Course Is For
                                  </Typography>
                                </Stack>
                                <Typography sx={{ fontSize: "12.5px", color: "#065F46", lineHeight: 1.7 }}>
                                  {courseDefinition?.target_audience || completeCourseDet?.target_audience || "—"}
                                </Typography>
                              </Box>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                              <Box
                                sx={{
                                  height: "100%",
                                  p: 2,
                                  borderRadius: "10px",
                                  backgroundColor: "#FFFBEB",
                                  border: "1px solid #FDE68A",
                                }}
                              >
                                <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                  <TaskAltOutlinedIcon sx={{ fontSize: 18, color: "#D97706" }} />
                                  <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#92400E" }}>
                                    Prerequisites
                                  </Typography>
                                </Stack>
                                <Typography sx={{ fontSize: "12.5px", color: "#92400E", lineHeight: 1.7 }}>
                                  {courseDefinition?.prerequisites || "None"}
                                </Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      </Box>
                    )}


                    {/* Lesson Infographic Section */}
                    {showCourseDefinition ? (
                      <Box
                        sx={{
                          position: "relative",
                          width: "100%",
                          border: "1px solid #E5E7EB",
                          borderRadius: "10px",
                          overflow: "hidden",
                          backgroundColor: "#FFFFFF",
                          mt: 1,
                          flex: 1,            // NEW
                          display: "flex",    // NEW
                          flexDirection: "column", // NEW
                          minHeight: 0,        // NEW
                        }}
                      >
                        {/* Section Heading */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            px: 1.5,
                            py: 1.2,
                          }}
                        >
                          {/* <ImageOutlinedIcon
                            sx={{
                              fontSize: 19,
                              color: "#2563EB",
                            }}
                          />

                          <Typography
                            sx={{
                              fontSize: "13px",
                              fontWeight: 700,
                              color: "#111827",
                            }}
                          >
                            Lesson Infographic
                          </Typography> */}
                        </Box>

                        {showProcessingMessage && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 1,
                              mb: 1.2, // ✅ sits above the image, with breathing room below
                              py: 0.9,
                              px: 2,
                              borderRadius: "24px",
                              width: "fit-content",
                              mx: "auto",
                              background: "linear-gradient(90deg, #7C3AED 0%, #2563EB 50%, #06B6D4 100%)",
                              boxShadow: "0 6px 20px rgba(124, 58, 237, 0.35)",
                              animation: "processingPulse 2s ease-in-out infinite",
                              "@keyframes processingPulse": {
                                "0%, 100%": { boxShadow: "0 6px 20px rgba(124, 58, 237, 0.35)" },
                                "50%": { boxShadow: "0 6px 28px rgba(6, 182, 212, 0.5)" },
                              },
                            }}
                          >
                            <AutoAwesomeIcon
                              sx={{
                                fontSize: 16,
                                color: "#fff",
                                animation: "sparkleSpin 1.6s linear infinite",
                                "@keyframes sparkleSpin": {
                                  from: { transform: "rotate(0deg)" },
                                  to: { transform: "rotate(360deg)" },
                                },
                              }}
                            />
                            <Typography
                              key={processingMessage}
                              sx={{
                                color: "#fff",
                                fontSize: "13.5px",
                                fontWeight: 700,
                                letterSpacing: "0.2px",
                                animation: "fadeInText 0.3s ease",
                                "@keyframes fadeInText": {
                                  from: { opacity: 0, transform: "translateY(2px)" },
                                  to: { opacity: 1, transform: "translateY(0)" },
                                },
                              }}
                            >
                              {processingMessage}
                            </Typography>
                          </Box>
                        )}

                        {/* Infographic Image */}
                        <Box
                          sx={{
                            position: "relative",
                            mx: 1,
                            mb: 1.5,
                            maxHeight: "50vh",     // ← hard viewport-based ceiling — always resolves, no flex ambiguity
                            minHeight: 0,
                            overflowY: "auto",
                            overflowX: "hidden",
                            border: "1px solid #E5E7EB",
                            borderRadius: "8px",
                            backgroundColor: "#F8FAFC",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "flex-start",

                            "&::-webkit-scrollbar": { width: "6px" },
                            "&::-webkit-scrollbar-track": { background: "transparent" },
                            "&::-webkit-scrollbar-thumb": {
                              background: "rgba(0,0,0,0.25)",   // darker so it's actually visible
                              borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": { background: "rgba(0,0,0,0.4)" },
                            scrollbarColor: "rgba(0,0,0,0.25) transparent",
                            scrollbarWidth: "thin",
                          }}
                        >
                          <Box
                            /* key={`${activeWeekIndex}-${currentWeekImage}`} */
                            component="img"
                            src={completeCourseDet?.image_path
                              /* /^(https?:)?\/\//i.test(currentWeekImage)
                                ? currentWeekImage
                                : `${process.env.REACT_APP_RETURN_DOMAIN_NAME}${currentWeekImage?.startsWith("/")
                                  ? ""
                                  : "/"
                                }${currentWeekImage}` */
                            }
                            sx={{
                              // width: "100%",
                              width: "100%",
                              height: "auto",
                              display: "block",
                            }}
                          />

                          {/* Subtitle overlay
                          {captionText && isSpeakerAnimating && captionsEnabled && (
                            <Box
                              sx={{
                                position: "absolute",
                                left: "50%",
                                bottom: 16,
                                transform: "translateX(-50%)",
                                width: "95%",              // controls the caption's width
                                maxWidth: "95%",
                                px: 2.5,
                                py: 1,
                                borderRadius: "8px",
                                backgroundColor: "rgba(17,24,39,0.25)",    // lighter/more transparent
                                backdropFilter: "blur(3px)",
                                boxSizing: "border-box",
                              }}
                            >
                              <Typography
                                sx={{
                                  color: "#fff",
                                  fontSize: "14px",
                                  fontWeight: 600,
                                  textAlign: "center",
                                  lineHeight: 1.5,
                                }}
                              >
                                {captionText}
                              </Typography>
                            </Box>
                          )} */}

                        </Box>

                        {/* ✅ Caption overlay — MOVED here, sibling of the image box, anchored to the OUTER box */}
                        {/* {captionText && isSpeakerAnimating && captionsEnabled && (
                          <Box
                            sx={{
                              position: "absolute",
                              left: "50%",
                              bottom: 68,              // ← tune this so it clears the Back/Next nav row below
                              transform: "translateX(-50%)",
                              width: "95%",
                              maxWidth: "95%",
                              px: 2.5,
                              py: 1,
                              borderRadius: "8px",
                              // backgroundColor: "rgba(17,24,39,0.25)",
                              backdropFilter: "blur(3px)",
                              boxSizing: "border-box",
                              zIndex: 5,               // sits above the image, doesn't scroll with it
                              pointerEvents: "none",   // optional: lets clicks/scroll pass through to content beneath
                            }}
                          >
                            <Typography
                              
                            
                              sx={{
                                display: "inline",
                                color: "#fff",
                                fontSize: "14px",
                                fontWeight: 600,
                                lineHeight: 1.6,
                                backgroundColor: "rgba(15, 23, 42, 0.88)",
                                border: "1px solid rgba(255,255,255,0.14)",
                                px: 1.2,
                                py: 0.45,
                                borderRadius: "6px",
                                boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
                                boxDecorationBreak: "clone",
                                WebkitBoxDecorationBreak: "clone",
                              }}
                            >
                              {captionText}
                            </Typography>
                          </Box>
                        )} */}



                        {captionText && isSpeakerAnimating && captionsEnabled && (
                          <Box
                            onMouseDown={handleCaptionMouseDown}
                            onTouchStart={handleCaptionTouchStart}
                            sx={{
                              position: "absolute",
                              ...(captionPos
                                ? { left: captionPos.x, top: captionPos.y, bottom: "auto", transform: "none" }
                                : { left: "50%", top: 12, bottom: "auto", transform: "translateX(-50%)" }),
                              maxWidth: "90%",
                              width: "fit-content",
                              zIndex: 5,
                              cursor: "grab",
                              userSelect: "none",
                              touchAction: "none",
                              "&:active": { cursor: "grabbing" },
                            }}
                          >

                            <Box
                              sx={{
                                position: "relative",
                                backgroundColor: "rgba(15, 23, 42, 0.88)",
                                border: "1px solid rgba(255,255,255,0.14)",
                                borderRadius: "6px",
                                boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
                                px: 1.2,
                                pt: 0.45,
                                pb: 0.45,
                                pr: 3.2, //  room for the icon so it doesn't overlap text
                              }}
                            >
                              {/* ✅ Drag handle icon — top-right corner */}
                              <OpenWithIcon
                                sx={{
                                  position: "absolute",
                                  top: 3,
                                  right: 3,
                                  fontSize: 14,
                                  color: "rgba(255,255,255,0.55)",
                                  pointerEvents: "none",
                                }}
                              />

                              <Typography
                                sx={{
                                  display: "inline-block",
                                  color: "#fff",
                                  fontSize: "14px",
                                  fontWeight: 600,
                                  lineHeight: 1.6,
                                  backgroundColor: "rgba(15, 23, 42, 0.88)",
                                  border: "1px solid rgba(255,255,255,0.14)",
                                  px: 1.2,
                                  py: 0.45,
                                  borderRadius: "6px",
                                  boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
                                  boxDecorationBreak: "clone",
                                  WebkitBoxDecorationBreak: "clone",
                                  pointerEvents: "none",  // text itself doesn't need its own drag target
                                }}
                              >
                                {captionText}
                              </Typography>
                            </Box>
                          </Box>
                        )}

                        {/* Navigation */}
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="space-between"
                          sx={{
                            px: 1.5,
                            pb: 1.5,
                          }}
                        >
                          {/* Back */}
                          <Button
                            startIcon={<ArrowBackIosNewIcon />}
                            sx={{
                              textTransform: "none",
                              color: "#374151",
                              border: "1px solid #D1D5DB",
                              borderRadius: "6px",
                              px: 1.5,
                              py: 0.7,
                              fontSize: "13px",
                              backgroundColor: "#FFFFFF",

                              "&:hover": {
                                backgroundColor: "#F9FAFB",
                                borderColor: "#9CA3AF",
                              },

                              "&.Mui-disabled": {
                                color: "#BDBDBD",
                                borderColor: "#E5E7EB",
                              },
                            }}
                            disabled={activeWeekIndex === 0}
                            onClick={() => {
                              if (loggedIn !== "true") {
                                navigate("/signup", {
                                  state: { role: "student" },
                                });
                                return;
                              }

                              stopAllAudio();

                              isChatbotRequestRef.current = false;

                              setActiveWeekIndex((p) => {
                                const prevIndex = Math.max(p - 1, 0);

                                setSelectedWeekData(
                                  curriculum[prevIndex]
                                );

                                return prevIndex;
                              });
                            }}
                          >
                            Back
                          </Button>

                          {/* Module Indicator */}
                          <Typography
                            sx={{
                              fontSize: "13px",
                              fontWeight: 700,
                              color: "#111827",
                            }}
                          >
                            {/* Module {activeWeekIndex + 1} of{" "}
                            {curriculum.length} */}
                            {showCourseDefinition ? `Course Definition` : `Module ${activeWeekIndex + 1} of ${curriculum.length}`}
                          </Typography>

                          {/* Next Module */}
                          <Button
                            endIcon={<ArrowForwardIosIcon />}
                            variant="contained"
                            sx={{
                              textTransform: "none",
                              borderRadius: "6px",
                              px: 1.5,
                              py: 0.7,
                              background:
                                "linear-gradient(90deg,#2563eb,#1d9bf0)",
                              color: "#fff",
                              fontSize: "13px",
                              boxShadow: "none",

                              "&:hover": {
                                background:
                                  "linear-gradient(90deg,#1d4ed8,#0284c7)",
                                boxShadow: "none",
                              },
                            }}
                            disabled={
                              activeWeekIndex === curriculum.length - 1
                            }
                            /* onClick={() => {
                              if (loggedIn !== "true") {
                                setLoginPopup(true);
                                return;
                              }

                              if (!isOwnCourse && !isEnrolled) {
                                setEnrollPopup(true);
                                return;
                              }

                              if (curriculumAudioRef.current) {
                                curriculumAudioRef.current.pause();
                                curriculumAudioRef.current.currentTime = 0;
                                curriculumAudioRef.current.src = "";
                              }

                              setActiveWeekIndex((p) => {
                                const nextIndex = Math.min(
                                  p + 1,
                                  curriculum.length - 1
                                );

                                setSelectedWeekData(
                                  curriculum[nextIndex]
                                );

                                return nextIndex;
                              });
                            }} */
                            onClick={() => {
                              if (loggedIn !== "true") {
                                setLoginPopup(true);
                                return;
                              }

                              if (!isOwnCourse && !isEnrolled) {
                                setEnrollPopup(true);
                                return;
                              }

                              // Stop currently playing audio
                              stopAllAudio();

                              if (curriculumAudioRef.current) {
                                curriculumAudioRef.current.pause();
                                curriculumAudioRef.current.currentTime = 0;
                                curriculumAudioRef.current.src = "";
                              }

                              // If user is currently on Course Definition / Overview,
                              // Next Module should open Module 1.
                              if (showCourseDefinition) {
                                setShowCourseDefinition(false);
                                setSelectedSubtopic(null);
                                setExpandedWeeks([0]);

                                setActiveWeekIndex(0);
                                setSelectedWeekData(curriculum[0]);

                                return;
                              }

                              // Normal module navigation: Module 1 -> Module 2 -> Module 3...
                              setActiveWeekIndex((p) => {
                                const nextIndex = Math.min(
                                  p + 1,
                                  curriculum.length - 1
                                );

                                setSelectedSubtopic(null);
                                setSelectedWeekData(curriculum[nextIndex]);

                                return nextIndex;
                              });
                            }}
                          >
                            Next Module
                          </Button>
                        </Stack>
                      </Box>
                    ) : !showCourseDefinition && !selectedSubtopic && currentWeekImage && !isLessonQuiz ? (
                      <Box
                        sx={{
                          position: "relative",
                          width: "100%",
                          border: "1px solid #E5E7EB",
                          borderRadius: "10px",
                          overflow: "hidden",
                          backgroundColor: "#FFFFFF",
                          mt: 1,
                          flex: 1,            // NEW
                          display: "flex",    // NEW
                          flexDirection: "column", // NEW
                          minHeight: 0,        // NEW
                        }}
                      >
                        {/* Section Heading */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            px: 1.5,
                            py: 1.2,
                          }}
                        >
                          {/* <ImageOutlinedIcon
                            sx={{
                              fontSize: 19,
                              color: "#2563EB",
                            }}
                          />

                          <Typography
                            sx={{
                              fontSize: "13px",
                              fontWeight: 700,
                              color: "#111827",
                            }}
                          >
                            Lesson Infographic
                          </Typography> */}
                        </Box>

                        {showProcessingMessage && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 1,
                              mb: 1.2, // ✅ sits above the image, with breathing room below
                              py: 0.9,
                              px: 2,
                              borderRadius: "24px",
                              width: "fit-content",
                              mx: "auto",
                              background: "linear-gradient(90deg, #7C3AED 0%, #2563EB 50%, #06B6D4 100%)",
                              boxShadow: "0 6px 20px rgba(124, 58, 237, 0.35)",
                              animation: "processingPulse 2s ease-in-out infinite",
                              "@keyframes processingPulse": {
                                "0%, 100%": { boxShadow: "0 6px 20px rgba(124, 58, 237, 0.35)" },
                                "50%": { boxShadow: "0 6px 28px rgba(6, 182, 212, 0.5)" },
                              },
                            }}
                          >
                            <AutoAwesomeIcon
                              sx={{
                                fontSize: 16,
                                color: "#fff",
                                animation: "sparkleSpin 1.6s linear infinite",
                                "@keyframes sparkleSpin": {
                                  from: { transform: "rotate(0deg)" },
                                  to: { transform: "rotate(360deg)" },
                                },
                              }}
                            />
                            <Typography
                              key={processingMessage}
                              sx={{
                                color: "#fff",
                                fontSize: "13.5px",
                                fontWeight: 700,
                                letterSpacing: "0.2px",
                                animation: "fadeInText 0.3s ease",
                                "@keyframes fadeInText": {
                                  from: { opacity: 0, transform: "translateY(2px)" },
                                  to: { opacity: 1, transform: "translateY(0)" },
                                },
                              }}
                            >
                              {processingMessage}
                            </Typography>
                          </Box>
                        )}

                        {/* Infographic Image */}
                        <Box
                          sx={{
                            position: "relative",
                            mx: 1,
                            mb: 1.5,
                            maxHeight: "50vh",     // ← hard viewport-based ceiling — always resolves, no flex ambiguity
                            minHeight: 0,
                            overflowY: "auto",
                            overflowX: "hidden",
                            border: "1px solid #E5E7EB",
                            borderRadius: "8px",
                            backgroundColor: "#F8FAFC",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "flex-start",

                            "&::-webkit-scrollbar": { width: "6px" },
                            "&::-webkit-scrollbar-track": { background: "transparent" },
                            "&::-webkit-scrollbar-thumb": {
                              background: "rgba(0,0,0,0.25)",   // darker so it's actually visible
                              borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": { background: "rgba(0,0,0,0.4)" },
                            scrollbarColor: "rgba(0,0,0,0.25) transparent",
                            scrollbarWidth: "thin",
                          }}
                        >
                          <Box
                            key={`${activeWeekIndex}-${currentWeekImage}`}
                            component="img"
                            src={
                              /^(https?:)?\/\//i.test(currentWeekImage)
                                ? currentWeekImage
                                : `${process.env.REACT_APP_RETURN_DOMAIN_NAME}${currentWeekImage?.startsWith("/")
                                  ? ""
                                  : "/"
                                }${currentWeekImage}`
                            }
                            sx={{
                              // width: "100%",
                              width: "100%",
                              height: "auto",
                              display: "block",
                            }}
                          />

                          {/* Subtitle overlay
                          {captionText && isSpeakerAnimating && captionsEnabled && (
                            <Box
                              sx={{
                                position: "absolute",
                                left: "50%",
                                bottom: 16,
                                transform: "translateX(-50%)",
                                width: "95%",              // controls the caption's width
                                maxWidth: "95%",
                                px: 2.5,
                                py: 1,
                                borderRadius: "8px",
                                backgroundColor: "rgba(17,24,39,0.25)",    // lighter/more transparent
                                backdropFilter: "blur(3px)",
                                boxSizing: "border-box",
                              }}
                            >
                              <Typography
                                sx={{
                                  color: "#fff",
                                  fontSize: "14px",
                                  fontWeight: 600,
                                  textAlign: "center",
                                  lineHeight: 1.5,
                                }}
                              >
                                {captionText}
                              </Typography>
                            </Box>
                          )} */}
                          {/* ✅ Caption overlay — MOVED here, sibling of the image box, anchored to the OUTER box */}
                          {/* {captionText && isSpeakerAnimating && captionsEnabled && (
                            <Box
                              sx={{
                                position: "absolute",
                                left: "50%",
                                bottom: 68,              // ← tune this so it clears the Back/Next nav row below
                                transform: "translateX(-50%)",
                                width: "95%",
                                maxWidth: "95%",
                                px: 2.5,
                                py: 1,
                                borderRadius: "8px",
                                // backgroundColor: "rgba(17,24,39,0.25)",
                                backdropFilter: "blur(3px)",
                                boxSizing: "border-box",
                                zIndex: 5,               // sits above the image, doesn't scroll with it
                                pointerEvents: "none",   // optional: lets clicks/scroll pass through to content beneath
                              }}
                            >
                              <Typography
                                
                                sx={{
                                  display: "inline",
                                  color: "#fff",
                                  fontSize: "14px",
                                  fontWeight: 600,
                                  lineHeight: 1.6,
                                  backgroundColor: "rgba(15, 23, 42, 0.88)",
                                  border: "1px solid rgba(255,255,255,0.14)",
                                  px: 1.2,
                                  py: 0.45,
                                  borderRadius: "6px",
                                  boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
                                  boxDecorationBreak: "clone",
                                  WebkitBoxDecorationBreak: "clone",
                                }}
                              >
                                {captionText}
                              </Typography>
                            </Box>
                          )} */}

                          {captionText && isSpeakerAnimating && captionsEnabled && (
                            <Box
                              onMouseDown={handleCaptionMouseDown}
                              onTouchStart={handleCaptionTouchStart}
                              sx={{
                                position: "absolute",
                                ...(captionPos
                                  ? { left: captionPos.x, top: captionPos.y, bottom: "auto", transform: "none" }
                                  : { left: "50%", top: 12, bottom: "auto", transform: "translateX(-50%)" }),
                                maxWidth: "90%",
                                width: "fit-content",
                                zIndex: 5,
                                cursor: "grab",
                                userSelect: "none",
                                touchAction: "none",
                                "&:active": { cursor: "grabbing" },
                              }}
                            >
                              <Box
                                sx={{
                                  position: "relative",
                                  backgroundColor: "rgba(15, 23, 42, 0.88)",
                                  border: "1px solid rgba(255,255,255,0.14)",
                                  borderRadius: "6px",
                                  boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
                                  px: 1.2,
                                  pt: 0.45,
                                  pb: 0.45,
                                  pr: 3.2, //  room for the icon so it doesn't overlap text
                                }}
                              >
                                {/*  Drag handle icon — top-right corner */}
                                <OpenWithIcon
                                  sx={{
                                    position: "absolute",
                                    top: 3,
                                    right: 3,
                                    fontSize: 14,
                                    color: "rgba(255,255,255,0.55)",
                                    pointerEvents: "none",
                                  }}
                                />

                                <Typography
                                  sx={{
                                    display: "inline-block",
                                    color: "#fff",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    lineHeight: 1.6,
                                    backgroundColor: "rgba(15, 23, 42, 0.88)",
                                    border: "1px solid rgba(255,255,255,0.14)",
                                    px: 1.2,
                                    py: 0.45,
                                    borderRadius: "6px",
                                    boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
                                    boxDecorationBreak: "clone",
                                    WebkitBoxDecorationBreak: "clone",
                                    pointerEvents: "none",  // text itself doesn't need its own drag target
                                  }}
                                >
                                  {captionText}
                                </Typography>
                              </Box>
                            </Box>
                          )}


                        </Box>



                        {/* Navigation */}
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="space-between"
                          sx={{
                            px: 1.5,
                            pb: 1.5,
                          }}
                        >
                          {/* Back */}
                          <Button
                            startIcon={<ArrowBackIosNewIcon />}
                            sx={{
                              textTransform: "none",
                              color: "#374151",
                              border: "1px solid #D1D5DB",
                              borderRadius: "6px",
                              px: 1.5,
                              py: 0.7,
                              fontSize: "13px",
                              backgroundColor: "#FFFFFF",

                              "&:hover": {
                                backgroundColor: "#F9FAFB",
                                borderColor: "#9CA3AF",
                              },

                              "&.Mui-disabled": {
                                color: "#BDBDBD",
                                borderColor: "#E5E7EB",
                              },
                            }}
                            disabled={activeWeekIndex === 0}
                            onClick={() => {
                              if (loggedIn !== "true") {
                                navigate("/signup", {
                                  state: { role: "student" },
                                });
                                return;
                              }

                              stopAllAudio();

                              isChatbotRequestRef.current = false;

                              setActiveWeekIndex((p) => {
                                const prevIndex = Math.max(p - 1, 0);

                                setSelectedWeekData(
                                  curriculum[prevIndex]
                                );

                                return prevIndex;
                              });
                            }}
                          >
                            Back
                          </Button>

                          {/* Module Indicator */}
                          <Typography
                            sx={{
                              fontSize: "13px",
                              fontWeight: 700,
                              color: "#111827",
                            }}
                          >
                            Module {activeWeekIndex + 1} of{" "}
                            {curriculum.length}
                          </Typography>

                          {/* Next Module */}
                          <Button
                            endIcon={<ArrowForwardIosIcon />}
                            variant="contained"
                            sx={{
                              textTransform: "none",
                              borderRadius: "6px",
                              px: 1.5,
                              py: 0.7,
                              background:
                                "linear-gradient(90deg,#2563eb,#1d9bf0)",
                              color: "#fff",
                              fontSize: "13px",
                              boxShadow: "none",

                              "&:hover": {
                                background:
                                  "linear-gradient(90deg,#1d4ed8,#0284c7)",
                                boxShadow: "none",
                              },
                            }}
                            disabled={
                              activeWeekIndex === curriculum.length - 1
                            }
                            onClick={() => {
                              if (loggedIn !== "true") {
                                setLoginPopup(true);
                                return;
                              }

                              if (!isOwnCourse && !isEnrolled) {
                                setEnrollPopup(true);
                                return;
                              }

                              if (curriculumAudioRef.current) {
                                curriculumAudioRef.current.pause();
                                curriculumAudioRef.current.currentTime = 0;
                                curriculumAudioRef.current.src = "";
                              }

                              setActiveWeekIndex((p) => {
                                const nextIndex = Math.min(
                                  p + 1,
                                  curriculum.length - 1
                                );

                                setSelectedWeekData(
                                  curriculum[nextIndex]
                                );

                                return nextIndex;
                              });
                            }}
                          >
                            Next Module
                          </Button>
                        </Stack>
                      </Box>
                    ) : !showCourseDefinition && selectedSubtopic && currentLessonImage && !isLessonQuiz ? (
                      <Box
                        sx={{
                          position: "relative",
                          width: "100%",
                          border: "1px solid #E5E7EB",
                          borderRadius: "10px",
                          overflow: "hidden",
                          backgroundColor: "#FFFFFF",
                          mt: 1,
                          flex: 1,            // NEW
                          display: "flex",    // NEW
                          flexDirection: "column", // NEW
                          minHeight: 0,        // NEW
                        }}
                      >
                        {/* Section Heading */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            px: 1.5,
                            py: 1.2,
                          }}
                        >
                          {/* <ImageOutlinedIcon
                            sx={{
                              fontSize: 19,
                              color: "#2563EB",
                            }}
                          />

                          <Typography
                            sx={{
                              fontSize: "13px",
                              fontWeight: 700,
                              color: "#111827",
                            }}
                          >
                            Lesson Infographic
                          </Typography> */}
                        </Box>

                        {showProcessingMessage && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 1,
                              mb: 1.2, // ✅ sits above the image, with breathing room below
                              py: 0.9,
                              px: 2,
                              borderRadius: "24px",
                              width: "fit-content",
                              mx: "auto",
                              background: "linear-gradient(90deg, #7C3AED 0%, #2563EB 50%, #06B6D4 100%)",
                              boxShadow: "0 6px 20px rgba(124, 58, 237, 0.35)",
                              animation: "processingPulse 2s ease-in-out infinite",
                              "@keyframes processingPulse": {
                                "0%, 100%": { boxShadow: "0 6px 20px rgba(124, 58, 237, 0.35)" },
                                "50%": { boxShadow: "0 6px 28px rgba(6, 182, 212, 0.5)" },
                              },
                            }}
                          >
                            <AutoAwesomeIcon
                              sx={{
                                fontSize: 16,
                                color: "#fff",
                                animation: "sparkleSpin 1.6s linear infinite",
                                "@keyframes sparkleSpin": {
                                  from: { transform: "rotate(0deg)" },
                                  to: { transform: "rotate(360deg)" },
                                },
                              }}
                            />
                            <Typography
                              key={processingMessage}
                              sx={{
                                color: "#fff",
                                fontSize: "13.5px",
                                fontWeight: 700,
                                letterSpacing: "0.2px",
                                animation: "fadeInText 0.3s ease",
                                "@keyframes fadeInText": {
                                  from: { opacity: 0, transform: "translateY(2px)" },
                                  to: { opacity: 1, transform: "translateY(0)" },
                                },
                              }}
                            >
                              {processingMessage}
                            </Typography>
                          </Box>
                        )}

                        {/* Infographic Image */}
                        <Box
                          sx={{
                            position: "relative",
                            mx: 1,
                            mb: 1.5,
                            maxHeight: "50vh",     // ← hard viewport-based ceiling — always resolves, no flex ambiguity
                            minHeight: 0,
                            overflowY: "auto",
                            overflowX: "hidden",
                            border: "1px solid #E5E7EB",
                            borderRadius: "8px",
                            backgroundColor: "#F8FAFC",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "flex-start",

                            "&::-webkit-scrollbar": { width: "6px" },
                            "&::-webkit-scrollbar-track": { background: "transparent" },
                            "&::-webkit-scrollbar-thumb": {
                              background: "rgba(0,0,0,0.25)",   // darker so it's actually visible
                              borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": { background: "rgba(0,0,0,0.4)" },
                            scrollbarColor: "rgba(0,0,0,0.25) transparent",
                            scrollbarWidth: "thin",
                          }}
                        >
                          <Box
                            // key={`${activeWeekIndex}-${currentWeekImage}`}
                            component="img"
                            src={currentLessonImage}
                            sx={{
                              // width: "100%",
                              width: "100%",
                              height: "auto",
                              display: "block",
                            }}
                          />

                          {/* Subtitle overlay
                          {captionText && isSpeakerAnimating && captionsEnabled && (
                            <Box
                              sx={{
                                position: "absolute",
                                left: "50%",
                                bottom: 16,
                                transform: "translateX(-50%)",
                                width: "95%",              // controls the caption's width
                                maxWidth: "95%",
                                px: 2.5,
                                py: 1,
                                borderRadius: "8px",
                                backgroundColor: "rgba(17,24,39,0.25)",    // lighter/more transparent
                                backdropFilter: "blur(3px)",
                                boxSizing: "border-box",
                              }}
                            >
                              <Typography
                                sx={{
                                  color: "#fff",
                                  fontSize: "14px",
                                  fontWeight: 600,
                                  textAlign: "center",
                                  lineHeight: 1.5,
                                }}
                              >
                                {captionText}
                              </Typography>
                            </Box>
                          )} */}
                          {/* ✅ Caption overlay — MOVED here, sibling of the image box, anchored to the OUTER box */}
                          {/* {captionText && isSpeakerAnimating && captionsEnabled && (
                            <Box
                              sx={{
                                position: "absolute",
                                left: "50%",
                                bottom: 68,              // ← tune this so it clears the Back/Next nav row below
                                transform: "translateX(-50%)",
                                width: "95%",
                                maxWidth: "95%",
                                px: 2.5,
                                py: 1,
                                borderRadius: "8px",
                                // backgroundColor: "rgba(17,24,39,0.25)",
                                backdropFilter: "blur(3px)",
                                boxSizing: "border-box",
                                zIndex: 5,               // sits above the image, doesn't scroll with it
                                pointerEvents: "none",   // optional: lets clicks/scroll pass through to content beneath
                              }}
                            >
                              <Typography
                           
                                sx={{
                                  display: "inline",
                                  color: "#fff",
                                  fontSize: "14px",
                                  fontWeight: 600,
                                  lineHeight: 1.6,
                                  backgroundColor: "rgba(15, 23, 42, 0.88)",
                                  border: "1px solid rgba(255,255,255,0.14)",
                                  px: 1.2,
                                  py: 0.45,
                                  borderRadius: "6px",
                                  boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
                                  boxDecorationBreak: "clone",
                                  WebkitBoxDecorationBreak: "clone",
                                }}
                              >
                                {captionText}
                              </Typography>
                            </Box>
                          )} */}

                          {captionText && isSpeakerAnimating && captionsEnabled && (
                            <Box
                              onMouseDown={handleCaptionMouseDown}
                              onTouchStart={handleCaptionTouchStart}
                              sx={{
                                position: "absolute",
                                ...(captionPos
                                  ? { left: captionPos.x, top: captionPos.y, bottom: "auto", transform: "none" }
                                  : { left: "50%", top: 12, bottom: "auto", transform: "translateX(-50%)" }),
                                maxWidth: "90%",
                                width: "fit-content",
                                zIndex: 5,
                                cursor: "grab",
                                userSelect: "none",
                                touchAction: "none",
                                "&:active": { cursor: "grabbing" },
                              }}
                            >

                              <Box
                                sx={{
                                  position: "relative",
                                  backgroundColor: "rgba(15, 23, 42, 0.88)",
                                  border: "1px solid rgba(255,255,255,0.14)",
                                  borderRadius: "6px",
                                  boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
                                  px: 1.2,
                                  pt: 0.45,
                                  pb: 0.45,
                                  pr: 3.2, //  room for the icon so it doesn't overlap text
                                }}
                              >
                                {/*  Drag handle icon — top-right corner */}
                                <OpenWithIcon
                                  sx={{
                                    position: "absolute",
                                    top: 3,
                                    right: 3,
                                    fontSize: 14,
                                    color: "rgba(255,255,255,0.55)",
                                    pointerEvents: "none",
                                  }}
                                />

                                <Typography
                                  sx={{
                                    display: "inline-block",
                                    color: "#fff",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    lineHeight: 1.6,
                                    backgroundColor: "rgba(15, 23, 42, 0.88)",
                                    border: "1px solid rgba(255,255,255,0.14)",
                                    px: 1.2,
                                    py: 0.45,
                                    borderRadius: "6px",
                                    boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
                                    boxDecorationBreak: "clone",
                                    WebkitBoxDecorationBreak: "clone",
                                    pointerEvents: "none",  // text itself doesn't need its own drag target
                                  }}
                                >
                                  {captionText}
                                </Typography>
                              </Box>
                            </Box>
                          )}


                        </Box>

                        {/* Key Takeaways strip — always shows for a selected lesson, independent of whether an image exists */}
                        {selectedSubtopic && keyTakeaways.length > 0 && (
                          <Box
                            sx={{
                              mx: 1,
                              mt: 1.5,
                              mb: 1.5,
                              p: 2,
                              borderRadius: "10px",
                              border: "1px solid #E5E7EB",
                              backgroundColor: "#F9FAFB",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "12px",
                                fontWeight: 700,
                                color: "#2563EB",
                                textTransform: "uppercase",
                                letterSpacing: "0.4px",
                                mb: 1.6,
                              }}
                            >
                              In this Lesson, you will learn...
                            </Typography>

                            <Stack
                              direction="row"
                              alignItems="flex-start"
                              justifyContent="space-between"
                              flexWrap="wrap"
                              rowGap={1.5}
                            >
                              {keyTakeaways.map((point, idx) => {
                                const IconComp = TAKEAWAY_ICONS[idx % TAKEAWAY_ICONS.length];
                                const isLast = idx === keyTakeaways.length - 1;

                                return (
                                  <Fragment key={idx}>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        textAlign: "center",
                                        flex: "1 1 90px",
                                        minWidth: 90,
                                        maxWidth: 170,
                                        px: 0.5,
                                      }}
                                    >
                                      <IconComp sx={{ fontSize: 26, color: "#2563EB", mb: 1 }} />
                                      <Typography
                                        sx={{
                                          fontSize: "11.5px",
                                          fontWeight: 500,
                                          color: "#4B5563",
                                          lineHeight: 1.5,
                                        }}
                                      >
                                        {point}
                                      </Typography>
                                    </Box>

                                    {!isLast && (
                                      <ChevronRightIcon
                                        sx={{
                                          fontSize: 36,              // little bigger
                                          color: "#CBD5E1",
                                          flexShrink: 0,
                                          alignSelf: "center",       // vertical center
                                          mx: 0.5,
                                          display: { xs: "none", sm: "block" },
                                        }}
                                      />
                                    )}
                                  </Fragment>
                                );
                              })}
                            </Stack>
                          </Box>
                        )}



                        {/* Navigation */}
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="space-between"
                          sx={{
                            px: 1.5,
                            pb: 1.5,
                          }}
                        >
                          {/* Back */}
                          <Button
                            startIcon={<ArrowBackIosNewIcon />}
                            sx={{
                              textTransform: "none",
                              color: "#374151",
                              border: "1px solid #D1D5DB",
                              borderRadius: "6px",
                              px: 1.5,
                              py: 0.7,
                              fontSize: "13px",
                              backgroundColor: "#FFFFFF",

                              "&:hover": {
                                backgroundColor: "#F9FAFB",
                                borderColor: "#9CA3AF",
                              },

                              "&.Mui-disabled": {
                                color: "#BDBDBD",
                                borderColor: "#E5E7EB",
                              },
                            }}
                            disabled={activeWeekIndex === 0}
                            onClick={() => {
                              if (loggedIn !== "true") {
                                navigate("/signup", {
                                  state: { role: "student" },
                                });
                                return;
                              }

                              stopAllAudio();

                              isChatbotRequestRef.current = false;

                              setActiveWeekIndex((p) => {
                                const prevIndex = Math.max(p - 1, 0);

                                setSelectedWeekData(
                                  curriculum[prevIndex]
                                );

                                return prevIndex;
                              });
                            }}
                          >
                            Back
                          </Button>

                          {/* Module Indicator */}
                          <Typography
                            sx={{
                              fontSize: "13px",
                              fontWeight: 700,
                              color: "#111827",
                            }}
                          >
                            Module {activeWeekIndex + 1} of{" "}
                            {curriculum.length}
                          </Typography>

                          {/* Next Module */}
                          <Button
                            endIcon={<ArrowForwardIosIcon />}
                            variant="contained"
                            sx={{
                              textTransform: "none",
                              borderRadius: "6px",
                              px: 1.5,
                              py: 0.7,
                              background:
                                "linear-gradient(90deg,#2563eb,#1d9bf0)",
                              color: "#fff",
                              fontSize: "13px",
                              boxShadow: "none",

                              "&:hover": {
                                background:
                                  "linear-gradient(90deg,#1d4ed8,#0284c7)",
                                boxShadow: "none",
                              },
                            }}
                            disabled={
                              activeWeekIndex === curriculum.length - 1
                            }
                            onClick={() => {
                              if (loggedIn !== "true") {
                                setLoginPopup(true);
                                return;
                              }

                              if (!isOwnCourse && !isEnrolled) {
                                setEnrollPopup(true);
                                return;
                              }

                              if (curriculumAudioRef.current) {
                                curriculumAudioRef.current.pause();
                                curriculumAudioRef.current.currentTime = 0;
                                curriculumAudioRef.current.src = "";
                              }

                              setActiveWeekIndex((p) => {
                                const nextIndex = Math.min(
                                  p + 1,
                                  curriculum.length - 1
                                );

                                setSelectedWeekData(
                                  curriculum[nextIndex]
                                );

                                return nextIndex;
                              });
                            }}
                          >
                            Next Module
                          </Button>
                        </Stack>
                      </Box>
                    ) : <></>}


                  </Stack>
                  {/*  )} */}
                </Grid>

                {isConversationOpen && (<Grid item xs={12} md={isCourseContentsOpen ? 3 : 3} sx={{ height: "100%", minHeight: 0, contain: { md: "size" } }}>
                  <Box sx={{ height: "100%", minHeight: 0, display: "flex", flexDirection: "column" }}>

                    {isCourseInstructor && (
                      <Box
                        sx={{
                          px: 2,
                          py: 1.2,
                          borderRadius: "10px",
                          background: "linear-gradient(90deg,#EEF2FF,#F5F3FF)",
                          border: "1px solid #C7D2FE",
                          mb: 2,
                        }}
                      >
                        <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#3730A3", mb: 0.3 }}>
                          Instructor preview
                        </Typography>
                        <Typography sx={{ fontSize: 11.5, color: "#4338CA", mb: 1, lineHeight: 1.5 }}>
                          See how the completion certificate will look for your students. It will be available to students after completion of course.
                          This sample uses your name.
                        </Typography>

                        <Button
                          fullWidth
                          size="small"
                          variant="contained"
                          disabled={downloadingCertificate}
                          onClick={handleDownloadCertificate}
                          startIcon={
                            downloadingCertificate ? undefined : <WorkspacePremiumOutlinedIcon sx={{ fontSize: 16 }} />
                          }
                          sx={{
                            textTransform: "none",
                            fontSize: 12,
                            fontWeight: 700,
                            borderRadius: "8px",
                            py: 0.8,
                            color: "#fff",
                            background: "#4F46E5",
                            "&:hover": { background: "#4338CA" },
                            "&.Mui-disabled": { color: "#fff", opacity: 0.7 },
                          }}
                        >
                          {downloadingCertificate ? (
                            <CircularProgress size={16} sx={{ color: "#fff" }} />
                          ) : (
                            "Download Sample Certificate"
                          )}
                        </Button>
                      </Box>
                    )}

                    {isEnrolled && isCourseCompleted && (
                      <Box
                        sx={{
                          px: 2,
                          py: 1.2,
                          borderRadius: "10px",
                          background: "linear-gradient(90deg,#ECFDF5,#F0FDF4)",
                          border: "1px solid #A7F3D0",
                          mb: 2,
                        }}
                      >
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="space-between"
                          mb={1}
                        >
                          <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#065F46" }}>
                            🎉 Course completed!
                          </Typography>
                          <Button
                            size="small"
                            onClick={() => setReviewPopupOpen(true)}
                            sx={{
                              textTransform: "none",
                              fontSize: 12,
                              fontWeight: 700,
                              color: "#059669",
                              "&:hover": { background: "transparent", textDecoration: "underline" },
                            }}
                          >
                            Leave a Review
                          </Button>
                        </Stack>

                        <Button
                          fullWidth
                          size="small"
                          variant="contained"
                          disabled={downloadingCertificate}
                          onClick={handleDownloadCertificate}
                          startIcon={
                            downloadingCertificate ? undefined : <WorkspacePremiumOutlinedIcon sx={{ fontSize: 16 }} />
                          }
                          sx={{
                            textTransform: "none",
                            fontSize: 12,
                            fontWeight: 700,
                            borderRadius: "8px",
                            py: 0.8,
                            background: "#d0f3e8",
                            "&:hover": { background: "#047857" },
                          }}
                        >
                          {downloadingCertificate ? (
                            <CircularProgress size={16} sx={{ color: "#fff" }} />
                          ) : (
                            "Download Certificate"
                          )}
                        </Button>
                      </Box>
                    )}

                    {isLessonQuiz ? (
                      <Paper
                        sx={{
                          borderRadius: "12px",
                          border: "1px solid #E5E7EB",
                          boxShadow: "none",
                          backgroundColor: '#fff',
                          p: 2,
                          mb: 2,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "13px",
                            fontWeight: 700,
                            color: "#111827",
                            mb: 2,
                          }}
                        >
                          Quiz Progress
                        </Typography>

                        <Box
                          sx={{
                            width: 110,
                            height: 110,
                            borderRadius: "50%",
                            mx: "auto",
                            mb: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: `conic-gradient(
                              #2563EB ${quizProgressPercentage}%,
                              #E5E7EB 0
                            )`,
                            position: "relative",
                          }}
                        >
                          <Box
                            sx={{
                              width: 88,
                              height: 88,
                              borderRadius: "50%",
                              backgroundColor: "#fff",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "20px",
                                fontWeight: 700,
                                color: "#111827",
                              }}
                            >
                              {quizProgressPercentage}%
                            </Typography>

                            <Typography
                              sx={{
                                fontSize: "9px",
                                color: "#6B7280",
                              }}
                            >
                              Complete
                            </Typography>
                          </Box>
                        </Box>

                        <Stack spacing={1}>
                          <Stack
                            direction="row"
                            justifyContent="space-between"
                          >
                            <Typography sx={{ fontSize: "12px", color: "#000" }}>
                              Answered
                            </Typography>

                            <Typography
                              sx={{ fontSize: "12px", fontWeight: 700, color: '#000' }}
                            >
                              {Object.keys(quizAnswers).length}
                            </Typography>
                          </Stack>

                          <Stack
                            direction="row"
                            justifyContent="space-between"
                          >
                            <Typography sx={{ fontSize: "12px", color: "#000" }}>
                              Remaining
                            </Typography>

                            <Typography
                              sx={{ fontSize: "12px", fontWeight: 700, color: '#000' }}
                            >
                              {Math.max(
                                currentQuiz.length - Object.keys(quizAnswers).length,
                                0
                              )}
                            </Typography>
                          </Stack>

                          <Stack
                            direction="row"
                            justifyContent="space-between"
                          >
                            <Typography sx={{ fontSize: "12px", color: "#000" }}>
                              Total Questions
                            </Typography>

                            <Typography
                              sx={{ fontSize: "12px", fontWeight: 700, color: '#000' }}
                            >
                              {currentQuiz.length}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Paper>
                    ) : (<Paper
                      sx={{
                        width: "100%",
                        borderRadius: "14px",
                        border: "1px solid #E5E7EB",
                        backgroundColor: "#FFFFFF",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                        overflow: "hidden",
                        flexShrink: 0,
                        // mb: 1
                      }}
                    >
                      {/* Heading */}
                      <Box
                        sx={{
                          px: {
                            xs: 2,
                            md: 2,
                          },
                          py: 2,
                          // borderBottom: "1px solid #E5E7EB",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "14px",
                              md: "15px",
                            },
                            fontWeight: 700,
                            color: "#111827",
                          }}
                        >
                          Course at a Glance
                        </Typography>
                      </Box>

                      {/* Details */}
                      <Stack
                        spacing={2}
                        sx={{
                          px: {
                            xs: 2,
                            md: 2,
                          },
                          py: 2,
                        }}
                      >

                        {/* Progress */}
                        {isEnrolled && (<Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 1.2,
                          }}
                        >
                          {/* Icon */}
                          <AccessTimeOutlinedIcon
                            sx={{
                              fontSize: 18,
                              color: "#6B7280",
                              flexShrink: 0,
                              mt: 0.1,
                            }}
                          />

                          {/* Label */}
                          <Typography
                            sx={{
                              fontSize: "11px",
                              color: "#374151",
                              whiteSpace: "nowrap",
                              pt: 0.1,
                            }}
                          >
                            Progress
                          </Typography>

                          {/* Percentage + Progress Bar */}
                          <Box
                            sx={{
                              ml: "auto",
                              width: "115px",
                              flexShrink: 0,
                            }}
                          >
                            {/* Percentage */}
                            <Typography
                              sx={{
                                fontSize: "11px",
                                fontWeight: 600,
                                color: "#6B7280",
                                textAlign: "center",
                                whiteSpace: "nowrap",
                                lineHeight: 1.2,
                                mb: 0.6,
                              }}
                            >
                              {/* {Math.round(
                              curriculum.length > 0
                                ? ((activeWeekIndex + 1) / curriculum.length) * 100
                                : 0
                            )} */}
                              {Math.round(overallCompletionPercentage)}
                              % Complete
                            </Typography>

                            {/* Progress Bar */}
                            <Box
                              sx={{
                                width: "100%",
                                height: 4,
                                borderRadius: "10px",
                                backgroundColor: "#E5E7EB",
                                overflow: "hidden",
                              }}
                            >
                              <Box
                                sx={{
                                  /* width: `${curriculum.length > 0
                                    ? ((activeWeekIndex + 1) / curriculum.length) * 100
                                    : 0
                                    }%`, */
                                  width: `${overallCompletionPercentage}%`,
                                  height: "100%",
                                  backgroundColor: "#2563EB",
                                  borderRadius: "10px",
                                }}
                              />
                            </Box>
                          </Box>
                        </Box>)}



                        {/* Modules */}
                        <Box
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "24px minmax(0, 1fr) 110px",
                            alignItems: "center",
                            columnGap: 1,
                          }}
                        >
                          <MenuBookOutlinedIcon
                            sx={{
                              fontSize: 18,
                              color: "#97b0e4",
                              flexShrink: 0,
                            }}
                          />

                          <Typography
                            sx={{
                              fontSize: "11px",
                              color: "#374151",
                              // flex: 1,
                            }}
                          >
                            Modules
                          </Typography>

                          <Typography
                            sx={{
                              fontSize: "11px",
                              fontWeight: 600,
                              color: "#111827",
                              textAlign: 'left'
                            }}
                          >
                            {curriculum.length}
                          </Typography>
                        </Box>

                        {/* Total Duration */}
                        <Box
                          /* sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.2,
                          }} */
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "24px minmax(0, 1fr) 110px",
                            alignItems: "center",
                            columnGap: 1,
                          }}
                        >
                          <AccessTimeOutlinedIcon
                            sx={{
                              fontSize: 18,
                              color: "#6B7280",
                              flexShrink: 0,
                            }}
                          />

                          <Typography
                            sx={{
                              fontSize: "11px",
                              color: "#374151",
                              flex: 1,
                            }}
                          >
                            Total Duration
                          </Typography>

                          <Typography
                            sx={{
                              fontSize: "11px",
                              fontWeight: 600,
                              color: "#111827",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {/* {completeCourseDet?.duration} */}
                            {displayDuration}
                            {/* {completeCourseDet?.duration?.replace(/weeks?/i, "Modules")} */}
                          </Typography>
                        </Box>

                        {/* Level */}
                        <Box
                          /* sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.2,
                          }} */
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "24px minmax(0, 1fr) 110px",
                            alignItems: "center",
                            columnGap: 1,
                          }}
                        >
                          <BarChartOutlinedIcon
                            sx={{
                              fontSize: 18,
                              color: "#6B7280",
                              flexShrink: 0,
                            }}
                          />

                          <Typography
                            sx={{
                              fontSize: "11px",
                              color: "#374151",
                              flex: 1,
                            }}
                          >
                            Level
                          </Typography>

                          <Typography
                            sx={{
                              fontSize: "11px",
                              fontWeight: 600,
                              color: "#111827",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {/* {completeCourseDet?.difficulty} */}
                            {completeCourseDet?.difficulty
                              ? completeCourseDet.difficulty.charAt(0).toUpperCase() +
                              completeCourseDet.difficulty.slice(1)
                              : ""}
                          </Typography>
                        </Box>

                        {/* Instructor */}
                        <Box>
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "24px minmax(0, 1fr) 110px",
                              alignItems: "center",
                              columnGap: 1,
                            }}
                          >
                            <PersonOutlineOutlinedIcon
                              sx={{
                                fontSize: 18,
                                color: "#6B7280",
                                flexShrink: 0,
                              }}
                            />

                            <Typography
                              sx={{
                                fontSize: "11px",
                                color: "#374151",
                                flex: 1,
                              }}
                            >
                              Instructor
                            </Typography>

                            <Typography
                              sx={{
                                fontSize: "11px",
                                fontWeight: 600,
                                color: "#111827",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {completeCourseDet?.user?.name ||
                                completeCourseDet?.user?.first_name ||
                                mentorDetails?.name ||
                                "—"}
                            </Typography>
                          </Box>

                          {/* View Profile */}
                          <Typography
                            sx={{
                              ml: "30px",
                              mt: 0.5,
                              fontSize: "11px",
                              fontWeight: 500,
                              color: "#2563EB",
                              cursor: "pointer",
                              width: "fit-content",

                              "&:hover": {
                                textDecoration: "underline",
                              },
                            }}
                            onClick={() => {
                              window.open(
                                `${window.location.origin}/profile/${completeCourseDet?.user?.profile_id}`,
                                "_blank",
                                "noopener,noreferrer"
                              );
                            }}
                          >
                            View Profile
                          </Typography>
                        </Box>

                      </Stack>
                    </Paper>)}

                    {isLessonQuiz && (<Paper
                      sx={{
                        borderRadius: "12px",
                        border: "1px solid #E5E7EB",
                        boxShadow: "none",
                        backgroundColor: '#fff',
                        p: 2,
                        mb: 2,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: 700,
                          color: "#111827",
                          mb: 2,
                        }}
                      >
                        {/* Quick Navigation */}
                        Review Quiz
                      </Typography>

                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "repeat(4, 1fr)",
                          gap: 1,
                        }}
                      >
                        {currentQuiz.map((_: any, index: number) => {
                          /* const isAnswered = answeredQuestions.has(index);
                          const isActive = currentQuizIndex === index; */
                          const quizAnswer = quizAnswers[index];
                          const isAnswered = Boolean(quizAnswer);
                          const isCorrect = quizAnswer?.is_correct === true;
                          const isWrong = quizAnswer?.is_correct === false;
                          const isActive = currentQuizIndex === index;

                          return (
                            <Box
                              key={index}
                              onClick={() => {
                                /* setCurrentQuizIndex(index);
                                setSelectedAnswer(null); */
                                selectLessonQuizQuestion(index);
                              }}
                              sx={{
                                width: 30,
                                height: 30,
                                borderRadius: "50%",
                                border: isCorrect
                                  ? "1.5px solid #16A34A"
                                  : isWrong
                                    ? "1.5px solid #DC2626"
                                    : isActive
                                      ? "1.5px solid #2563EB"
                                      : "1px solid #D1D5DB",
                                backgroundColor: isCorrect
                                  ? "#F0FDF4"
                                  : isWrong
                                    ? "#FEF2F2"
                                    : isActive
                                      ? "#EFF6FF"
                                      : "#fff",
                                color: isCorrect
                                  ? "#16A34A"
                                  : isWrong
                                    ? "#DC2626"
                                    : isActive
                                      ? "#2563EB"
                                      : "#374151",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "10px",
                                fontWeight: 600,
                                cursor: "pointer",
                              }}
                            >
                              {isCorrect ? (
                                <CheckCircleIcon sx={{ fontSize: 18 }} />
                              ) : isWrong ? (
                                <CloseIcon sx={{ fontSize: 18 }} />
                              ) : (
                                index + 1
                              )}
                            </Box>
                          )
                        })}
                      </Box>
                    </Paper>)}

                    {isLessonQuiz && (
                      <Paper
                        sx={{
                          borderRadius: "12px",
                          border: "1px solid #E5E7EB",
                          boxShadow: "none",
                          backgroundColor: '#fff',
                          p: 2,
                        }}
                      >
                        <Stack
                          direction="row"
                          spacing={1}
                          alignItems="center"
                          sx={{ mb: 1 }}
                        >
                          <InfoOutlinedIcon
                            sx={{
                              fontSize: 17,
                              color: "#2563EB",
                            }}
                          />

                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: 700,
                              color: "#111827",
                            }}
                          >
                            Tip
                          </Typography>
                        </Stack>

                        <Typography
                          sx={{
                            fontSize: "10px",
                            lineHeight: 1.7,
                            color: "#6B7280",
                          }}
                        >
                          Review the lesson content if you're unsure about an answer.
                          You can retake the quiz after completing the module.
                        </Typography>
                      </Paper>
                    )}

                    <Paper
                      sx={{
                        // height: { xs: "auto", md: "calc(140vh - 140px)" },
                        // height: {
                        //   xs: "auto",
                        //   // md: "calc(100vh - 365px)",
                        //   md: !isEnrolled ? "calc(100vh - 328px)" : "calc(100vh - 365px)",
                        // },
                        // maxHeight: {
                        //   // md: "calc(100vh - 365px)",
                        //   md: !isEnrolled ? "calc(100vh - 328px)" : "calc(100vh - 365px)",
                        // },
                        /* height: {
                          xs: 420,
                          md: 600,
                        }, */
                        flex: 1,
                        minHeight: 0,
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: "14px",
                        overflow: "hidden",
                        border: "1px solid #E5E7EB",
                        background: "#fff",
                        mt: isMobile ? 3 : 2
                      }}
                    >
                      <Box
                        sx={{
                          px: 2,
                          py: 2,
                          borderBottom: "1px solid #E5E7EB"
                        }}
                      >

                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Typography fontWeight={600} color={'#000'}>
                            <AutoAwesomeIcon sx={{ color: '#7F00FF' }} /> Digital Twin Assistant
                          </Typography>
                          {/* <IconButton
                          size="small"
                          onClick={() => setIsConversationOpen(false)}
                          sx={{
                            bgcolor: "#F5F5F5",
                            "&:hover": {
                              bgcolor: "#EAEAEA",
                            },
                          }}
                        >
                          <CloseIcon sx={{ fontSize: 18, color: '#000' }} />
                        </IconButton> */}

                        </Stack>

                      </Box>
                      <Box
                        ref={chatContainerRef}
                        /* sx={{
                          height: { xs: "auto", md: "calc(100vh - 140px)" },
                          overflowY: "auto",
                          p: 1.5,
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                        }} */
                        sx={{
                          /* flex: 1,
                          minHeight: 0, */
                          /*  height: { xs: 350, md: 800 },
                           maxHeight: { xs: 350, md: 800 },
                           overflowY: "auto", */
                          height: { xs: 350, md: "auto" },
                          maxHeight: { xs: 350, md: "none" },
                          flex: { md: 1 },
                          minHeight: { md: 0 },
                          overflowY: "auto",
                          overflowX: "hidden",
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        {chatMessages.length === 0 && !isChatBotLoading && (
                          <Box
                            sx={{
                              flex: 1,
                              display: "flex",
                              // flexDirection: "column",
                              // justifyContent: "center",
                              // alignItems: "center",
                              textAlign: "left",
                              // px: 3,
                            }}
                          >
                            {/* <Typography
                            sx={{
                              fontSize: 20,
                              fontWeight: 700,
                              color: "#111827",
                              mb: 1,
                            }}
                          >
                            Welcome!
                          </Typography> */}

                            <Typography
                              sx={{
                                color: "#6B7280",
                                fontSize: 12,
                                // lineHeight: 1.8,
                                textAlign: 'left'
                              }}
                            >
                              {/* Let's explore{" "}
                            <strong>
                              {completeCourseDet?.title?.replace(/"/g, "")}
                            </strong> */}
                              I'm your AI Digital Twin. Ask me anything about this lesson or the course.
                            </Typography>
                          </Box>
                        )}

                        {chatMessages.map((msg, i) => {
                          const isLastUser =
                            msg.role === "user" &&
                            i ===
                            [...chatMessages].map((m) => m.role).lastIndexOf("user");
                          return (
                            <Box
                              key={i}
                              ref={isLastUser ? lastUserMsgRef : null}
                              sx={{
                                position: "relative",
                                alignSelf:
                                  msg.role === "user" ? "flex-end" : "flex-start",
                                background: msg.role === "user" ? "#2563eb" : "#2b2d36",
                                color: "#fff",
                                px: 1.5,
                                py: 1,
                                borderRadius: 2,
                                maxWidth: "80%",
                                fontSize: "13px",
                                lineHeight: 1.6,
                                whiteSpace: msg.role === "bot" ? "normal" : "pre-wrap",
                              }}
                            >
                              {msg.role === "bot" ? (
                                <Box
                                  sx={{
                                    "& h1, & h2, & h3, & h4, & h5, & h6": {
                                      margin: "4px 0",
                                      lineHeight: 1.3,
                                    },
                                    "& p": { margin: "4px 0" },
                                    "& ul": { margin: "4px 0", paddingLeft: "18px" },
                                    "& li": { margin: "2px 0" },
                                    "& *": {
                                      textAlign: "left !important",
                                    },
                                  }}
                                  dangerouslySetInnerHTML={{ __html: msg.text }}
                                />
                              ) : (
                                msg.text
                              )}
                            </Box>
                          );
                        })}
                        {isChatBotLoading && (
                          <Box
                            sx={{
                              alignSelf: "flex-start",
                              background: "#2b2d36",
                              color: "#9CA3AF",
                              px: 1.5,
                              py: 1,
                              borderRadius: 2,
                              fontSize: "13px",
                            }}
                          >
                            {/* Typing... */}
                            Analyzing your question...
                          </Box>
                        )}
                      </Box>

                      {/* ── Ask AI bar ────────────────────────────────────────────────── */}
                      {/* {isEnrolled && ( */}
                      <Box /* sx={{ p: 1 }} */ sx={{
                        p: 2,
                        // borderTop: "1px solid #E5E7EB",
                        background: "#fff",
                        mt: "auto",
                      }}>
                        <Paper
                          sx={{
                            // mt: 3,
                            p: 1,
                            borderRadius: "8px",
                            // background: "#2b2d36",
                            border: "1px solid #D1D5DB",
                            boxShadow: "none",
                            background: '#fff',
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            /* width: {
                              xs: '100%',
                              md: '90%'
                            } */
                          }}
                        >
                          <TextField
                            fullWidth
                            placeholder="Ask AI"
                            variant="standard"
                            InputProps={{
                              disableUnderline: true,
                              sx: { color: "#000", fontSize: "16px", p: 1 },
                              endAdornment: isTranscribing ? (
                                <InputAdornment position="end">
                                  <VoicePulseLoader />
                                </InputAdornment>
                              ) : null,
                            }}
                            onChange={(e: any) => setPrompt(e.target.value)}
                            value={prompt}
                          />
                          {/* <TTSButton text={lastBotText} id={"last-bot-message"} /> */}
                          {/* <IconButton
                        onClick={toggleMute}
                        sx={{
                          background: isMuted
                            ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                            : "linear-gradient(135deg, #4BA5EB 0%, #1E7BC0 100%)",
                          borderRadius: "12px",
                          width: 45,
                          height: 45,
                          boxShadow: isMuted
                            ? "0 4px 15px rgba(102,126,234,0.5)"
                            : "0 4px 15px rgba(75,165,235,0.5)",
                          border: "1px solid rgba(255,255,255,0.2)",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            transform: "scale(1.1)",
                            boxShadow: isMuted
                              ? "0 6px 20px rgba(102,126,234,0.7)"
                              : "0 6px 20px rgba(75,165,235,0.7)",
                          },
                          animation: !isMuted ? "speakerPulse 2s infinite" : "none",
                          "@keyframes speakerPulse": {
                            "0%": {
                              boxShadow: "0 4px 15px rgba(75,165,235,0.5)",
                            },
                            "50%": {
                              boxShadow: "0 4px 25px rgba(75,165,235,0.9)",
                            },
                            "100%": {
                              boxShadow: "0 4px 15px rgba(75,165,235,0.5)",
                            },
                          },
                        }}
                      >
                        {isMuted ? (
                          <VolumeOffIcon sx={{ color: "#fff", fontSize: "22px" }} />
                        ) : (
                          <VolumeUpIcon sx={{ color: "#fff", fontSize: "22px" }} />
                        )}
                      </IconButton> */}
                          {/* <IconButton>
                {isRecording ? (
                  <StopIcon
                    sx={{ color: "#fff" }}
                    onClick={() => stopRecording()}
                  />
                ) : (
                  <MicNoneOutlinedIcon
                    sx={{ color: "#fff" }}
                    onClick={() => startRecording()}
                  />
                )}
              </IconButton> */}
                          <IconButton
                            onClick={() =>
                              isRecording ? stopRecording() : startRecording()
                            }
                            className={isRecording ? "recording-mic-btn" : "mic-btn"}
                            sx={{
                              width: 60,
                              height: 60,
                              background: isRecording
                                ? "linear-gradient(135deg, #ff4d4d, #ff0000)"
                                : "linear-gradient(135deg, #4BA5EB, #2563EB)",
                              "&:hover": {
                                background: isRecording
                                  ? "linear-gradient(135deg, #ff4d4d, #ff0000)"
                                  : "linear-gradient(135deg, #4BA5EB, #2563EB)",
                              },
                            }}
                          >
                            <MicNoneOutlinedIcon
                              sx={{
                                color: "#fff",
                                fontSize: "22px",
                              }}
                            />
                          </IconButton>
                          <IconButton>
                            <SendIcon
                              sx={{ color: "#60A5FA" }}
                              /* onClick={() => {
                                stopAllAudio();
              
                                getChatBotResponse(courseId, prompt, "");
              
                                setOpenChatBot(true);
                              }} */
                              /* onClick={() => {
                                // chatbot request started
                                isChatbotRequestRef.current = true;
                                setCaptionText("");
                                // stop curriculum wav
                                if (curriculumAudioRef.current) {
                                  curriculumAudioRef.current.pause();
                                  curriculumAudioRef.current.currentTime = 0;
                                  curriculumAudioRef.current.src = "";
                                }

                                // stop tts queue
                                stopAll();

                                getChatBotResponse(courseId, prompt, currentWeek?.title);

                                setOpenChatBot(true);
                              }} */
                              onClick={() => {
                                // Save module position before interrupting it
                                // saveModulePlaybackState();
                                if (!prompt?.trim()) {
                                  return;
                                }

                                savePlaybackStateBeforeChat();

                                // chatbot request started
                                isChatbotRequestRef.current = true;

                                setCaptionText("");

                                // Pause curriculum audio ONLY.
                                // Do NOT reset currentTime.
                                // Do NOT clear src.
                                if (curriculumAudioRef.current) {
                                  curriculumAudioRef.current.pause();
                                }

                                // Stop TTS queue
                                stopAll();

                                getChatBotResponse(
                                  courseId,
                                  prompt,
                                  currentWeek?.title
                                );

                                setOpenChatBot(true);
                              }}
                            />
                          </IconButton>
                        </Paper>
                      </Box>
                      {/* )} */}
                    </Paper>
                  </Box>
                </Grid>)}

                {/* RIGHT SIDE OPEN/CLOSE TAB */}
                {!isMobile && (
                  <Tooltip
                    title={
                      isConversationOpen
                        ? "Close Course at a Glance"
                        : "Open Course at a Glance"
                    }
                    placement="left"
                    arrow
                  >
                    <Box
                      onClick={() =>
                        setIsConversationOpen((prev) => !prev)
                      }
                      sx={{
                        position: "absolute",
                        right: 0,
                        top: 2,
                        zIndex: 30,

                        width: 40,
                        height: 40,

                        borderRadius: "10px 0 0 10px",
                        backgroundColor: "#EFF6FF",
                        border: "1px solid #93C5FD",
                        borderRight: "none",

                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",

                        cursor: "pointer",

                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",

                        transition: "all 0.2s ease",

                        "&:hover": {
                          backgroundColor: "#DBEAFE",
                          width: 44,
                        },
                      }}
                    >
                      {isConversationOpen ? (
                        <ArrowForwardIosIcon
                          sx={{
                            fontSize: 18,
                            color: "#2563EB",
                          }}
                        />
                      ) : (
                        <ArrowBackIosNewIcon
                          sx={{
                            fontSize: 18,
                            color: "#2563EB",
                          }}
                        />
                      )}
                    </Box>
                  </Tooltip>
                )}

                <Dialog
                  open={moduleCompletePopup}
                  onClose={handleContinueToNextModule}
                  maxWidth="xs"
                  fullWidth
                  PaperProps={{
                    sx: {
                      borderRadius: "24px",
                      overflow: "hidden",
                      textAlign: "center",
                      boxShadow: "0 20px 50px rgba(0,0,0,0.15)",
                      backgroundColor: "#fff",
                    },
                  }}
                >
                  <DialogContent sx={{ py: 5, px: 4 }}>
                    {(() => {
                      const totalQuestions = currentQuiz.length;
                      const wrongCount = Math.max(totalQuestions - correctCount, 0);
                      const scorePercent =
                        totalQuestions > 0
                          ? Math.round((correctCount / totalQuestions) * 100)
                          : 0;
                      const encouragement =
                        scorePercent >= 80
                          ? "Excellent work! You're mastering this material."
                          : scorePercent >= 50
                            ? "Great job! Keep up the good work and continue learning."
                            : "Nice effort! A quick review will help it stick.";

                      const isLastModule =
                        (completedModuleInfo?.index ?? 0) === curriculum.length - 1;

                      // NEW — show the certificate section once the whole course is finished
                      const showCertificateInfo = isEnrolled && (isLastModule || isCourseCompleted);

                      return (
                        <>
                          {/* Success icon with soft glow */}
                          <Box
                            sx={{
                              position: "relative",
                              width: 96,
                              height: 96,
                              mx: "auto",
                              mb: 3,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Box
                              sx={{
                                position: "absolute",
                                inset: 0,
                                borderRadius: "50%",
                                background:
                                  "radial-gradient(circle, rgba(16,185,129,0.12) 0%, rgba(16,185,129,0) 70%)",
                              }}
                            />
                            <Box
                              sx={{
                                width: 68,
                                height: 68,
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "#10B981",
                                border: "5px solid #D1FAE5",
                              }}
                            >
                              <CheckCircleIcon sx={{ fontSize: 34, color: "#fff" }} />
                            </Box>
                          </Box>

                          <Typography
                            sx={{
                              fontSize: 26,
                              fontWeight: 800,
                              color: "#111827",
                              mb: 1,
                              textAlign: 'center'
                            }}
                          >
                            {isLastModule
                              ? "🎉 Course Complete!"
                              : `Module ${(completedModuleInfo?.index ?? 0) + 1} Complete!`}
                          </Typography>

                          <Typography sx={{ fontSize: 14.5, color: "#6B7280", mb: 3, textAlign: 'center' }}>
                            {isLastModule
                              ? `Congratulations! You've completed the entire course — "${completeCourseDet?.title || completedModuleInfo?.title}".`
                              : `Congratulations! You've successfully completed "${completedModuleInfo?.title}".`}
                          </Typography>

                          {/* Stats grid */}
                          <Box
                            sx={{
                              border: "1px solid #E5E7EB",
                              borderRadius: "16px",
                              p: 2.5,
                              mb: 2.5,
                              display: "grid",
                              gridTemplateColumns: "repeat(4, 1fr)",
                              gap: 1,
                              textAlign: 'center'
                            }}
                          >
                            {[
                              {
                                icon: <CheckCircleIcon sx={{ fontSize: 20, color: "#16A34A" }} />,
                                bg: "#DCFCE7",
                                value: correctCount,
                                label: "Correct Answers",
                                color: "#16A34A",
                              },
                              {
                                icon: <CloseIcon sx={{ fontSize: 20, color: "#DC2626" }} />,
                                bg: "#FEE2E2",
                                value: wrongCount,
                                label: "Wrong Answers",
                                color: "#DC2626",
                              },
                              {
                                icon: (
                                  <AssignmentOutlinedIcon
                                    sx={{ fontSize: 20, color: "#2563EB" }}
                                  />
                                ),
                                bg: "#DBEAFE",
                                value: totalQuestions,
                                label: "Total Questions",
                                color: "#2563EB",
                              },
                              {
                                icon: <TrendingUpIcon sx={{ fontSize: 20, color: "#7C3AED" }} />,
                                bg: "#EDE9FE",
                                value: `${scorePercent}%`,
                                label: "Your Score",
                                color: "#7C3AED",
                              },
                            ].map((stat, i) => (
                              <Box
                                key={i}
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                }}
                              >
                                <Box
                                  sx={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: stat.bg,
                                    mb: 1,
                                    textAlign: "center",
                                  }}
                                >
                                  {stat.icon}
                                </Box>
                                <Typography
                                  sx={{
                                    fontSize: 20,
                                    fontWeight: 800,
                                    color: stat.color,
                                    lineHeight: 1.2,
                                    textAlign: "center",
                                  }}
                                >
                                  {stat.value}
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: 11,
                                    color: "#6B7280",
                                    lineHeight: 1.3,
                                    mt: 0.25,
                                    textAlign: "center",
                                  }}
                                >
                                  {stat.label}
                                </Typography>
                              </Box>
                            ))}
                          </Box>

                          {/* Encouragement banner */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1.25,
                              background: "#F0FDF4",
                              border: "1px solid #DCFCE7",
                              borderRadius: "12px",
                              p: 1.5,
                              mb: 3,
                              textAlign: "left",
                            }}
                          >
                            <Box
                              sx={{
                                width: 32,
                                height: 32,
                                minWidth: 32,
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "#DCFCE7",
                              }}
                            >
                              <EmojiEventsOutlinedIcon sx={{ fontSize: 18, color: "#16A34A" }} />
                            </Box>
                            <Typography sx={{ fontSize: 13, color: "#166534", fontWeight: 600 }}>
                              {encouragement}
                            </Typography>
                          </Box>

                          {/* NEW — Certificate instructions, only after the final module */}
                          {showCertificateInfo && (
                            <Box
                              sx={{
                                border: "1px solid #FDE68A",
                                background: "linear-gradient(135deg, #FFFBEB 0%, #FEF3C7 100%)",
                                borderRadius: "14px",
                                p: 2,
                                mb: 3,
                                textAlign: "left",
                              }}
                            >
                              <Stack direction="row" spacing={1.25} alignItems="center" mb={1}>
                                <Box
                                  sx={{
                                    width: 34,
                                    height: 34,
                                    minWidth: 34,
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: "#FDE68A",
                                  }}
                                >
                                  <WorkspacePremiumOutlinedIcon sx={{ fontSize: 20, color: "#B45309" }} />
                                </Box>
                                <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#92400E" }}>
                                  Your certificate is ready!
                                </Typography>
                              </Stack>

                              <Typography sx={{ fontSize: 12.5, color: "#78350F", lineHeight: 1.7, mb: 1 }}>
                                You've earned a Certificate of Completion for this course. To get it:
                              </Typography>

                              <Box
                                component="ol"
                                sx={{
                                  m: 0,
                                  mb: 1.75,
                                  pl: 2.5,
                                  fontSize: 12.5,
                                  color: "#78350F",
                                  lineHeight: 1.8,
                                }}
                              >
                                <li>Click <strong>Download Certificate</strong> below to save it as a PDF.</li>
                                <li>You can also download it anytime later from the <strong>"Course completed"</strong> card at the top of the right panel on this page.</li>
                                <li>Share it on LinkedIn or add it to your résumé to showcase your new skills.</li>
                              </Box>

                              <Button
                                fullWidth
                                variant="contained"
                                disabled={downloadingCertificate}
                                onClick={handleDownloadCertificate}
                                startIcon={
                                  downloadingCertificate ? undefined : (
                                    <WorkspacePremiumOutlinedIcon sx={{ fontSize: 18 }} />
                                  )
                                }
                                sx={{
                                  py: 1.1,
                                  borderRadius: "10px",
                                  textTransform: "none",
                                  fontWeight: 700,
                                  fontSize: 14,
                                  color: "#fff",
                                  background: "linear-gradient(90deg,#D97706,#F59E0B)",
                                  boxShadow: "0 6px 16px rgba(217,119,6,0.3)",
                                  "&:hover": {
                                    background: "linear-gradient(90deg,#B45309,#D97706)",
                                  },
                                  "&.Mui-disabled": { color: "#fff", opacity: 0.7 },
                                }}
                              >
                                {downloadingCertificate ? (
                                  <CircularProgress size={18} sx={{ color: "#fff" }} />
                                ) : (
                                  "Download Certificate"
                                )}
                              </Button>
                            </Box>
                          )}

                          {/* Footer buttons */}
                          <Stack direction="row" spacing={1.5}>
                            {/* <Button
                              fullWidth
                              variant="outlined"
                              startIcon={<ReplayIcon sx={{ fontSize: 18 }} />}
                              onClick={() => setModuleCompletePopup(false)}
                              sx={{
                                py: 1.3,
                                borderRadius: "12px",
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: 14,
                                color: "#374151",
                                borderColor: "#D1D5DB",
                                "&:hover": {
                                  borderColor: "#9CA3AF",
                                  background: "#F9FAFB",
                                },
                              }}
                            >
                              Review Answers
                            </Button> */}

                            <Button
                              fullWidth
                              variant="contained"
                              endIcon={<ChevronRightIcon sx={{ fontSize: 18 }} />}
                              onClick={handleContinueToNextModule}
                              sx={{
                                py: 1.3,
                                borderRadius: "12px",
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: 14,
                                background: "linear-gradient(90deg,#2563eb,#1d9bf0)",
                                "&:hover": {
                                  background: "linear-gradient(90deg,#1d4ed8,#0284c7)",
                                },
                                color: '#fff'
                              }}
                            >
                              Close
                            </Button>
                          </Stack>
                        </>
                      );
                    })()}
                  </DialogContent>
                </Dialog>


                <Dialog
                  open={reviewPopupOpen}
                  onClose={() => setReviewPopupOpen(false)}
                  maxWidth="sm"
                  fullWidth
                  PaperProps={{ sx: { borderRadius: "16px", overflow: "hidden" } }}
                >
                  <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography fontWeight={700}>Rate your experience</Typography>
                    <IconButton onClick={() => setReviewPopupOpen(false)} size="small">
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </DialogTitle>

                  <DialogContent dividers>
                    <Stack direction="row" spacing={0.5} mb={2} sx={{ background: "#F3F4F6", p: 0.5, borderRadius: "10px" }}>
                      {(["student", "mentor"] as const).map((tab) => (
                        <Button
                          key={tab}
                          onClick={() => setReviewTab(tab)}
                          sx={{
                            flex: 1,
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: 12,
                            borderRadius: "8px",
                            color: reviewTab === tab ? "#fff" : "#374151",
                            background: reviewTab === tab ? "linear-gradient(90deg,#2563eb,#1d9bf0)" : "transparent",
                          }}
                        >
                          {tab === "student" ? "Course" : "Mentor"}
                        </Button>
                      ))}
                    </Stack>

                    {reviewTab === "student" ? (
                      <CourseReviewForm
                        courseId={courseId}
                        apiUrl={apiUrl}
                        studentId={studentId}
                        onReviewSubmitted={(newReview) => {
                          setCourseReviews((prev) => [newReview, ...prev]);
                          setReviewPopupOpen(false);
                        }}
                      />
                    ) : (
                      <MentorReviewForm
                        mentorId={mentorId}
                        mentorName={mentorName}
                        apiUrl={apiUrl}
                        studentId={studentId}
                        onReviewSubmitted={(newReview) => {
                          setMentorReviews((prev) => [newReview, ...prev]);
                          setReviewPopupOpen(false);
                        }}
                      />
                    )}
                  </DialogContent>
                </Dialog>

                {/* {isEnrolled && (
                  <Box mt={5}>
                    {/ Section header + tab switcher /}
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      mb={3}
                    >
                      <Stack direction="row" alignItems="center" spacing={1.5}>
                        <Box
                          sx={{
                            width: 4,
                            height: 28,
                            borderRadius: 2,
                            background: "linear-gradient(180deg, #2563eb, #1d9bf0)",
                          }}
                        />
                        <Typography color="#fff" fontSize="22px" fontWeight={700}>
                          Reviews
                        </Typography>
                      </Stack>

                      <Stack
                        direction="row"
                        spacing={0.5}
                        sx={{
                          background: "#0e1018",
                          p: 0.5,
                          borderRadius: "10px",
                          border: "1px solid #1e2030",
                        }}
                      >
                        {(["student", "mentor"] as const).map((tab) => (
                          <Button
                            key={tab}
                            onClick={() => setReviewTab(tab)}
                            sx={{
                              textTransform: "none",
                              fontSize: "12px",
                              fontWeight: 600,
                              px: 2,
                              py: 0.6,
                              borderRadius: "8px",
                              minWidth: 90,
                              color: reviewTab === tab ? "#fff" : "#6B7280",
                              background:
                                reviewTab === tab
                                  ? "linear-gradient(90deg,#2563eb,#1d9bf0)"
                                  : "transparent",
                              transition: "all 0.2s",
                              "&:hover": {
                                background:
                                  reviewTab === tab
                                    ? "linear-gradient(90deg,#2563eb,#1d9bf0)"
                                    : "#1e2030",
                              },
                            }}
                          >
                            {tab === "student" ? (
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={0.6}
                              >
                                <SchoolIcon sx={{ fontSize: 14 }} />
                                <span>Course</span>
                              </Stack>
                            ) : (
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={0.6}
                              >
                                <VerifiedIcon sx={{ fontSize: 14 }} />
                                <span>Mentors</span>
                              </Stack>
                            )}
                          </Button>
                        ))}
                      </Stack>
                    </Stack>

                    {/ ── Student / Course Reviews Tab ──────────────────────────── /}
                    {reviewTab === "student" && (
                      <Box>
                        {/ ── Course Review Form ── /}
                        <Divider sx={{ borderColor: "#1e2030", mb: 3 }} />
                        <Typography color="#9CA3AF" fontSize="13px" mb={2}>
                          You're enrolled — we'd love to hear your thoughts! 💬
                        </Typography>
                        <CourseReviewForm
                          courseId={courseId}
                          apiUrl={apiUrl}
                          studentId={studentId}
                          onReviewSubmitted={(newReview) =>
                            setCourseReviews((prev) => [newReview, ...prev])
                          }
                        />
                      </Box>
                    )}

                    {/ ── Mentor Reviews Tab ────────────────────────────────────── /}
                    {reviewTab === "mentor" && (
                      <Box>
                        <Divider sx={{ borderColor: "#1e3a5f", mb: 1 }} />
                        <MentorReviewForm
                          mentorId={mentorId}
                          mentorName={mentorName}
                          apiUrl={apiUrl}
                          studentId={studentId}
                          onReviewSubmitted={(newReview) =>
                            setMentorReviews((prev) => [newReview, ...prev])
                          }
                        />
                      </Box>
                    )}
                  </Box>
                )} */}
              </Grid>
            </Grid>

          </Grid>
        </Box >

        {/* ── Modals ────────────────────────────────────────────────────────────── */}
        < Modal open={loginPopup} onClose={() => setLoginPopup(false)
        }>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 320,
              bgcolor: "#1F1F27",
              borderRadius: "12px",
              boxShadow: 24,
              p: 3,
              textAlign: "center",
            }}
          >
            <Typography
              sx={{ color: "#fff", fontSize: "18px", fontWeight: "bold", mb: 1 }}
            >
              Authentication Required
            </Typography>
            <Typography sx={{ color: "#9CA3AF", fontSize: "14px", mb: 3 }}>
              Please Register to view the course details.
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="center">
              <Button
                variant="outlined"
                onClick={() => setLoginPopup(false)}
                sx={{ color: "#fff", borderColor: "#555" }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() =>
                  navigate("/signup", { state: { role: "student" } })
                }
                sx={{ background: "linear-gradient(90deg,#2563eb,#1d9bf0)" }}
              >
                Sign Up
              </Button>
            </Stack>
          </Box>
        </Modal >

        <Modal open={enrollPopup} onClose={() => setEnrollPopup(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 320,
              bgcolor: "#1F1F27",
              borderRadius: "12px",
              boxShadow: 24,
              p: 3,
              textAlign: "center",
            }}
          >
            <Typography
              sx={{ color: "#fff", fontSize: "18px", fontWeight: "bold", mb: 1 }}
            >
              Enrollment Required
            </Typography>
            <Typography sx={{ color: "#9CA3AF", fontSize: "14px", mb: 3 }}>
              Please enroll in this course to access full content.
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="center">
              <Button
                variant="outlined"
                onClick={() => setEnrollPopup(false)}
                sx={{ color: "#fff", borderColor: "#555" }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => handleBuyNow()}
                sx={{ background: "linear-gradient(90deg,#2563eb,#1d9bf0)" }}
              >
                Enroll Now
              </Button>
            </Stack>
          </Box>
        </Modal>

        <Dialog
          open={openCoursePopup}
          onClose={() => setOpenCoursePopup(false)}
          TransitionComponent={Zoom}
          transitionDuration={400}
          maxWidth="sm"
          fullWidth
          BackdropProps={{
            sx: {
              backdropFilter: "blur(8px)",
              backgroundColor: "rgba(0,0,0,0.65)",
            },
          }}
          PaperProps={{
            sx: {
              position: "relative",
              borderRadius: "28px",
              overflow: "hidden",
              /* background:
                "linear-gradient(135deg, #181A30 0%, #2A245A 100%)",
              color: "#fff",
              border: "1px solid rgba(139,92,246,0.35)",
              boxShadow:
                "0 25px 80px rgba(0,0,0,.65), 0 0 40px rgba(139,92,246,.25)", */
              background: "#FFFFFF",
              color: "#111827",
              border: "1px solid #E5E7EB",
              boxShadow: "0 20px 50px rgba(0,0,0,0.12)",
            },
          }}
        >
          {/* Top Accent Line */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: 4,
              background:
                "linear-gradient(90deg,#6366F1,#8B5CF6,#A855F7)",
            }}
          />

          <DialogContent sx={{ p: { xs: 3, md: 5 } }}>
            <Stack spacing={3} alignItems="center">
              {/* Icon */}
              <Box
                sx={{
                  width: 90,
                  height: 90,
                  borderRadius: "24px",
                  /* background:
                    "linear-gradient(135deg,#6366F1,#8B5CF6)", */
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  /* boxShadow:
                    "0 0 30px rgba(139,92,246,.5)", */
                  background:
                    "linear-gradient(135deg,#2563EB,#3B82F6)",

                  boxShadow:
                    "0 10px 25px rgba(37,99,235,.25)",
                }}
              >
                <RocketLaunchIcon
                  sx={{
                    fontSize: 45,
                    color: "#fff",
                  }}
                />
              </Box>

              {/* Heading */}
              <Typography
                variant="h3"
                fontWeight={700}
                textAlign="center"
                sx={{
                  fontSize: {
                    xs: "2rem",
                    md: "2.6rem",
                  },
                  color: "#111827",
                }}
              >
                Ready to Start Learning?
              </Typography>

              {/* Description */}
              <Typography
                textAlign="center"
                sx={{
                  // color: "rgba(255,255,255,0.75)",
                  lineHeight: 1.8,
                  fontSize: "1rem",
                  maxWidth: 500,
                  color: "#6B7280"
                }}
              >
                Welcome to the course. Complete lessons at your own pace,
                track your progress, and unlock valuable insights as you
                move through each module.
              </Typography>

              {/* Stats */}
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-around",
                  p: 2,
                  borderRadius: "16px",
                  /* background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.08)", */
                  background: "#F9FAFB",
                  border: "1px solid #E5E7EB",
                }}
              >
                {/* <Box textAlign="center">
                <Typography fontWeight={700}>12</Typography>
                <Typography variant="caption" color="rgba(255,255,255,.7)">
                  Lessons
                </Typography>
              </Box> */}

                <Box textAlign="center">
                  <Typography fontWeight={700}>{/* {completeCourseDet?.duration} */}
                    {/* {completeCourseDet?.duration?.replace(/weeks?/i, "Modules")} */}
                    {displayDuration}
                  </Typography>
                  <Typography variant="caption" color="#6B7280"/* color="rgba(255,255,255,.7)" */>
                    Duration
                  </Typography>
                </Box>

                <Box textAlign="center">
                  <Typography fontWeight={700}>
                    {completeCourseDet?.difficulty
                      ? completeCourseDet.difficulty.charAt(0).toUpperCase() +
                      completeCourseDet.difficulty.slice(1)
                      : ""}
                  </Typography>
                  <Typography variant="caption" color="#6B7280"/* color="rgba(255,255,255,.7)" */>
                    Level
                  </Typography>
                </Box>
              </Box>

              {/* Buttons */}
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                width="100%"
              >
                <Button
                  fullWidth
                  variant="outlined"
                  // onClick={() => setOpenCoursePopup(false)}
                  onClick={() => window.history.back()}
                  sx={{
                    py: 1.7,
                    borderRadius: "14px",
                    textTransform: "none",
                    fontSize: "1rem",
                    /* color: "#fff",
                    borderColor: "rgba(255,255,255,.15)",
                    "&:hover": {
                      borderColor: "rgba(255,255,255,.3)",
                    }, */
                    color: "#374151",

                    borderColor: "#D1D5DB",

                    background: "#fff",

                    "&:hover": {
                      background: "#F9FAFB",
                      borderColor: "#9CA3AF",
                    },
                  }}
                >
                  Maybe Later
                </Button>

                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => {
                    setHasStartedCourse(true);

                    setOpenCoursePopup(false);

                    if (introVideoUrl) {
                      // Show the Introduction Video first; Course Definition
                      // will be triggered once the video popup is closed
                      // (see handleCloseIntroVideo).
                      setPendingStartAfterVideo(true);
                      setIntroVideoOpen(true);
                      return;
                    }

                    setShowCourseDefinition(true);

                    document
                      .getElementById("course-content")
                      ?.scrollIntoView({
                        behavior: "smooth",
                      });
                  }}
                  sx={{
                    py: 1.7,
                    borderRadius: "14px",
                    textTransform: "none",
                    fontSize: "1rem",
                    fontWeight: 600,
                    /* background:
                      "linear-gradient(135deg,#6366F1,#8B5CF6)",
                    boxShadow:
                      "0 10px 30px rgba(99,102,241,.4)",
                    "&:hover": {
                      background:
                        "linear-gradient(135deg,#5855eb,#7c3aed)",
                    }, */
                    background:
                      "linear-gradient(135deg,#2563EB,#3B82F6)",

                    boxShadow:
                      "0 10px 25px rgba(37,99,235,.30)",

                    "&:hover": {
                      background:
                        "linear-gradient(135deg,#1D4ED8,#2563EB)",
                    },
                  }}
                >
                  Start Course
                </Button>
              </Stack>
            </Stack>
          </DialogContent>
        </Dialog>

        {/* quiz dialog */}
        <Dialog
          open={quizOpen}
          // onClose={() => setQuizOpen(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "14px",
              overflow: "hidden",
              boxShadow: "0 20px 50px rgba(0,0,0,0.15)",
            },
          }}
        >
          <DialogTitle
            sx={{
              p: 0,
              bgcolor: "#fff",
              borderBottom: "1px solid #F1F5F9",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                px: 3,
                pt: 2,
                pb: 1,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: 13,
                  letterSpacing: 1,
                  color: "#111827",
                }}
              >
                PROGRESS
              </Typography>

              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: 13,
                  color: "#111827",
                }}
              >
                STEP {currentQuizIndex + 1} OF {currentQuiz.length}
              </Typography>
            </Box>

            <LinearProgress
              variant="determinate"
              value={((currentQuizIndex + 1) / currentQuiz.length) * 100}
              sx={{
                height: 8,
                bgcolor: "#DBEAFE",
                "& .MuiLinearProgress-bar": {
                  bgcolor: "#3B82F6",
                },
              }}
            />
          </DialogTitle>

          <DialogContent sx={{
            px: 5,
            py: 5,
            background: "#fff",
          }}>

            {showResult ? (

              < Box
                sx={{
                  py: 2,
                  px: 3,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  backgroundColor: '#fff'
                }}
              >
                {/* Illustration */}
                <Box
                  component="img"
                  src={quizSuccessImg}
                  alt="Quiz Completed"
                  sx={{
                    width: 140,
                    maxHeight: 140,
                    objectFit: "contain",
                    mb: 2,
                  }}
                />

                {/* Heading */}
                <Typography
                  sx={{
                    fontSize: 34,
                    fontWeight: 700,
                    color: "#1F2937",
                    mb: 1,
                  }}
                >
                  Congratulations!
                </Typography>

                {/* Subtitle */}
                <Typography
                  sx={{
                    fontSize: 17,
                    color: "#6B7280",
                    mb: 4,
                  }}
                >
                  You have successfully completed this quiz.
                </Typography>

                {/* Score Card */}
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: 340,
                    border: "1px solid #E5E7EB",
                    borderRadius: "16px",
                    p: 3,
                    background: "#F9FAFB",
                    mb: 4,
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                    <Typography
                      sx={{
                        fontSize: 14,
                        color: "#6B7280",
                        mb: 2,
                      }}
                    >
                      Your Score
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 36,
                        fontWeight: 700,
                        color: "#2563EB",
                        lineHeight: 1,
                      }}
                    >
                      {correctCount}/{currentQuiz.length}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      mt: 3,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontSize: 14,
                          color: "#10B981",
                          fontWeight: 600,
                        }}
                      >
                        Correct
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: 24,
                          fontWeight: 700,
                          color: "#111827",
                        }}
                      >
                        {correctCount}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography
                        sx={{
                          fontSize: 14,
                          color: "#EF4444",
                          fontWeight: 600,
                        }}
                      >
                        Wrong
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: 24,
                          fontWeight: 700,
                          color: "#111827",
                        }}
                      >
                        {currentQuiz.length - correctCount}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Button */}
                <Button
                  variant="contained"
                  onClick={() => setQuizOpen(false)}
                  sx={{
                    px: 6,
                    py: 1.5,
                    borderRadius: "999px",
                    textTransform: "none",
                    fontSize: 16,
                    fontWeight: 600,
                    background: "linear-gradient(90deg, #14B8A6, #0EA5E9)",
                    boxShadow: "0 10px 25px rgba(20,184,166,0.25)",
                    "&:hover": {
                      background: "linear-gradient(90deg, #0D9488, #0284C7)",
                    },
                  }}
                >
                  Back to Course
                </Button>
              </Box>

            ) : (

              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 3,
                    mt: 1
                  }}
                >
                  <Typography fontWeight={600}>
                    Question {currentQuizIndex + 1} / {currentQuiz.length}
                  </Typography>

                  <IconButton
                    onClick={() => setQuizOpen(false)}
                    sx={{
                      bgcolor: "#F3F4F6",
                      "&:hover": {
                        bgcolor: "#E5E7EB",
                      },
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>

                <Typography sx={{
                  mt: 2,
                  fontSize: 34,
                  fontWeight: 700,
                  color: "#111827",
                  textAlign: "center",
                  lineHeight: 1.3,
                }}>
                  {currentQuestion?.question}
                </Typography>

                <Typography
                  sx={{
                    mt: 1,
                    mb: 4,
                    color: "#6B7280",
                    fontSize: 16,
                    textAlign: "center",
                  }}
                >
                  Select the correct answer below.
                </Typography>

                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr",
                    gap: 2,
                    mt: 3,
                  }}
                >

                  {
                    currentQuestion?.options.map((option: any, index: number) => (

                      <Button

                        fullWidth

                        variant="outlined"
                        sx={{
                          justifyContent: "flex-start",
                          minHeight: 82,
                          px: 3,
                          borderRadius: "12px",
                          textTransform: "none",
                          fontSize: 17,
                          fontWeight: 600,
                          color: "#111827",
                          border: "2px solid #E5E7EB",
                          background:
                            selectedAnswer === option
                              ? option === currentQuestion.correct_answer
                                ? "#ECFDF5"
                                : "#FEF2F2"
                              : "#fff",

                          "&:hover": {
                            borderColor: "#2563EB",
                            background: "#F8FAFC",
                          },

                          ...(selectedAnswer === option &&
                            option === currentQuestion.correct_answer && {
                            borderColor: "#22C55E",
                          }),

                          ...(selectedAnswer === option &&
                            option !== currentQuestion.correct_answer && {
                            borderColor: "#EF4444",
                          }),
                        }}
                        onClick={() => {

                          setSelectedAnswer(option);

                          if (option === currentQuestion.correct_answer) {

                            setCorrectCount(prev => prev + 1);

                          }

                        }}

                      >

                        {/* {option} */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            width: "100%",
                          }}
                        >
                          <Box
                            sx={{
                              width: 22,
                              height: 22,
                              minWidth: 22,
                              minHeight: 22,
                              borderRadius: "50%",
                              border: "2px solid #D1D5DB",
                              mr: 2,
                              flexShrink: 0,
                              alignSelf: "center",
                              mt: "2px",
                              bgcolor:
                                selectedAnswer === option
                                  ? option === currentQuestion.correct_answer
                                    ? "#22C55E"
                                    : "#EF4444"
                                  : "#fff",
                            }}
                          />

                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: 17,
                              textAlign: "left",
                              wordBreak: "break-word",
                              flex: 1,
                            }}
                          >
                            {option}
                          </Typography>
                        </Box>

                      </Button>

                    ))

                  }

                </Box>

                {/* {
                selectedAnswer && (

                  <Alert
                    severity={
                      selectedAnswer === currentQuestion.correct_answer
                        ? "success"
                        : "error"
                    }
                    sx={{
                      mt: 4,
                      borderRadius: "12px",
                    }}
                  >

                    {currentQuestion.explanation}

                  </Alert>

                )
              } */}

                <Box
                  sx={{
                    mt: 5,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >

                  <Button

                    disabled={!selectedAnswer}

                    onClick={() => {

                      if (currentQuizIndex < currentQuiz.length - 1) {

                        setCurrentQuizIndex(prev => prev + 1);

                        setSelectedAnswer(null);

                      }
                      else {

                        setShowResult(true);

                      }

                    }}
                    variant="contained"
                    sx={{
                      px: 5,
                      py: 1.3,
                      borderRadius: "10px",
                      textTransform: "none",
                      fontWeight: 700,
                      fontSize: 16,
                      background: "#3B82F6",
                      color: '#fff',

                      "&:hover": {
                        background: "#3B82F6",
                      },

                      "&:disabled": {
                        background: "#D1D5DB",
                      },
                    }}
                  >

                    {currentQuizIndex === currentQuiz.length - 1
                      ? "Finish"
                      : "Next"}

                  </Button>

                </Box>

              </>

            )}

          </DialogContent>
        </Dialog>

        {/* Introduction Video popup */}
        <Dialog
          open={introVideoOpen}
          // onClose={handleCloseIntroVideo}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "14px",
              overflow: "hidden",
              boxShadow: "0 20px 50px rgba(0,0,0,0.15)",
              background: "#000",
            },
          }}
        >
          <Box sx={{ position: "relative" }}>
            <IconButton
              onClick={handleCloseIntroVideo}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                zIndex: 2,
                color: "#fff",
                background: "rgba(0,0,0,0.55)",
                "&:hover": {
                  background: "rgba(0,0,0,0.75)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>

            <DialogContent sx={{ p: 0 }}>
              {introVideoUrl ? (
                <Box
                  component="video"
                  key={introVideoUrl}
                  src={`${process.env.REACT_APP_SERVER_ENDPOINT}${introVideoUrl}`}
                  controls
                  autoPlay
                  onEnded={handleCloseIntroVideo}
                  sx={{
                    width: "100%",
                    maxHeight: "75vh",
                    display: "block",
                    background: "#000",
                  }}
                />
              ) : (
                <Box
                  sx={{
                    p: 6,
                    textAlign: "center",
                  }}
                >
                  <Typography sx={{ color: "#fff", fontSize: 14 }}>
                    No introduction video is available for this course.
                  </Typography>
                </Box>
              )}
            </DialogContent>
          </Box>
        </Dialog>

        {/* Resume-after-AI confirmation dialog */}
        <Dialog
          open={showResumeConfirm}
          onClose={handleDeclineResumeAfterChat}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "14px",
              overflow: "hidden",
              boxShadow: "0 20px 50px rgba(0,0,0,0.15)",
              background: '#fff'
            },
          }}
        >
          <DialogTitle sx={{ fontWeight: 700, fontSize: 18, color: "#111827" }}>
            Resume playback?
          </DialogTitle>

          <DialogContent>
            <Typography sx={{ fontSize: 14, color: "#4B5563" }}>
              You were listening to the course before asking the AI.
              Do you want to resume from where you left off?
            </Typography>
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button
              onClick={handleDeclineResumeAfterChat}
              sx={{ textTransform: "none", color: "#6B7280" }}
            >
              No
            </Button>
            <Button
              onClick={handleConfirmResumeAfterChat}
              variant="contained"
              sx={{
                textTransform: "none",
                background: "linear-gradient(135deg,#2563EB,#3B82F6)",
                "&:hover": {
                  background: "linear-gradient(135deg,#1D4ED8,#2563EB)",
                },
              }}
            >
              Resume
            </Button>
          </DialogActions>
        </Dialog>
      </Box >
    </>
  );
}
